import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import stylesDocCss from './documents.scss'
import Modal from 'react-modal'
import i18n from 'lib/i18n'
import { getTheLanguageCodeByAnyLanguageOnAnyLanguage, getTheClientTypeCodeByAnyLanguageOnAnyLanguage } from 'lib/helpers'
import nesProp from 'nested-property'
import { customModalStyles, customModalStylesForFillForm, escapeSpecialChars } from './documentsHelpers'
import {
    setDSWizard, upsertDSDocument, doUsersProcessFlagWatch, startUsersProcessFlagWatch, stopUsersProcessFlagWatch,
    removeUsersProcessFlagWatch, setEmailSenderExternalAttachments, fetchDsDocumentSizeList, getTemplatesSigners,
    removeTemporaryUpload
} from 'state/actions'
import * as c from 'state/constants'
import cs from 'classnames'
import {
    fetchClient, fetchOfficeData, fetchClientContract, setNotification,
    upsertDSPackage, getDsDocsAndPackages, getDSDataSets, getDSDataSet, getLists,
    executeFullDSDocumentWizardOnServer, setDSDocumentsOpenedPackage, setDSDocumentsSubModule, setAppModule,
    fetchClientOptionsDict, getDSDocumentConfig, disableBackgroundProcesses,
    createClientTarification, fetchTeamSubgroups, loadEmailServer, showEmailServerConfigModal,
    hideEmailServerConfigModal, saveEmailServer, getDSStakeholders, setClientSubModule, showLoader, hideLoader,
    getDSDocumentTemplates, setClientCreateContractState, getImageListAboutPDF, showEmailSenderAttachmentModal,
    hideEmailSenderAttachmentModal, upsertDSPackageEmailStatus, updateDSStakeholder, getOneDsPackageById,
    getDSDocumentTemplateClaimsAvailability, createLocalUploadFilesFromAttachments
} from '../../state/actions'

import CustomSelect, {
    isATarificationAndHasAMarkedTemplate, getModuleKeyOfPackage, getRemainderIntervalOptionList,
    getRemainderRepeatsOptionList, getDocumentTemplateOptionList, getLanguageOptionList, allDocumentsHasTarificationNumber,
    getDocumentsTarificationNumbersList, getTeamsOptionList, getTeamSubgroupsOptionList,
    filterTeamsForBroker, patchFormInputValuesByValueList, areThereDocumentSentToConnective,
    processBrokerWhiteListFromBrokersList, filterTemplatesForBroker, checkDocumentAfterFillIns,
    getTheListOfInvalidDocuments, isUsedAllOfStakeholders, areThereSignableDocuments, isValidDocument, getSubModuleKeyOfPackage,
    filterDocumentsByPackageId, requireSigning, requireSmsOtpSigning,
    getContractNumbersInOptionList, getEntityIdByModule, getModuleTypeByModuleKey,
    setOracleSelectedDocuments, getLanguageOptionsByTemplateId, oraDocumentAlreadyInList,
    prepareOracleDocumentsFromUploaderSelectionDocList, removeSelectedDocumentFromOraDocuments,
    getOracleIdByCursorFromPackageDSDocuments, removeDSDocumentFromThePackage, getEmailerModuleKeyByWizardModuleKey,
    getSignerAdderButtonsFlags, isMandateAndHasAMarkedTemplate
} from './DSWizardHelper'

import {
    getBrokersInOptionList, getBrokerEmailsInOptionList, packageDocumentsAttachIdCursor, getClientEmailsInOptionList,
    getNewDSDocumentInstance, findContractInClientObj, getBrokerNumberByContract, getBrokerFullInfoByNumber, getDefaultRemainderInterval,
    getDefaultRemainderRepeats, getDefaultExpirationOn, showSecondSignerFields, getDynamicFieldNameForDocTemplate,
    getDynamicFieldNameForDocLang, getDynamicFieldNameForDocTeam, getDynamicFieldNameForDocTeamName,
    getDynamicFieldNameForDocContractNumber, getDynamicFieldNameForDocTeamSubgroup,
    getDynamicFieldNameForDocContractId, getDynamicFieldNameForDocTarificationId, getDynamicFieldNameForDocTarificationNumber,
    getDynamicFieldNameForDocId, _initValueOfInput, getDynamicInputFieldByCursor,
    getPackageIdFieldName, getFlatValueListOfDsDocumentsForForm, removeSigningInputFieldsValues, getDynamicFieldNameForOracleDocumentUploadDate,
    setSigningInputFields, setFormInputsByFormValues, getClientGSMPhoneNumbers, phoneNumberValidator, getCountryPhoneCodes,
    spreadPhoneNumber, getDynamicFieldNameForTemporaryUploadId, getDynamicFieldNameForDocUploadedFileOriginalName,
    getDynamicFieldNameForDocOrigin, getDynamicFieldNameForDocOracleId, getDynamicFieldNameForDocOracleType, getDynamicFieldNameForDocOracleName,
    resetBrokerSignerRelatedFields, getBrokerGSMPhoneNumbers, validateTheForm, fieldValidation, formInputsValidation,
    removeFormInputByCursor, fetchFormValues, getDynamicFieldNameForDocSelectionTab, createNewFormInputFieldsList, getDynamicFieldNameAttachmentConnectionId,
    findItemByValueFromSelectOptions, clearPackageDSDocumentsInputsFromForm, getFormDynamicInputFieldsList, getDynamicFieldNameIsAttachment,
    synchronizePackageDSDocumentsInputsFromForm, getDynamicFieldNameForDocumentTypeIdx, getDynamicFieldNameForUploadComment, getDynamicFieldNameForSize,
    getDynamicFieldNameForEncrypted, getDynamicFieldNameForDocClaimId, getDynamicFieldNameForDocClaimNumber, getDynamicFieldNameForDocumentUploadGroupTypeId,
    packageDocumentsListUpdateByDocument, getDefaultTarificationRemainderRepeats, getDefaultTarificationRemainderInterval, getDynamicFieldNamePositionInUploadDoc,
} from './DSWizardFormControl'

import { DS_WIZARD_ERROR_CODE_GENERAL, DS_WIZARD_ERROR_CODE_NO_DOCUMENTS, DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC } from './DSWizardFormControl'

import uuidv4 from 'uuid/v4'
import moment from 'moment'
import jsonBeautify from 'json-beautify'
import EmailServerConfigDialog from '../emailSender/emailServerConfigDialog'
import AreYouSureModal from './AreYouSureModal'
import IntervalInfoPopup from './IntervalInfoPopup'
import OpenDocumentToFillModal from './OpenDocumentToFillModal'
import PopupOfSignaturePlaceholder from './handleSignaturePlaceholders/popupOfSignaturePlaceholder'
import WarningModal from './WarningModal'
import UploadLocalDocumentButton from './UploadLocalDocument/UploadLocalDocumentButton'
import OracleDocumentButton from './SelectOracleDocument/OracleDocumentButton'
import AttachmentDialog from '../emailSender/attachmentDialog'
import EmailButton from '../emailSender/emailButton'

import { upsertDSDocumentAndFetchAllData } from '../../state/actions'

// init translations
const _ = i18n('dswizard')

export const HALF_FILLED_PDF_API_URL = "/api/getHalfFilledPdfForPrint"

/**
 * Connect module to store
 */
@connect(
    (state) => {
        let brokers = nesProp.get(state, "office.brokers")
        const clientAccess = nesProp.get(state, "app.security.actions")
        const createmail = clientAccess &&
            clientAccess.filter((item) => (item.actionName == "createmail" && item.actionAllowed == "true")).length > 0
        const moduleKey = nesProp.get(state, "DSDocuments.moduleKey")
        const isOffice = moduleKey === c.DS_MODULE_OFFICE
        return {
            DSWizardOpened: nesProp.get(state, "DSDocuments.DSWizardOpened"),
            documents: nesProp.get(state, "DSDocuments.items"),
            subgroups: nesProp.get(state, "DSDocuments.subgroups"),
            moduleKey,
            brokers,
            clientDataExt: nesProp.get(state, "clients.clientData"),
            clientOptionsDict: nesProp.get(state, "client.clientOptionsDict"),
            client: nesProp.get(state, "DSDocuments.client"),
            templates: nesProp.get(state, "DSDocuments.templates"),
            DSDataSets: nesProp.get(state, "DSDocuments.DSDataSets"),
            security: nesProp.get(state, "app.security"),
            userFirstName: nesProp.get(state, "app.firstName"),
            userLastName: nesProp.get(state, "app.lastName"),
            DSDocumentOriginTypes: nesProp.get(state, "app.security.DigitalSignatureHardLists.DSDocumentOriginTypes"),
            DSDocumentsConfig: nesProp.get(state, "DSDocuments.config"),
            allContracts: state.contracts,
            emailServerConfigModalIsOpen: state.emailSender.emailServerConfigModalIsOpen,
            serverConfigIsSaved: state.emailSender.serverConfigIsSaved,
            //brokersTeamWhiteList: {'90069': ['1', '2'], '91616': [3, 4]} // TODO - fetch this values from the app login security
            brokersTeamWhiteList: processBrokerWhiteListFromBrokersList(brokers), // TODO - fetch this values from the app login security
            userId: state.app.userId,
            userPhoneNumber: state.app.number,
            UsersProcessFlag: state.UsersProcessFlag,
            createmail,
            EmailTemplateRelations: state.app.security.EmailTemplateRelations,
            isOffice,
        }
    }
)

/**
 * DSWizard class used to create dsDocuments.
 */
export default class DSWizard extends Component {
    static propTypes = {
        step: PropTypes.string,
        packageId: PropTypes.string,
        callBackOnClose: PropTypes.func,
        clientId: PropTypes.string,
        contractId: PropTypes.string,
        claimId: PropTypes.string,
        claimNumber: PropTypes.string,
        tarificationId: PropTypes.string,
        tarificationNumber: PropTypes.string,
        team: PropTypes.string,
        teamName: PropTypes.string,
        forceGetClient: PropTypes.bool,
        customModalTitle1: PropTypes.string,
        customModalTitle2: PropTypes.string,
        customModalTitle3: PropTypes.string,
        customModalDescriptionStep1: PropTypes.string,
        customModalDescriptionStep2: PropTypes.string,
        customModalDescriptionStep3: PropTypes.string,
        subModuleKey: PropTypes.string,
        stakeholders: PropTypes.array,
        moduleOptions: PropTypes.object,
        alienUserId: PropTypes.string,

        ticketId: React.PropTypes.string,
        ticketDocuments: React.PropTypes.array,
        selectedTicketDocuments: React.PropTypes.array,
        emailAttachmentTicketDocuments: React.PropTypes.array,
        brokerFromOffice: React.PropTypes.object,
    }

    /**
     * Module constructor
     *
     *  Prepare the properties for the module, but must be initialised with values by init-Step1()
     *  in case when there are already loaded the necessary values in store, the constructor can
     *  prepare few of the initial values, but idf not the init-Step1() starts a flow, what will
     *   fetch all te missing necessary values from database
     * @param {*} props
     */
    constructor(props) {
        super(props)

        this.state = {
            clientId: props.clientId
        }

        let brokers = props.brokers

        const clientId = props.clientId
        let firstSignerEmailAddressOptions = getClientEmailsInOptionList(props.clientDataExt, clientId)
        const clientGSMPhoneNumbers = getClientGSMPhoneNumbers(props.clientDataExt, clientId)

        const countryPhoneCodes = getCountryPhoneCodes()

        let remainderIntervalOptions = getRemainderIntervalOptionList(props.security)
        let remainderRepeatsOptions = getRemainderRepeatsOptionList(props.security)
        let documentTemplateOptions = getDocumentTemplateOptionList(props.templates, props.lang, props.moduleKey, props.subModuleKey, false, props.claimWizardDocType)
        let languageOptions = getLanguageOptionList()
        let teamsOptions = getTeamsOptionList(props.clientOptionsDict, props.lang)
        let teamSubgroupsOptions = getTeamSubgroupsOptionList(props.subgroups, props.lang)

        // handle package documents
        let packageDSDocuments = filterDocumentsByPackageId(props.documents, props.packageId)

        // set cursor for all documents
        let dynamicFieldIdCursor = 1
        let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)
        packageDSDocuments = attachIdResult.packageDSDocuments
        dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor

        this.state = {
            ...this.state,
            dynamicFieldIdCursor
        }

        let moduleKey = props.moduleKey || getModuleKeyOfPackage(packageDSDocuments)
        let subModuleKey = props.subModuleKey || getSubModuleKeyOfPackage(packageDSDocuments)
        const stakeholders = props.stakeholders

        // if package created get the instance
        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        // get brNr from package, other ways not working here, not exists in store,
        // and async calls not possible in constructor.
        let brokerNumber = nesProp.get(packageInstance, "brokerNumber")

        // alternative solution but if not initialised from contracts zoom, nothing found.
        if (props.contractId && props.client) {
            let theContract = findContractInClientObj(props.client, props.contractId)
            // the already saved broker number is more important than what is in the contract
            brokerNumber = brokerNumber || getBrokerNumberByContract(theContract, props.brokers, {})
        }

        // select first brokerNumber
        brokerNumber = brokerNumber ? brokerNumber : (props.brokers && props.brokers[Object.keys(props.brokers)[0]].brokerNumber)

        let brokerGSMPhoneNumbers = []
        if (props.isOffice) {
            brokerGSMPhoneNumbers = getBrokerGSMPhoneNumbers(props.brokerFromOffice.main.phoneNumbers)
        } else {
            brokerNumber ? getBrokerGSMPhoneNumbers(props.brokers[brokerNumber].main.phoneNumbers, props.userPhoneNumber) : ""
        }

        let teamIndex = nesProp.get(packageInstance, "team")
        let teamSubgroupId = nesProp.get(packageInstance, "teamSubgroup")

        teamsOptions = filterTeamsForBroker(teamsOptions, props.brokersTeamWhiteList, brokerNumber)

        let brokerEmailOptions = getBrokerEmailsInOptionList(brokerNumber, props.brokers, props.userId)

        // if this is the tarificatino we must filter the templates
        if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION) {
            documentTemplateOptions = filterTemplatesForBroker(
                documentTemplateOptions, props.brokersTeamWhiteList, brokerNumber, teamIndex, teamSubgroupId
            )
        }
        // case module is from office, use the broker from office reset broker number and change email option like foowing:
        // fisrst signer  -> emails from  broker
        // broker emails from logged in user
        if (props.isOffice) {
            brokers = [props.brokerFromOffice]
            brokerNumber = props.brokerFromOffice.brokerNumber
            firstSignerEmailAddressOptions = getBrokerEmailsInOptionList(brokerNumber, props.brokers, props.userId)

        }

        const isPrem = props.moduleKey && props.moduleKey === c.DS_MODULE_CLIENT_CONTRACT_PREM ? true : false
        const secondSigningStakeholder = props.stakeholders && props.stakeholders.find(stakeholder => stakeholder.signerNumber === '1')
        let brokerOptions = getBrokersInOptionList(brokers)

        //add stakeholder phone number to clientGSMPhoneNumbers list
        if (props.stakeholders && props.stakeholders.find(stakeholder => stakeholder.signerNumber === '0')) {
            const firstSigningStakeholderPhoneNumber = spreadPhoneNumber(props.stakeholders.find(stakeholder => stakeholder.signerNumber === '0').phoneNumber)
            clientGSMPhoneNumbers.push(firstSigningStakeholderPhoneNumber && {
                label: firstSigningStakeholderPhoneNumber.phoneNumber,
                value: firstSigningStakeholderPhoneNumber.phoneNumber,
                countryCode: firstSigningStakeholderPhoneNumber.phoneCode
            })
        }

        this.isLoaded = false

        // init state with all of the available data prepared from props and the store
        this.state = {
            ...this.state,
            step: props.step,
            packageId: props.packageId,
            clientNumber: props.client && props.client.main && props.client.main.clientNumber,
            contractId: props.contractId,
            tarificationId: props.tarificationId,
            tarificationNumber: props.tarificationNumber,
            claimId: props.claimId,
            claimNumber: props.claimNumber,

            packageDSDocuments: packageDSDocuments || [],

            isValidTheForm: { isValid: false },

            firstSignerEmailAddressOptions,
            clientGSMPhoneNumbers,
            brokerGSMPhoneNumbers,
            countryPhoneCodes,
            brokerOptions,
            brokerEmailOptions,
            remainderIntervalOptions,
            remainderRepeatsOptions,

            dynamicFieldIdCursor,
            documentTemplateOptions,
            languageOptions,
            teamsOptions,
            teamSubgroupsOptions,

            formInputs: {},

            //isLoaded: false,
            isOpenIntervalInfo: false,
            isOpenTicketIntervalInfo: false,

            moduleKey,
            subModuleKey,
            clientOptionsDict: props.clientOptionsDict,
            warningModalOpen: false,
            isOpenAreYouSure: false,
            forceGetClientAffected: false,

            changeTemplateModalIsOpen: true,
            changeTemplateModalData: {},
            contractDetails: null,
            fillTemplateErrors: false,
            fillTemplateErrorsModalOpen: false,
            documentsAreNotValidModalOpen: false,
            areNonUsedStakeholders: false,
            stakeholderUsageMap: {},
            printNotValidModalOpen: false,
            isPrem,
            showSecondSigner: secondSigningStakeholder ? true : false,
            stakeholders,
            selectedTicketRelatedOraDocuments: props.selectedTicketDocuments,
            emailAttachmentsTicketRelatedOraDocuments: props.emailAttachmentTicketDocuments,
            selectedClaimRelatedOraDocuments: [], selectedContractRelatedOraDocuments: [], selectedTarificationRelatedOraDocuments: [], selectedClientRelatedOraDocuments: [],
            moduleOptions: props.moduleOptions,
            invitationEmailSent: false,
            // moduleKeyToSetForEmailer: nesProp.get(props, "EmailTemplateRelations.EmailTemplateModules. mifid.value") || false,
            forceCloseDatepicker: false,
            signerAvailabilityOfTemplates: null,
            haveAvailableClaimTemplate: false,

            isItExistFirstSignerPlaceholder: false,
            isItExistSecondSignerPlaceholder: false,
            isItExistBrokerSignerPlaceholder: false,

            initiatorEmailAddressesFromTemplates: [],
        }
    }

    /**
     * Start loading anything.
     * Not a state driven status flag, because not required a rerender in case of change
     */
    startLoading() {
        this.isLoaded = false
    }

    /**
     * Stop loading anything.
     * Not a state driven status flag, because not required a rerender in case of change
     * @param {*} forceUpdate - can be enforced optionally a rerender but very rare to be necessary.
     */
    stopLoading(forceUpdate = false) {
        this.isLoaded = true

        if (forceUpdate) {
            this.forceUpdate()
        }
    }

    componentWillMount() {
        const { dispatch, clientOptionsDict, isOffice } = this.props

        if (!isOffice && (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0)) {
            dispatch(fetchClientOptionsDict())
                .then(() => {
                    this.setState({ clientOptionsDict: this.props.clientOptionsDict })
                })
        }
    }

    /**
     * Component did mount hook. Check and load all the dependency values, init related values.
     */
    async componentDidMount() {
        let { formInputs, clientOptionsDict } = this.state
        let { dispatch, isOffice } = this.props
        // fist make sure there are loaded the dictionaries from oracle also
        if (!isOffice && (!this.props.clientOptionsDict || Object.keys(this.props.clientOptionsDict).length == 0)) {

            try {
                clientOptionsDict = await dispatch(fetchClientOptionsDict())
            } catch (err) {
                // can not get the dictionaries from oracle, but let the initialisation to go forward
                // notify the user about error
                console.error("Error loading client options dictionary, ", err)
                dispatch(setNotification(_('wizardError') + " " + JSON.stringify(err), 'error'))
                return err
            }

            clientOptionsDict = this.props.clientOptionsDict

            this.setState({ clientOptionsDict })
        }

        // display loader for multi step operation
        dispatch(showLoader())

        this.startLoading()

        try {
            formInputs = await this.initStep1(formInputs)
            this.setState({ formInputs })
        } catch (err) {
            console.error(err)
        }

        this.stopLoading()

        dispatch(hideLoader())
        return
    }

    /**
     * Component did mount hook. Check and load all the dependency values, init related values.
     * @param {object} formInputs list of inputs of the form, what is constructed by this function and returned
     * @returns {object}
     */
    initStep1 = async (formInputs) => {
        const { dispatch, brokers, clientDataExt, client, templates, forceGetClient,
            DSDocumentsConfig, lang, brokersTeamWhiteList, subgroups, userId, DSDocumentOriginTypes,
            selectedTicketDocuments, alienUserId, userPhoneNumber, claimId, claimNumber, isOffice, claimWizardDocType } = this.props
        let { brokerOptions, brokerEmailOptions, firstSignerEmailAddressOptions, clientId, packageId, clientGSMPhoneNumbers, brokerGSMPhoneNumbers,
            forceGetClientAffected, moduleKey, subModuleKey, teamSubgroupsOptions, dynamicFieldIdCursor,
            teamsOptions, stakeholders, clientNumber, contractId, isValidTheForm, clientOptionsDict, isPrem,
            languageOptions, documentTemplateOptions, tarificationId, tarificationNumber, contractDetails,
            signerAvailabilityOfTemplates, haveAvailableClaimTemplate } = this.state

        // +++++++++++++++ LOAD DICTIONARIES if not already loaded
        if (!this.props.clientOptionsDict || Object.keys(this.props.clientOptionsDict).length == 0) {
            clientOptionsDict = await dispatch(fetchClientOptionsDict())
        }

        // make sure if it loaded to state
        if (!clientOptionsDict || Object.keys(clientOptionsDict).length == 0) {
            clientOptionsDict = this.props.clientOptionsDict
        }
        // -------------------------------------


        // +++++++++++++++ LOAD CONFIG if not already loaded
        if (!DSDocumentsConfig || Object.keys(DSDocumentsConfig).length === 0) {
            await dispatch(getDSDocumentConfig(c.DIGITAL_SIGNATURE_SETTINGS))
        }
        // -------------------------------------


        // +++++++++++++++ CLAIMS PREPARATION (just in claim case)
        if (moduleKey === c.DS_MODULE_CLIENT_CLAIMS) {
            let resultOFClaimAvailable = await dispatch(getDSDocumentTemplateClaimsAvailability())
            // {claimsAvailable: boolean, count: number}
            haveAvailableClaimTemplate = resultOFClaimAvailable.claimsAvailable
        }
        // -------------------------------------



        // +++++++++++++++ LOAD DOCUMENT-S and templates
        //must reload every time when init step1 to be up to date in order to improve dswizard loading from Prem should do this only when there is a package id otherwise load only templates
        let documentTemplates
        if (packageId && moduleKey != 'DS_MODULE_CLIENT_CONTRACT_PREM') {
            let getDsDocumentsAndPackagesResult
            if (alienUserId) {
                getDsDocumentsAndPackagesResult = await dispatch(getDsDocsAndPackages(false, false, alienUserId, packageId, true))
            } else {
                getDsDocumentsAndPackagesResult = await dispatch(getDsDocsAndPackages(false, false, null, null, true))
            }

            documentTemplates = getDsDocumentsAndPackagesResult.templates
        }
        // PREM CASE: (not the best solution, but find all template to get the PREM template. TODO optimise it.)
        else {
            //get only the templates options
            documentTemplates = await dispatch(getDSDocumentTemplates())
        }

        // Get the templates availability
        if (documentTemplates) {
            let templateIds = documentTemplates.map((oneTmplt) => {
                return oneTmplt._id
            })

            signerAvailabilityOfTemplates = await dispatch(getTemplatesSigners(templateIds))

        }

        documentTemplateOptions = getDocumentTemplateOptionList(documentTemplates, lang, moduleKey, subModuleKey, false, claimWizardDocType)
        // -------------------------------------


        // +++++++++++++++ get DOCUMENTS from store by package ID
        let packageDSDocuments = filterDocumentsByPackageId(this.props.documents, packageId)

        // fill up with cursor values
        let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)
        packageDSDocuments = attachIdResult.packageDSDocuments
        dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor
        // -------------------------------------


        formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)

        // if there are documents, then try to check those come from tickets ofr attachment selector
        let selectedListsList = {}
        if (packageDSDocuments && packageDSDocuments.length > 0) {
            selectedListsList = setOracleSelectedDocuments(packageDSDocuments)
        }
        // -------------------------------------


        // +++++++++++++++ FIND PACKAGE instance using the first document from the package
        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }
        // -------------------------------------


        // +++++++++++++++ FIND A BROKER NUMBER
        let brokerNumber = nesProp.get(formInputs, "brokerNumber.value") ||
            nesProp.get(packageInstance, "brokerNumber") || (brokers && brokers[Object.keys(brokers)[0]].brokerNumber) || ""
        // getBrokerNumberByContract(theContract, brokers, contractDetails)
        // -------------------------------------


        // +++++++++++++++ LOAD CONTRACT IF CONTRACT ID EXISTS
        // when no brokerNumber is predicted by the package we should use from the contract is exists
        // we do this only in case when not exists already saved brokerNumber by user selection, and
        // only when there exists a contract, else let the first broker from selection list what was set on form initialisation
        if (!nesProp.get(packageInstance, "brokerNumber") && contractId) {
            // if the contract details are not loaded, then must be load it, than keep it in state, to do not load again
            if (!contractDetails) {
                let detailedContractInfo = await dispatch(fetchClientContract(contractId))
                contractDetails = nesProp.get(detailedContractInfo, "response.contractDetails")
            }

            // set the newly determined broker number by contract, this was asked: BEWB-471
            brokerNumber = contractDetails.brokerNumber
            // this broker number will be put in the form-Inputs values in the following code lower
        }


        // +++++++++++++++ TEMPLATE OPTION LIST filtering
        // determine the list of used templates, for this module on the selected language
        let teamIndex = nesProp.get(formInputs, "team.value")
        let teamName = nesProp.get(formInputs, "teamName.value")
        let teamSubgroupId = nesProp.get(formInputs, "teamSubgroup.value")

        // if this is the tarification we must filter the templates again by broker and teams etc.
        if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION) {

            // when the pacakge already exists, and the state  formInpust is not prepared yet, then we must use the packageInstance values
            // this affect the values only on first reload, when the package is already created, and the formInputs not yet prepared
            if (packageId && packageInstance) {
                teamIndex = teamIndex || nesProp.get(packageInstance, "team") || ""
                teamName = teamName || nesProp.get(packageInstance, "teamName") || ""
                teamSubgroupId = teamSubgroupId || nesProp.get(packageInstance, "teamSubgroup") || ""
            }

            // filter the unecessary or restricted templates
            documentTemplateOptions = filterTemplatesForBroker(
                documentTemplateOptions, brokersTeamWhiteList, brokerNumber, teamIndex, teamSubgroupId
            )
        }
        // -------------------------------------


        // +++++++++++++++ LOAD BROKER data
        // prepare lists for form dropdown inputs (broker emails, brokers)
        if ((!brokerOptions || brokerOptions.length === 0) && !isOffice) {
            let brokerLoader = await dispatch(fetchOfficeData())
            // must get the office data for all informations for variables
            brokerOptions = getBrokersInOptionList(this.props.brokers)
            brokerGSMPhoneNumbers = getBrokerGSMPhoneNumbers(brokers[brokerNumber].main.phoneNumbers, userPhoneNumber)
        }

        // filter the new list by broker number and put it in to state
        brokerEmailOptions = getBrokerEmailsInOptionList(brokerNumber, brokers, userId)
        // ------------------------------------------


        // +++++++++++++++ generate TEAM OPTIONS
        // determine the list of teams using the whitelist of the broker
        teamsOptions = getTeamsOptionList(clientOptionsDict, lang)
        teamsOptions = filterTeamsForBroker(teamsOptions, brokersTeamWhiteList, brokerNumber)
        // ------------------------------------------


        // +++++++++++++++  LOAD CLIENT, and CONTRACTS in the same request
        //check prop data is also a way to do a fetch: if (!clientDataExt || !nesProp.get(clientDataExt, clientId + ".main")) {
        if (!isOffice && ((forceGetClient && !forceGetClientAffected) || (!firstSignerEmailAddressOptions && clientId) || firstSignerEmailAddressOptions.length === 0 ||
            !clientGSMPhoneNumbers || clientGSMPhoneNumbers.length === 0 || (client && (client.clientId !== clientId)))) {

            // API call to get client information
            await dispatch(fetchClient(clientId))

            // process client result
            firstSignerEmailAddressOptions = getClientEmailsInOptionList(clientDataExt, clientId)
            clientGSMPhoneNumbers = getClientGSMPhoneNumbers(clientDataExt, clientId)
            clientNumber = client && client.main.clientNumber || ""
            forceGetClientAffected = true
        }
        // ------------------------------------------

        // +++++++++++++++ LOAD SUBGROUPS
        //prevent unnecessary fetch when is claim wizard
        const isClaimWizard = moduleKey === c.DS_MODULE_CLAIM_WIZARD

        let resultOfGetTeamSubgroups = subgroups
        if (!isClaimWizard && (!teamSubgroupsOptions || teamSubgroupsOptions.length === 0)) {
            // must get the office data for all informations for variables
            resultOfGetTeamSubgroups = await dispatch(fetchTeamSubgroups())
        }
        if (resultOfGetTeamSubgroups) {
            teamSubgroupsOptions = getTeamSubgroupsOptionList(resultOfGetTeamSubgroups, lang)
        }
        // ------------------------------------------


        // +++++++++++++++ HANDLE CONTRACT ID
        // loaded data preprocessed, can continue the flow
        if (contractId) {
            // get the two necessary value about the current contract, to init the contract dropdown and the broker data related the contract
            let theContract = findContractInClientObj(client, contractId)
            let contractNumber = nesProp.get(theContract, "contractMain.contractNumber")

            // force the change of the contract input to use set the Broker details in other inputs
            formInputs = await this.handleChangeContractNumber(contractId, contractNumber, formInputs)
        }
        // ---------------------------------


        // +++++++++++++++ determine CLIENTLANGUAGE for new document
        let clientLanguageWord = nesProp.get(clientDataExt, clientId + ".detail.language")
        let clientLanguage
        if (clientOptionsDict && clientLanguageWord) {
            clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguageWord, clientOptionsDict)
        }
        clientLanguage = nesProp.get(formInputs, "clientLanguage.value") || clientLanguage
        // ------------------------------------


        // +++++++++++++++ DOCUMENTS FROM TICKETS
        // add ticket documents to wizard
        if (selectedTicketDocuments && !packageId) {
            // iterate ticked documents and add them to the package
            for (let i = 0; i < selectedTicketDocuments.length; i++) {
                let result = await this.createDSDocumentForPackage(
                    packageDSDocuments,
                    clientLanguage,
                    { team: teamIndex, teamName, teamSubgroup: teamSubgroupId },
                    dynamicFieldIdCursor,
                    languageOptions,
                    documentTemplateOptions,
                    { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem },
                    null,
                    selectedTicketDocuments[i]
                )

                // merge on document inputs
                formInputs = {
                    ...formInputs,
                    ...result.documentFormInputs
                }

                // update the list of documents and the cursor
                packageDSDocuments = result.packageDSDocuments
                dynamicFieldIdCursor = result.dynamicFieldIdCursor
            }
        }
        // ---------------------------------------------------


        // ++++ package exist reload stakeholders ++++++
        if (packageId && packageDSDocuments) {
            let packageInstance = {}
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
            stakeholders = await dispatch(getDSStakeholders(packageInstance.stakeholders))
        }
        // ----------------------------------------------------

        // +++++ all DOCUMENTS are LOADED/CREATED/ADDED
        // +++++ generate formInputs for the packageDSDocuments
        let formInitialValues = this.getFormInitialValues(
            packageDSDocuments,
            brokerNumber,
            stakeholders,
            clientId,
            packageId,
            clientOptionsDict,
            contractId
        )

        let newFormInputs = createNewFormInputFieldsList(
            formInitialValues,
            packageDSDocuments,
            DSDocumentOriginTypes,
            moduleKey,
            subModuleKey,
            requireSigning(packageDSDocuments, DSDocumentOriginTypes),
            stakeholders,
            requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes),
            isOffice
        )

        // the new set form input must overwrite by old ones, to keep the
        // correct values, and extend the input list with the document fields
        formInputs = {
            ...newFormInputs,
            ...formInputs
        }
        // ------------------------------------------


        // +++++++++++ POST PROCESSING packageDSDocuments and produce final FORM INPUTS
        // +++++++++++ AFTER ALL OPERATION ON "packageDSDocuments" we can add/remove the conditional fields and validation
        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey, packageId)

        formInputs = formInputsValidation(formInputs)
        isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, false)
        // -------------------------------------------------------------------------------------------

        // +++++++++++++  PREM initial handling
        // CREATE PACKAGE FOR PREM CONTRACT ON FIRST CONTACT
        // in case when we creating a new package, and it is prem, must added on document, with the PREM template
        // BEWB - 706 - update we can have generated documents in PREM module, one document flagged as requiredOnPrem
        //is mandatory by default and can't be deleted
        let isItTarificationModule = (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION)
        let isTarificationSubmodule = subModuleKey === c.DS_MODULE_CLIENT_TARIFICATION
        if ((isPrem || (isItTarificationModule && !isTarificationSubmodule)) && !packageId) {

            // +++++++++++ add a single mandate document
            const requiredOnPrem = getDocumentTemplateOptionList(documentTemplates, lang, moduleKey, subModuleKey, true, claimWizardDocType)
            let createDefaultDocResult = await this.createDSDocumentForPackage(
                packageDSDocuments,
                clientLanguage,
                { team: teamIndex, teamName, teamSubgroup: teamSubgroupId },
                dynamicFieldIdCursor,
                languageOptions,
                requiredOnPrem,
                { contractId, tarificationId, tarificationNumber, moduleKey, subModuleKey, isPrem, isItTarificationModule },
                null,
                null
            )

            // merge on document inputs
            formInputs = {
                ...formInputs,
                ...createDefaultDocResult.documentFormInputs
            }

            // update the list of documents and the cursor
            packageDSDocuments = createDefaultDocResult.packageDSDocuments
            dynamicFieldIdCursor = createDefaultDocResult.dynamicFieldIdCursor
            // ---------------------------


            // get the form values from the formInputs object,
            // because the rendering is not done
            // to get values from inputs by ref
            let rawFormValuesData = {}
            for (const [key, value] of Object.entries(formInputs)) {
                if (value.value !== null) {
                    rawFormValuesData[key] = value.value
                }
            }

            //load properties for first contact
            let theContract = findContractInClientObj(client, contractId)

            const upsertArguments = {
                ...rawFormValuesData,
                clientId,
                clientNumber,
                contractId: nesProp.get(theContract, 'contractMain.contractId'),
                contractNumber: nesProp.get(theContract, "contractMain.contractNumber"),
                uploadedOnModule: moduleKey,
                subModuleKey
            }

            const newPremPackage = await dispatch(upsertDSPackage(upsertArguments))
            packageId = newPremPackage._id

            // Notice I.
            // important to find the documents from this.props, do not use the destructured from
            // the begin of the function, because the dispatch update the store references, and
            // that object is disconnected with old values in the moment of destructuring
            // Notice II.
            // This reloaded package, will overwrite the packageDSDocuments, so must keep in
            // sync with the formInputs
            packageDSDocuments = filterDocumentsByPackageId(this.props.documents, packageId)

            // ++++ reset dynamicFieldIdCursor because new package created and the documents are reloaded
            dynamicFieldIdCursor = 1
            // ----

            // add local ID to manage the document in browser
            let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)
            packageDSDocuments = attachIdResult.packageDSDocuments
            dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor // get the increased value

            // don't need to synch because the hole form will be regenerated in next lines
            // formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)

            stakeholders = await dispatch(getDSStakeholders(newPremPackage.stakeholders))

            // ++++++++++++ RESET THE FORM INPUTS by documents because the new package ++++++++++++++++++
            let formInitialValues = this.getFormInitialValues(
                packageDSDocuments,
                brokerNumber,
                stakeholders,
                clientId,
                packageId,
                clientOptionsDict,
                contractId
            )

            formInputs = createNewFormInputFieldsList(
                formInitialValues,
                packageDSDocuments,
                this.props.DSDocumentOriginTypes,
                this.props.moduleKey,
                this.props.subModuleKey,
                requireSigning(packageDSDocuments, this.props.DSDocumentOriginTypes),
                stakeholders,
                requireSmsOtpSigning(packageDSDocuments, this.props.DSDocumentOriginTypes),
                isOffice
            )

            formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey, packageId)
            formInputs = formInputsValidation(formInputs)
            isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, false)
        }
        // ----------------------- END of PREM section

        // +++++++++++++++++++++ claimWizard initial handling
        // add a single designated document for claimWizard without creating a package
        if (isClaimWizard && !packageId) {
            const requiredOnClaimWizard = getDocumentTemplateOptionList(documentTemplates, lang, moduleKey, subModuleKey, true, claimWizardDocType)
            let createDefaultDocResult = await this.createDSDocumentForPackage(
                packageDSDocuments,
                clientLanguage,
                { team: teamIndex, teamName, teamSubgroup: teamSubgroupId },
                dynamicFieldIdCursor,
                languageOptions,
                requiredOnClaimWizard,
                { claimId, claimNumber, moduleKey, subModuleKey },
                null,
                null
            )

            // merge on document inputs
            formInputs = {
                ...formInputs,
                ...createDefaultDocResult.documentFormInputs
            }

            // update the list of documents and the cursor
            packageDSDocuments = createDefaultDocResult.packageDSDocuments
            dynamicFieldIdCursor = createDefaultDocResult.dynamicFieldIdCursor
            // ---------------------------


            // get the form values from the formInputs object,
            // because the rendering is not done
            // to get values from inputs by ref
            let rawFormValuesData = {}
            for (const [key, value] of Object.entries(formInputs)) {
                if (value.value !== null) {
                    rawFormValuesData[key] = value.value
                }
            }
            // ++++++++++++ RESET THE FORM INPUTS by documents because the new package ++++++++++++++++++
            let formInitialValues = this.getFormInitialValues(
                packageDSDocuments,
                brokerNumber,
                stakeholders,
                clientId,
                packageId,
                clientOptionsDict,
                contractId
            )

            formInputs = createNewFormInputFieldsList(
                formInitialValues,
                packageDSDocuments,
                this.props.DSDocumentOriginTypes,
                this.props.moduleKey,
                this.props.subModuleKey,
                requireSigning(packageDSDocuments, this.props.DSDocumentOriginTypes),
                stakeholders,
                requireSmsOtpSigning(packageDSDocuments, this.props.DSDocumentOriginTypes),
                isOffice
            )

            formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey, packageId)
            formInputs = formInputsValidation(formInputs)
            isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, false)
        }

        // +++++++++++++++++++++ DETERMINE THE flags for showing signer buttons
        // ++++++++++++ start handle enabled signers list ++++++++++++++
        let addSignersButtonFlags = getSignerAdderButtonsFlags(packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates)
        let isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder
        let isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder
        let isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder
        // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
        // those properties, so don't do that
        //---------------- end handle enabled signers list



        // at the end set the state
        this.setState({
            teamSubgroupsOptions,
            packageDSDocuments,
            formInputs,
            isValidTheForm,
            dynamicFieldIdCursor,
            packageId,
            clientOptionsDict,
            brokerOptions,
            brokerEmailOptions,
            brokerGSMPhoneNumbers,
            moduleKey,
            subModuleKey,
            documentTemplateOptions,
            teamsOptions,
            firstSignerEmailAddressOptions,
            clientGSMPhoneNumbers,
            clientNumber,
            forceGetClientAffected,
            stakeholders,
            contractDetails,
            signerAvailabilityOfTemplates,
            haveAvailableClaimTemplate,
            isItExistFirstSignerPlaceholder,
            isItExistSecondSignerPlaceholder,
            isItExistBrokerSignerPlaceholder,
            ...selectedListsList // spread oracle document lists in state
        })

        return formInputs
    }



    /**
     * This function prepare and return a bunch of predefined data for the form inputs indexed by form input ref names
     * When wizard is opened from office module there is no client there fore no client data to set
     * @param {*} packageDSDocuments
     * @param {*} brokerNumberFromForm
     * @param {*} stakeholders
     * @param {*} clientId
     * @param {*} packageId
     * @param {*} clientOptionsDict
     * @param {*} contractId
     * @returns
     */
    getFormInitialValues(packageDSDocuments, brokerNumberFromForm, stakeholders, clientId, packageId, clientOptionsDict, contractId) {
        const { clientDataExt, moduleKeyFromProps, lang, templates, brokersTeamWhiteList, subModuleKey, client,
            brokers, security, DSDocumentsConfig, userFirstName, userLastName, claimId, claimNumber, userPhoneNumber,
            isOffice, brokerFromOffice, userId, claimWizardDocType } = this.props

        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        clientId = clientId || this.props.clientId
        packageId = packageId || this.props.packageId

        clientOptionsDict = clientOptionsDict || this.props.clientOptionsDict

        // +++++ determine clientlanguage and language word
        let clientLanguageWord = nesProp.get(clientDataExt, clientId + ".detail.language")
        let clientLanguage = ''
        if (clientOptionsDict && clientLanguageWord) {
            clientLanguage = getTheLanguageCodeByAnyLanguageOnAnyLanguage(clientLanguageWord, clientOptionsDict)
        }
        //hard coded the language for broker until we improve this module
        if (isOffice) {
            clientLanguage = brokerFromOffice.main.language
        }
        console.log('broker from office ::: ', brokerFromOffice);
        console.log('is office ::: ', isOffice);
        console.log('client language :::: ', clientLanguage)
        
        
        // ------------------------------------

        let clientTypeCode = isOffice ? '' : c.CLIENT_TYPE_PERSON // CLIENT_TYPE_COMPANY
        let clientTypeWord = nesProp.get(clientDataExt, clientId + ".main.clientType")
        if (clientOptionsDict && clientTypeWord) {
            clientTypeCode = getTheClientTypeCodeByAnyLanguageOnAnyLanguage(clientTypeWord, clientOptionsDict)
        }

        let clientFirstName = nesProp.get(clientDataExt, clientId + ".main.firstName") || ""
        let clientLastName = nesProp.get(clientDataExt, clientId + ".main.lastName") || ""
        let clientBirthDate = nesProp.get(clientDataExt, clientId + ".main.dateOfBirth")

        let clientName = [clientFirstName, clientLastName].join(" ")

        let clientEmailAddresses = getClientEmailsInOptionList(clientDataExt, clientId)
        let clientEmailAddress = nesProp.get(clientEmailAddresses, "0.value") // get the default email-address (ordered - first is default)

        let clientGSMPhoneNumbers = getClientGSMPhoneNumbers(clientDataExt, clientId)
        let clientPhoneNumber = nesProp.get(clientGSMPhoneNumbers, "0.value")
        let clientPhoneNumberCountryCode = nesProp.get(clientGSMPhoneNumbers, "0.countryCode") || '+32'

        contractId = contractId || this.props.contractId
        let theContract = findContractInClientObj(client, contractId)

        let packageBrokerNumber = brokerNumberFromForm || nesProp.get(packageInstance, "brokerNumber")
        let teamIndex = nesProp.get(packageInstance, "team")
        let teamSubgroupId = nesProp.get(packageInstance, "teamSubgroup")

        const contractDetails = this.state && this.state.contractDetails || null
        let brokerNumber = packageBrokerNumber || getBrokerNumberByContract(theContract, brokers, contractDetails) // broker number by contract or default

        //handle broker number if the module is fro office
        if (isOffice) {
            brokerNumber = brokerFromOffice.brokerNumber
        }

        let brokerInfo = getBrokerFullInfoByNumber(brokerNumber, brokers) // broker number by contract or default
        let brokerEmailAddress = ''

        if (!isOffice) {
            brokerEmailAddress = nesProp.get(brokerInfo, "main.emails.0")
        }

        let brokerName = nesProp.get(brokerInfo, "main.name")

        let brokerSignerFirstName = userFirstName
        let brokerSignerLastName = userLastName
        //let brokerSignerBirthDate = moment().subtract(25, 'years').format("YYYY/MM/DD") // pick a random date

        // let brokerNameParts = String(brokerName).split(" ")
        // let brokerSignerFirstName = nesProp.get(brokerNameParts , "0")
        // let brokerSignerLastName = brokerNameParts.slice(1).join(" ")

        let brokerGSMPhoneNumbers
        if (isOffice) {
            brokerGSMPhoneNumbers = getBrokerGSMPhoneNumbers(brokerFromOffice.main.phoneNumbers)
            clientEmailAddresses = getBrokerEmailsInOptionList(brokerNumber, brokers, userId)

            clientPhoneNumber = nesProp.get(brokerGSMPhoneNumbers, "0.value")
            clientEmailAddress = nesProp.get(clientEmailAddresses, "0.value") // get the default email-address (ordered - first is default)

        } else {
            brokerGSMPhoneNumbers = getBrokerGSMPhoneNumbers(brokerInfo.main.phoneNumbers, userPhoneNumber)
        }

        let brokerPhoneNumber = nesProp.get(brokerGSMPhoneNumbers, "0.value")
        let brokerPhoneNumberCountryCode = nesProp.get(brokerGSMPhoneNumbers, "0.countryCode") || '+32'

        let remainderInterval = getDefaultRemainderInterval(security, DSDocumentsConfig)
        let remainderRepeats = getDefaultRemainderRepeats(security, DSDocumentsConfig)
        let remainderTicketInterval = getDefaultTarificationRemainderInterval(security, DSDocumentsConfig)
        let remainderTicketRepeats = getDefaultTarificationRemainderRepeats(security, DSDocumentsConfig)
        let expirationOn = getDefaultExpirationOn(DSDocumentsConfig)

        // recalculate the template options by broker white lists and template white list match
        const moduleKeyFromState = nesProp.get(this, "state.moduleKey")
        const subModuleKeyFromState = nesProp.get(this, "state.subModuleKey")
        let moduleKey = moduleKeyFromState || moduleKeyFromProps
        let subModuleKeyCalculated = subModuleKeyFromState || subModuleKey

        let documentTemplateOptions = getDocumentTemplateOptionList(templates, lang, moduleKey, subModuleKeyCalculated, false, claimWizardDocType)

        if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKeyCalculated !== c.DS_MODULE_CLIENT_TARIFICATION) {
            documentTemplateOptions = filterTemplatesForBroker(
                documentTemplateOptions, brokersTeamWhiteList, brokerNumber, teamIndex, teamSubgroupId
            )
        }

        // generate dynamic list of the fields for documents
        let flatDocumentsValueList = getFlatValueListOfDsDocumentsForForm(packageDSDocuments, documentTemplateOptions)

        let packageIdFieldName = getPackageIdFieldName()
        let tarificationId = nesProp.get(this, "state.tarificationId") || this.props.tarificationId
        let tarificationNumber = nesProp.get(this, "state.tarificationNumber") || this.props.tarificationNumber

        const firstSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerNumber === '0')
        const secondSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerNumber === '1')
        const brokerSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerType === "BROKER")

        let firstSigningSpreadPhoneNumberObject = nesProp.get(firstSigningStakeholder, "phoneNumber") ?
            spreadPhoneNumber(nesProp.get(firstSigningStakeholder, "phoneNumber")) : null
        let secondSigningSpreadPhoneNumberObject = nesProp.get(secondSigningStakeholder, "phoneNumber") ?
            spreadPhoneNumber(nesProp.get(secondSigningStakeholder, "phoneNumber")) : null
        let brokerSigningSpreadPhoneNumberObject = nesProp.get(brokerSigningStakeholder, "phoneNumber") ?
            spreadPhoneNumber(nesProp.get(brokerSigningStakeholder, "phoneNumber")) : {
                phoneNumber: brokerPhoneNumber,
                phoneCode: brokerPhoneNumberCountryCode
            }
        let firstSignerLastName = firstSigningStakeholder && firstSigningStakeholder.lastName || clientLastName
        let firstSignerFirstName = firstSigningStakeholder && firstSigningStakeholder.firstName || clientFirstName

        if (!firstSignerFirstName && isOffice && brokerFromOffice.main.legalType === "1") {
            const spreadName = brokerFromOffice.main.name.split(' ')
            firstSignerLastName = spreadName[0]
            spreadName.shift()
            firstSignerFirstName = spreadName.join(' ')
        }

        let initialValues = {
            [packageIdFieldName]: nesProp.get(packageInstance, "_id") || packageId,
            "clientEmailAddress": nesProp.get(packageInstance, "clientEmailAddress") || clientEmailAddress,
            "clientName": nesProp.get(packageInstance, "clientName") || clientName,
            "clientTypeCode": nesProp.get(packageInstance, "clientTypeCode") || clientTypeCode,
            "contractNumber": nesProp.get(packageInstance, "contractNumber") || nesProp.get(theContract, "contractMain.contractNumber"),
            "brokerNumber": nesProp.get(packageInstance, "brokerNumber") || brokerNumber,
            "brokerEmailAddress": nesProp.get(packageInstance, "brokerEmailAddress") || brokerEmailAddress,
            "brokerName": nesProp.get(packageInstance, "brokerName") || brokerName,
            "team": nesProp.get(packageInstance, "team") || "",
            "teamName": nesProp.get(packageInstance, "teamName") || "",
            "teamSubgroup": nesProp.get(packageInstance, "teamSubgroup") || "",
            "tarificationId": nesProp.get(packageInstance, "tarificationId") || tarificationId || "",
            "tarificationNumber": nesProp.get(packageInstance, "tarificationNumber") || tarificationNumber || "",
            "remainderInterval": nesProp.get(packageInstance, "remainderInterval") || remainderInterval,
            "remainderRepeats": nesProp.get(packageInstance, "remainderRepeats") || remainderRepeats,
            "remainderTicketInterval": nesProp.get(packageInstance, "remainderTicketInterval") || remainderTicketInterval,
            "remainderTicketRepeats": nesProp.get(packageInstance, "remainderTicketRepeats") || remainderTicketRepeats,
            "expirationOn": nesProp.get(packageInstance, "expirationOn") || expirationOn,

            "clientFirstName": nesProp.get(packageInstance, "clientFirstName") || clientFirstName,
            "clientLastName": nesProp.get(packageInstance, "clientLastName") || clientLastName,
            "clientBirthDate": nesProp.get(packageInstance, "clientBirthDate") || clientBirthDate,
            "clientLanguageWord": clientLanguageWord,
            "clientLanguage": nesProp.get(packageInstance, "clientLanguage") || clientLanguage,
            "status": nesProp.get(packageInstance, "status") || 'initialized',

            "firstSignerFirstName": firstSignerFirstName,
            "firstSignerLastName": firstSignerLastName,
            "firstSignerPhoneNumber": firstSigningSpreadPhoneNumberObject ? firstSigningSpreadPhoneNumberObject.phoneNumber : clientPhoneNumber,
            "firstSignerCountryPhoneCode": firstSigningSpreadPhoneNumberObject ?
                firstSigningSpreadPhoneNumberObject.phoneCode : clientPhoneNumberCountryCode,

            "secondSignerLanguage": secondSigningStakeholder && secondSigningStakeholder.language || "",
            "secondSignerEmailAddress": secondSigningStakeholder && secondSigningStakeholder.email || "",
            "secondSignerFirstName": secondSigningStakeholder && secondSigningStakeholder.firstName || "",
            "secondSignerLastName": secondSigningStakeholder && secondSigningStakeholder.lastName || "",
            "secondSignerPhoneNumber": secondSigningSpreadPhoneNumberObject ? secondSigningSpreadPhoneNumberObject.phoneNumber : "",
            "secondSignerCountryPhoneCode": secondSigningSpreadPhoneNumberObject ? secondSigningSpreadPhoneNumberObject.phoneCode : "",

            "brokerSignerFirstName": brokerSigningStakeholder && brokerSigningStakeholder.firstName || brokerSignerFirstName,
            "brokerSignerLastName": brokerSigningStakeholder && brokerSigningStakeholder.lastName || brokerSignerLastName,
            //"brokerSignerBirthDate": brokerSigningStakeholder && brokerSigningStakeholder.birthDate || brokerSignerBirthDate,
            "brokerSignerPhoneNumber": brokerSigningSpreadPhoneNumberObject ?
                brokerSigningSpreadPhoneNumberObject.phoneNumber : brokerPhoneNumber,
            "brokerSignerCountryPhoneCode": brokerSigningSpreadPhoneNumberObject ?
                brokerSigningSpreadPhoneNumberObject.phoneCode : brokerPhoneNumberCountryCode,

            "claimId": claimId,
            "claimNumber": claimNumber,

            //add the dynamic fields also, those must be managed when form is changed
            ...flatDocumentsValueList
        }
        return initialValues
    }

    /**
     * Change one input value in state, validate also.
     * @param {*} value
     * @param {*} formFieldName
     * @param {*} forceTouch
     * @param {*} callback
     */
    onChangeFormInput(value, formFieldName, forceTouch = null, callback = () => { }, forceFormInputs = null) {
        const { formInputs, packageDSDocuments } = this.state
        const { DSDocumentOriginTypes } = this.props
        let newFormInputs = forceFormInputs || formInputs

        //get the object from state to be able to set the validity value in it.
        let formField = newFormInputs[formFieldName]

        // handle touch input
        if (formField.value !== value && (forceTouch === null)) {
            formField.touched = true
        }

        if (forceTouch !== null) {
            formField.touched = forceTouch
        }

        // set the value
        formField.value = value



        // set the validity in object, this will be set because it passed by address in JS
        formField = fieldValidation(formField)

        // set the newly validate input to the list
        newFormInputs[formFieldName] = formField

        // reset the flag of form validity
        let isValidTheForm = validateTheForm(newFormInputs, packageDSDocuments, DSDocumentOriginTypes)

        // put back into the state
        this.setState({ formInputs: newFormInputs, isValidTheForm }, () => {
            if (callback) {
                return callback(newFormInputs)
            }
        })

        return newFormInputs
    }

    /**
     * Get contract id by contract number from client data
     */
    getContractIdByNumber(contractNumber) {
        const { client } = this.props
        let result = ''
        let contracts = nesProp.get(client, "contracts")

        if (!contracts || contracts.length === 0) {
            return result
        }

        let objKeys = Object.keys(contracts)
        objKeys && objKeys.map((oneKey) => {
            let oneContractNumber = nesProp.get(contracts, oneKey + ".contractMain.contractNumber")
            if ((oneContractNumber + "") === (contractNumber + "")) {
                result = nesProp.get(contracts, oneKey + ".contractMain.contractId")
            }
        })

        return result
    }

    /**
     * Finish the first step of wizard and step forward.
     */
    initStep2 = async (formInputs, skipValidationJustUpdate = false) => {
        const { dispatch, templates, lang, brokersTeamWhiteList, documents, DSDocumentOriginTypes, claimWizardDocType } = this.props
        let { clientId, packageId, moduleKey, subModuleKey, clientNumber, dynamicFieldIdCursor,
            stakeholders, packageDSDocuments } = this.state

        this.startLoading()

        try {
            //await new Promise(resolve => this.setState({isLoaded: false}, resolve))

            // load current form values like flat array
            let rawFormValuesData = fetchFormValues(formInputs, this.refs, packageDSDocuments, moduleKey, subModuleKey)

            // fill back the state holded form input objects list what control the form in the dome
            formInputs = setFormInputsByFormValues(rawFormValuesData, formInputs)

            //-------------------   VALIDATE INPUT FIELDS ---------------------------//
            // now we do a final validation before passing forward the wizard, force touch to enforce to fill the error messages
            let forceTouche = true

            formInputs = formInputsValidation(formInputs, forceTouche)

            // set the general error flag of the current step of wizard
            let isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, forceTouche)

            this.setState({ isValidTheForm, formInputs })

            // put back the validated, and error filled input instances to the state to be able to render the error messages under the inputs
            // in case of ERROR abort to move forward until the form is not valid on another try
            // skipValidationJustUpdate : BEWB-676
            if (!isValidTheForm.isValid && !skipValidationJustUpdate) {
                console.error(isValidTheForm)
                this.stopLoading()
                //trow error to prevent the form to move forward
                throw _("invalidForm")
            }


            // prepare few variables form
            let contractId = this.getContractIdByNumber(nesProp.get(formInputs, "contractNumber.value"))
            let claimId = nesProp.get(this.props, 'claimId')
            let claimNumber = nesProp.get(this.props, 'claimNumber')
            //check if there are signing documents selected or attachment selected
            let ticketId = nesProp.get(this.props, 'ticketId') &&
                ((nesProp.get(this.state, "selectedTicketRelatedOraDocuments") && nesProp.get(this.state, "selectedTicketRelatedOraDocuments").length > 0)
                    || (nesProp.get(this.state, "emailAttachmentsTicketRelatedOraDocuments") && nesProp.get(this.state, "emailAttachmentsTicketRelatedOraDocuments").length > 0))
                ? nesProp.get(this.props, 'ticketId') : ''

            let brokerNumber = nesProp.get(formInputs, "brokerNumber.value")

            // ++++++++++++++++ WORKING WITH TARIFICATION ++++++++++
            let isRequiredTarification = (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION)
            let tarificationId = nesProp.get(formInputs, "tarificationId.value")
            let tarificationNumber = nesProp.get(formInputs, "tarificationNumber.value")
            let teamIndex = nesProp.get(formInputs, "team.value")
            let teamSubgroupId = nesProp.get(formInputs, "teamSubgroup.value") || null

            if (isRequiredTarification) {
                const teamIndex = nesProp.get(formInputs, "team.value")
                brokerNumber = nesProp.get(formInputs, "brokerNumber.value")

                // this function will create tarification in case when there is no tarification else will return new ID and number pair
                const tarificationResult = await this.setupTarificationForPackageAndDocs(
                    clientId, brokerNumber, teamIndex, tarificationId, tarificationNumber,
                    packageDSDocuments, formInputs
                )

                if (tarificationResult) {
                    // the promise does what must be done before to finish the initialisation of step 2
                    // if this promise is a tarification initialiser then we have this values and patch it into args for create package
                    tarificationId = tarificationResult.tarificationId
                    tarificationNumber = tarificationResult.tarificationNumber
                    formInputs = tarificationResult.formInputs
                    packageDSDocuments = tarificationResult.packageDSDocuments

                    // get the fresh input values from the form, because possible, there is a new tarification was created, and the
                    // inputs are updated by the new tarification values for the dynamic document list also
                    // the raw values of the form are used to create a document package by the API
                    rawFormValuesData = fetchFormValues(formInputs, this.refs, packageDSDocuments, moduleKey, subModuleKey)
                }
            }

            // ------------------ UPSERTING THE PACKAGE -------------- //
            const upsertPackageArgs = {
                ...rawFormValuesData,
                emailAttachmentTicketDocuments: this.state.emailAttachmentsTicketRelatedOraDocuments,
                contractId,
                claimId,
                claimNumber,
                tarificationId,
                tarificationNumber,
                clientId,
                ticketId,
                clientNumber,
                packageId,
                claimWizardDocType,
                uploadedOnModule: moduleKey,
                subModuleKey: subModuleKey,
                teamSubgroup: teamSubgroupId
            }

            // UPDATE PACKAGE
            const updatedPackage = await dispatch(upsertDSPackage(upsertPackageArgs))


            // REFRESH STAKEHOLDERS
            if (updatedPackage && updatedPackage.stakeholders && updatedPackage.stakeholders.length > 0) {
                stakeholders = await dispatch(getDSStakeholders(updatedPackage.stakeholders))
            }


            // ++++++ Refresh DOCUMENTS and packages list -------------- //
            await dispatch(getDsDocsAndPackages(false, false, null, null, true))


            // UPDATE TEMPLATE OPTIONS
            let documentTemplateOptions = getDocumentTemplateOptionList(templates, lang, moduleKey, subModuleKey, false, claimWizardDocType)
            if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION) {
                documentTemplateOptions = filterTemplatesForBroker(
                    documentTemplateOptions, brokersTeamWhiteList, brokerNumber, teamIndex, teamSubgroupId
                )
            }

            let newPackageId = packageId || (updatedPackage && updatedPackage._id)

            // reload package documents from store, because fo update
            // this require to reconstruct the dynamic documents part fo the form
            packageDSDocuments = filterDocumentsByPackageId(this.props.documents, newPackageId)

            // ++++ reset dynamic document index cursor for reindexing
            dynamicFieldIdCursor = 1
            // attach the cursor for all document
            let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)
            packageDSDocuments = attachIdResult.packageDSDocuments
            dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor

            formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)

            moduleKey = moduleKey || getModuleKeyOfPackage(nesProp.get(this, "state.packageDSDocuments"))
            subModuleKey = subModuleKey || getSubModuleKeyOfPackage(nesProp.get(this, "state.packageDSDocuments"))

            let newPackageContractId = contractId || (updatedPackage && updatedPackage.contractId)
            let newPackageTarificationId = tarificationId || (updatedPackage && updatedPackage.tarificationId)

            this.setState({
                formInputs,
                packageDSDocuments,
                packageId: newPackageId,
                contractId: newPackageContractId,
                tarificationId: newPackageTarificationId,
                tarificationNumber: tarificationNumber,
                dynamicFieldIdCursor,
                moduleKey,
                subModuleKey,
                documentTemplateOptions,
                stakeholders
            }, () => {
                this.stopLoading()
            })

            return updatedPackage

        } catch (error) {
            //this.setState({isLoaded: true})
            this.stopLoading()
            // TODO - solve the error handling on another way if necessary. To give feedback for the user about the error in the modal...
            dispatch(setNotification(_('wizardError') + " " + JSON.stringify(error), 'error'))
            return Promise.reject(error)
        }
    }

    /**
     * This function will handle the tarification related values for the package.
     * If there is a tarification already added then just return it in promise, else
     * will generate one using oracle procedures, and will return with that.
     * @param {*} clientId
     * @param {*} brokerNumber
     * @param {*} teamIndex
     * @param {*} tarificationId
     * @param {*} tarificationNumber
     * @param {*} packageDSDocuments
     * @param {*} formInputs
     * @returns Promise: {packageDSDocuments, formInputs, tarificationId, tarificationNumber}
     */
    async setupTarificationForPackageAndDocs(clientId, brokerNumber, teamIndex, tarificationId, tarificationNumber,
        packageDSDocuments, formInputs) {
        const { dispatch } = this.props

        // prepare result
        let tarificationInfo = {
            tarificationId,
            tarificationNumber
        }

        // parse all document are there set tarification for al documents
        let isLinkedAllDocumentsWithTarification = allDocumentsHasTarificationNumber(packageDSDocuments)

        // +++ EXIT POINT
        // already set the tarification, or not needed to link with anything, then return and resolve
        if (isLinkedAllDocumentsWithTarification) {
            return {
                ...tarificationInfo,
                packageDSDocuments,
                formInputs
            }
        }


        // ------------------ CREATE AND SETUP TARIFICATION IN CASE OF NOT CREATED ----------------------------------
        // if necessary to setup tarification for a document then check if already have tarification number generated by oracle
        // get the list of used tarification numbers
        let listOfTarificationNumbers = getDocumentsTarificationNumbersList(packageDSDocuments)
        let firstTarificationIdNumberPair = nesProp.get(listOfTarificationNumbers, "0")


        // +++ EXIT POINT
        // When we have ALREADY generated TARIFICATION, just LINK it to the DOCUMENTS,
        // normally must be the same for all docs, when it is possible avoid to use value from package
        if (firstTarificationIdNumberPair && firstTarificationIdNumberPair.tarificationId) {

            // fill the form documents properties with the new tarification values and return a promise
            let setTarifResult = await this.setTarificationInfoForAllDocuments(
                packageDSDocuments,
                formInputs,
                firstTarificationIdNumberPair.tarificationId,
                firstTarificationIdNumberPair.tarificationNumber
            )

            packageDSDocuments = setTarifResult.packageDSDocuments
            formInputs = setTarifResult.formInputs

            return {
                ...tarificationInfo,
                packageDSDocuments,
                formInputs
            }
        }

        // Last case when we don't have tarification, we create one and set it for all entities, for package and document also
        // prepare params for api call
        let createTarificationParams = {
            clientId,
            brokerNumber,
            tarificationTeam: teamIndex
        }

        // temporary external data holder bridge for the following promise


        // call the createTarification api call
        let createTarifResult = await dispatch(createClientTarification(createTarificationParams))

        try {
            // setup tarification for package inputs
            formInputs = this.onChangeFormInput(createTarifResult.tarificationId, "tarificationId", null, null, formInputs)
            formInputs = this.onChangeFormInput(createTarifResult.tarificationNumber, "tarificationNumber", null, null, formInputs)

            // fill the form documents properties with the new tarification values and return a promise
            let setTarifResult = await this.setTarificationInfoForAllDocuments(
                packageDSDocuments,
                formInputs,
                createTarifResult.tarificationId,
                createTarifResult.tarificationNumber
            )

            packageDSDocuments = setTarifResult.packageDSDocuments
            formInputs = setTarifResult.formInputs

        } catch (err) {
            console.error(err)
            throw err
        }

        return {
            ...createTarifResult,
            packageDSDocuments,
            formInputs
        }
    }

    /**
     * This function helps to use an icon on a safe way
     */
    getIcon(menuName) {
        try {
            return require(`resources/images/${menuName}.svg`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /**
     *
     * @param {*} templateId
     * @returns
     */
    getTeamOptionsByTemplateId(templateId) {
        const { templates, lang, clientOptionsDict } = this.props
        const { teamsOptions } = this.state

        // language can be selected depending on template
        let teamsList = getTeamsOptionList(clientOptionsDict, lang)
        let teamWhiteList = []

        // extend the languageWhiteList with the values what support the selected template (check html existence in record)
        if (templates && templates.length && templateId) {
            // find template in the list of all templates
            let templateForTheNewDoc = templates.filter((item) => {
                return (item._id === templateId)
            })

            // get the template instance from result
            let templateInstance = nesProp.get(templateForTheNewDoc, "0")

            // check the languages if exist in template, what mean check the html path have value on that language index
            teamsList.forEach((oneTeam) => {
                if (oneTeam.value == nesProp.get(templateInstance, "teamId.teamIndex")) {
                    teamWhiteList.push(oneTeam.value)
                }
            })
        }

        // compose the language list for the current Select element in the render, using th whitelist created using the template.
        let filteredLanguageOptions = teamsOptions.filter((item) => {
            return teamWhiteList.includes(item.value)
        })

        return filteredLanguageOptions
    }

    /**
     * This function will create a new document for the package, can be added to the sate
     * @param {array} packageDSDocuments - package documents
     * @param {string} clientLanguage - form inputs list
     * @param {object} teamInfo - teamInfo
     * @param {number} dynamicFieldIdCursor - cursor index for docs
     * @param {array} languageOptions - cursor index for docs
     * @param {array} documentTemplateOptions - cursor index for docs
     * @param {object} moduleEntityArguments - this object can contains contract, claim, tarification information
     * Options for moduleEntityArguments: {contractId, tarificationId, tarificationNumber, moduleKey, subModuleKey, isPrem}
     * @param {object} localDocument - provided by uploader/attachment modal (v8)
     * @param {object} oracleDocument - provided by oracle (v8)
     * @returns
     */
    async createDSDocumentForPackage(
        packageDSDocuments, clientLanguage, teamInfo, dynamicFieldIdCursor,
        languageOptions, documentTemplateOptions,
        moduleEntityArguments,
        localDocument = null, oracleDocument = null
    ) {
        const { templates, security, DSDocumentOriginTypes, client } = this.props
        let { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem, isItTarificationModule } = moduleEntityArguments

        let blankDSDocumentInstance = getNewDSDocumentInstance(security)

        // set unique cursor for the new instance to be able to handle it, that is a kind of temporal ID to assign it
        blankDSDocumentInstance.cursor = dynamicFieldIdCursor

        //INCREASE by ONE and save the global cursor (temporal ID)
        dynamicFieldIdCursor += 1

        // +++++++ PREM CASE
        // WHEN WE HAVE THE PREM CASE, ONLY ON TEMPLATE IS IN THE LIST, the prem template it is. !!deprecated!!
        // select the first one values from options of selection list to init the document instance in case we are in PREM dswizard flow !!deprecated!!
        //update BEWB - 706 prem module should behave like tariffication
        // update BEWB - 706 we need to add a default document with flag requiredOnPrem, this doc can't be removed, these documents are to be removed from documents list and stored in a different list
        if (isPrem) {
            nesProp.set(blankDSDocumentInstance, "documentTemplateId", nesProp.get(documentTemplateOptions, "0.value"))
            documentTemplateOptions
        }
        // ------- PREM CASE

        if (isItTarificationModule) {
            // IMPORTANT: LET IT BLANK DO NOT SELECT ANY TEMPLATE: BEWB-664
            // nesProp.set(blankDSDocumentInstance, "documentTemplateId", nesProp.get(documentTemplateOptions, "0.value"))
        }
        // case is claimWizard there should always be only one document template add should be added by default
        if (moduleKey === c.DS_MODULE_CLAIM_WIZARD && !localDocument && !oracleDocument) {
            nesProp.set(blankDSDocumentInstance, "documentTemplateId", nesProp.get(documentTemplateOptions, "0.value"))
        }

        nesProp.set(blankDSDocumentInstance, "subModuleKey", subModuleKey)

        // init team for the doc when we are on tarification
        let isRequiredTarification = (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION)

        // in case if the tarification is required, then we clone the team information from the package for the individual documents
        // else just leave it empty
        if (isRequiredTarification) {
            blankDSDocumentInstance.team = nesProp.get(teamInfo, "team") || null
            blankDSDocumentInstance.teamName = nesProp.get(teamInfo, "teamName") || null
            blankDSDocumentInstance.teamSubgroup = nesProp.get(teamInfo, "teamSubgroup") || null
        } else {
            blankDSDocumentInstance.team = null
            blankDSDocumentInstance.teamName = null
            blankDSDocumentInstance.teamSubgroup = null
        }

        // language can be selected depending on template
        let filteredLanguageOptions = getLanguageOptionsByTemplateId(blankDSDocumentInstance.documentTemplateId, templates, languageOptions)

        // get the fist value from the possible languages
        blankDSDocumentInstance.language = nesProp.get(filteredLanguageOptions, "0.value")

        // BEWB-443 the LANGUAGE of the document to be the language of the user by default
        let yesAllowedLang = false
        filteredLanguageOptions.forEach((item) => {
            yesAllowedLang = yesAllowedLang || (item.value === clientLanguage)
        })

        if (yesAllowedLang) {
            blankDSDocumentInstance.language = clientLanguage
        }

        // get the the possible CONTRACTNUMBER
        if (contractId) {
            let theContract = findContractInClientObj(client, contractId) // sync call
            blankDSDocumentInstance.contractNumber = nesProp.get(theContract, "contractMain.contractNumber")
            blankDSDocumentInstance.contractId = contractId
        }

        // get the the possible ClaimId
        if (claimId) {
            blankDSDocumentInstance.claimNumber = claimNumber
            blankDSDocumentInstance.claimId = claimId
        }

        // get the the possible TARIFICATIONID
        if (tarificationId) {
            blankDSDocumentInstance.tarificationId = tarificationId
            blankDSDocumentInstance.tarificationNumber = tarificationNumber
        }

        // set the ORIGIN and the origin specific details for the new dynamic document
        // by default is generated document
        blankDSDocumentInstance.origin = DSDocumentOriginTypes.DS_ORIGIN_GENERATED


        // +++++++ EXTRA FIELDS FOR UPLOADED DOCUMENTS
        // when a document is uploaded from local device, overwrite the origin and specific related data
        if (localDocument) {
            blankDSDocumentInstance.originalFileName = localDocument.originalFileName
            blankDSDocumentInstance.temporaryUploadId = localDocument._id
            blankDSDocumentInstance.origin = DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD
            blankDSDocumentInstance.documentUploadGroupTypeId = localDocument.documentUploadGroupTypeId
            blankDSDocumentInstance.documentTypeIdx = localDocument.lowValue
            blankDSDocumentInstance.language = clientLanguage
            blankDSDocumentInstance.uploadComment = localDocument.uploadComment
            blankDSDocumentInstance.attachmentConnectionId = localDocument.attachmentConnectionId || ''
            blankDSDocumentInstance.isAttachment = localDocument.isAttachment || false
            blankDSDocumentInstance.positionInUploadDoc = localDocument.positionInUploadDoc || ''
        }
        // --------- END of handling UPLOADED documents


        // +++++++ EXTRA FIELDS FOR ORACLE DOCUMENTS
        // when a document is selected from oracle, overwrite the origin and specific related data
        if (oracleDocument) {
            blankDSDocumentInstance.oracleDocumentId = oracleDocument.oracleDocumentId
            blankDSDocumentInstance.oracleDocumentType = oracleDocument.oracleDocumentType
            blankDSDocumentInstance.origin = DSDocumentOriginTypes.DS_ORIGIN_ORACLE
            blankDSDocumentInstance.oracleDocumentName = oracleDocument.oracleDocumentName || oracleDocument.oracleDocumentId
            // TODO ask if it is ok
            // no template enforce client language
            blankDSDocumentInstance.language = clientLanguage
            blankDSDocumentInstance.documentSelectionTab = oracleDocument.documentSelectionTab
            blankDSDocumentInstance.oracleDocumentUploadDate = oracleDocument.oracleDocumentUploadDate
        }
        // --------- END of handling ORACLE documents


        // link the template record for the new doc instance
        if (templates && templates.length && blankDSDocumentInstance.documentTemplateId) {
            let templateForTheNewDoc = templates.filter((item) => {
                return (item._id === blankDSDocumentInstance.documentTemplateId)
            })
            nesProp.set(blankDSDocumentInstance, "documentTemplate", nesProp.get(templateForTheNewDoc, "0"))
        }

        // finally extend the package documents list also, to be able to work with documents.
        packageDSDocuments.push(blankDSDocumentInstance)

        // +++++ process FILE SIZES for documents +++++++
        packageDSDocuments = await this.updateDocumentSizesForAllDsDocuments(packageDSDocuments)
        // ----------------------------------------------

        // get the document from the list with the same cursor to know the size from the previous operation
        let sameDocumentWithSize = packageDSDocuments.filter(oneDoc => oneDoc.cursor === blankDSDocumentInstance.cursor)
        blankDSDocumentInstance = sameDocumentWithSize[0]

        // ++++ Important notice +++ This operation to produce fields for the document must be the last operation, to give corect
        // initial values for inputs by the document instances
        // push a new form field set for the new document properties in form
        let documentFormInputs = getDynamicInputFieldByCursor(blankDSDocumentInstance, moduleKey, subModuleKey, DSDocumentOriginTypes)

        return { packageDSDocuments, documentFormInputs, dynamicFieldIdCursor }
    }

    /**
     *
     * @param {*} packageDSDocuments
     * @returns
     */
    async updateDocumentSizesForAllDsDocuments(packageDSDocuments) {
        const { DSDocumentOriginTypes, dispatch } = this.props

        let generatedDocs = packageDSDocuments
            .filter(oneDoc => oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED)
            .map(oneDoc => oneDoc.documentTemplateId)
        let oraDocsDocs = packageDSDocuments
            .filter(oneDoc => oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_ORACLE)
            .map(oneDoc => ({
                oracleDocumentId: oneDoc.oracleDocumentId,
                oracleDocumentType: oneDoc.oracleDocumentType,
            }))
        let uploadedDocs = packageDSDocuments
            .filter(oneDoc => oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD)
            .map(oneDoc => oneDoc.temporaryUploadId)

        let fileSizeList = await dispatch(fetchDsDocumentSizeList(generatedDocs, oraDocsDocs, uploadedDocs))

        // iterate al docs and update the result sizes by origin on it
        for (let i = 0; i < packageDSDocuments.length; i++) {

            // update ora template documents for size
            for (let j = 0; j < fileSizeList.DS_ORIGIN_GENERATED.length; j++) {
                if (packageDSDocuments[i].documentTemplateId === fileSizeList.DS_ORIGIN_GENERATED[j].documentTemplateId) {
                    packageDSDocuments[i].fileSize = fileSizeList.DS_ORIGIN_GENERATED[j].size
                    packageDSDocuments[i].isEncrypted = false
                }
            }

            // update ora docs for size
            for (let j = 0; j < fileSizeList.DS_ORIGIN_ORACLE.length; j++) {
                if (packageDSDocuments[i].oracleDocumentId === fileSizeList.DS_ORIGIN_ORACLE[j].oracleDocumentId &&
                    packageDSDocuments[i].oracleDocumentType === fileSizeList.DS_ORIGIN_ORACLE[j].oracleDocumentType) {
                    packageDSDocuments[i].fileSize = fileSizeList.DS_ORIGIN_ORACLE[j].size
                    packageDSDocuments[i].isEncrypted = fileSizeList.DS_ORIGIN_ORACLE[j].isEncrypted
                }
            }

            // update ora template documents for size
            for (let j = 0; j < fileSizeList.DS_ORIGIN_LOCAL_UPLOAD.length; j++) {
                if (packageDSDocuments[i].temporaryUploadId === fileSizeList.DS_ORIGIN_LOCAL_UPLOAD[j].temporaryUploadId) {
                    packageDSDocuments[i].fileSize = fileSizeList.DS_ORIGIN_LOCAL_UPLOAD[j].size
                    packageDSDocuments[i].isEncrypted = fileSizeList.DS_ORIGIN_LOCAL_UPLOAD[j].isEncrypted
                }
            }
        }

        return packageDSDocuments
    }

    /**
     * This will change the template for a doc on packageDSDocuments and formInputs as well.
     * This will fire the this.on ChangeLanguageForDoc as well with default value.
     * @param {*} value
     * @param {*} docTemplateFieldName
     * @param {*} packageDSDocuments
     * @param {*} documentCursor
     */
    async onChangeTemplateForDoc(value, docTemplateFieldName, packageDSDocuments, formInputs, documentCursor) {
        let { moduleKey, subModuleKey, languageOptions, stakeholders, isPrem, signerAvailabilityOfTemplates, dynamicFieldIdCursor, initiatorEmailAddressesFromTemplates } = this.state
        const { templates, DSDocumentOriginTypes, isOffice } = this.props
        let selectedTemplateId = nesProp.get(value, "value")
        let clientLanguage = nesProp.get(formInputs, "clientLanguage.value")

        formInputs = this.onChangeFormInput(selectedTemplateId || "", docTemplateFieldName, null, null, formInputs)

        // find the affected template record
        let selectedTemplateRecord = templates
            .filter((item) => (item._id.toString() === selectedTemplateId ? selectedTemplateId.toString() : ''))

        selectedTemplateRecord = nesProp.get(selectedTemplateRecord, "0") || null

        // change the language selected in case that is the old value is restricted
        let filteredLanguageOptions = getLanguageOptionsByTemplateId(selectedTemplateId, templates, languageOptions)

        let initiatorEmailAddressesFromTemplatesCopy = [...initiatorEmailAddressesFromTemplates]
        // package documents are mixed with already existent and newly created documents,
        // so they are managed in browser with local cursor in place of id, to be able make difference in between
        // more newly added document
        if (packageDSDocuments) {
            for (let index = 0; index < packageDSDocuments.length; index++) {
                let oneDocument = packageDSDocuments[index]

                // skip if not affected
                if (oneDocument.cursor != documentCursor) {
                    continue
                }

                // if this is office than the initiator is not just a broker and "broker email addresses are set from the templates

                if (isOffice && selectedTemplateRecord && selectedTemplateRecord.initiatorEmailAddress) {

                    // remove emails from initiator list that originate from removed "documents from office"
                    const emailsFromTemplateMapResult = packageDSDocuments.map(oneDoc => {
                        const oneTemplateArray = templates
                            .filter((item) => oneDoc.cursor !== documentCursor && (oneDoc.documentTemplateId && item._id.toString() === oneDoc.documentTemplateId.toString()))
                        const oneTemplate = nesProp.get(oneTemplateArray, "0") || null
                        return oneTemplate && oneTemplate.initiatorEmailAddress
                    })
                    initiatorEmailAddressesFromTemplatesCopy = initiatorEmailAddressesFromTemplatesCopy.filter(email => emailsFromTemplateMapResult.includes(email.value))

                    //add new email address if it's the case 
                    if (!initiatorEmailAddressesFromTemplatesCopy.some(oneEmailOption => oneEmailOption.value === selectedTemplateRecord.initiatorEmailAddress)) {
                        const emailOption = {
                            value: selectedTemplateRecord.initiatorEmailAddress,
                            label: selectedTemplateRecord.initiatorEmailAddress
                        }

                        if (initiatorEmailAddressesFromTemplatesCopy.length === 0 ||
                            !initiatorEmailAddressesFromTemplatesCopy.some(oneEmailOption => oneEmailOption.value === formInputs['brokerEmailAddress'])) {
                            formInputs = this.onChangeFormInput(selectedTemplateRecord.initiatorEmailAddress, 'brokerEmailAddress', null, null, formInputs)
                        }
                        initiatorEmailAddressesFromTemplatesCopy.push(emailOption)
                    }
                }

                //check if there attached documents from template
                const attachedDocumentsToRemove = packageDSDocuments.filter(oneDsDoc =>
                    oneDocument.attachmentConnectionId && oneDsDoc.attachmentConnectionId === oneDocument.attachmentConnectionId && oneDsDoc.cursor !== oneDocument.cursor)

                for (const oneDocToRemove of attachedDocumentsToRemove) {
                    const removeDocumentsRes = await this.removeAttachmentDocument(oneDocToRemove.cursor, formInputs, packageDSDocuments)
                    packageDSDocuments = removeDocumentsRes.packageDSDocuments
                    formInputs = removeDocumentsRes.formInputs

                }

                // set the affected document template in state also
                nesProp.set(packageDSDocuments, index + ".documentTemplate", selectedTemplateRecord)
                nesProp.set(packageDSDocuments, index + ".documentTemplateId", selectedTemplateId)
                // -------------------- CHECK LANGUAGE WHITELIST SECTION ----


                // ++++++++ check the size by API call, only one doc to check in this case
                // the result contains only just the lonely document
                let docListToCheckSize = await this.updateDocumentSizesForAllDsDocuments([packageDSDocuments[index]])
                // put be the doc in place, the result have only one result, the first one needed
                packageDSDocuments[index] = docListToCheckSize[0]
                // -------------------------

                let documentSizeFieldName = getDynamicFieldNameForSize(documentCursor)
                formInputs = this.onChangeFormInput(packageDSDocuments[index].fileSize || 0, documentSizeFieldName, null, null, formInputs)

                // check if the language is not in the white list of the template
                let currentDocLang = nesProp.get(packageDSDocuments, index + ".language")
                let isEnabledTheDocLang = false


                // check if must change
                filteredLanguageOptions.forEach((oneWhiteListedLang) => {
                    if (oneWhiteListedLang.value === currentDocLang) {
                        isEnabledTheDocLang = true
                    }
                })


                // in case the current language is not enabled, then change it
                if (!isEnabledTheDocLang) {
                    //nesProp.set(packageDSDocuments, index+".language", nesProp.get(filteredLanguageOptions, "0.value"))
                    let docLangFieldName = getDynamicFieldNameForDocLang(documentCursor)

                    // BEWB-443 the language of the document to be the language of the user by default
                    let yesAllowedLang = false
                    filteredLanguageOptions.forEach((oneWhiteListedLang) => {
                        yesAllowedLang = yesAllowedLang || (oneWhiteListedLang.value === clientLanguage)
                    })

                    let defaultLanguageForDoc = nesProp.get(filteredLanguageOptions, "0.value")
                    if (yesAllowedLang) {
                        defaultLanguageForDoc = clientLanguage
                    }

                    formInputs = this.onChangeFormInput(
                        nesProp.get(defaultLanguageForDoc, "value") || "",
                        docLangFieldName,
                        null,
                        null,
                        formInputs
                    )

                    nesProp.set(packageDSDocuments, index + ".language", nesProp.get(defaultLanguageForDoc, "value"))
                    nesProp.set(packageDSDocuments, index + ".brokerFilledValues", null)
                    nesProp.set(packageDSDocuments, index + ".isPrinted", false)

                }
                // -----------------------------------------------------------------------


                // -----------------  Clone the tarification info --------------------------
                // templates depends on teams by priority, do not change a higher level value

                let team = nesProp.get(formInputs, "team.value")
                let teamName = nesProp.get(formInputs, "teamName.value")
                let teamSubgroup = nesProp.get(formInputs, "teamSubgroup.value")
                let tarificationId = nesProp.get(formInputs, "tarificationId.value")
                let tarificationNumber = nesProp.get(formInputs, "tarificationNumber.value")

                nesProp.set(packageDSDocuments, index + ".team", team)
                nesProp.set(packageDSDocuments, index + ".teamName", teamName)
                nesProp.set(packageDSDocuments, index + ".teamSubgroup", teamSubgroup)
                nesProp.set(packageDSDocuments, index + ".tarificationId", tarificationId)
                nesProp.set(packageDSDocuments, index + ".tarificationNumber", tarificationNumber)

                let docTeamFieldName = getDynamicFieldNameForDocTeam(oneDocument.cursor)
                let docTeamNameFieldName = getDynamicFieldNameForDocTeamName(oneDocument.cursor)
                let docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(oneDocument.cursor)
                let docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(oneDocument.cursor)
                let docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(oneDocument.cursor)

                formInputs = this.onChangeFormInput(team, docTeamFieldName, null, null, formInputs)
                formInputs = this.onChangeFormInput(teamName, docTeamNameFieldName, null, null, formInputs)
                formInputs = this.onChangeFormInput(tarificationId, docTarificationIdFieldName, null, null, formInputs)
                formInputs = this.onChangeFormInput(tarificationNumber, docTarificationNumberFieldName, null, null, formInputs)
                formInputs = this.onChangeFormInput(teamSubgroup, docTeamSubgroupFieldName, null, null, formInputs)
                // -----------------------------------------------------------------------

                // reset the filled values and the printed status on template change
                nesProp.set(packageDSDocuments, index + ".brokerFilledValues", null)
                nesProp.set(packageDSDocuments, index + ".isPrinted", false)

                // Create a connection id for attached pdf's if there are any
                const connectionId = uuidv4()
                nesProp.set(packageDSDocuments, index + ".attachmentConnectionId", connectionId)
                let attachmentConnectionIdFieldName = getDynamicFieldNameAttachmentConnectionId(oneDocument.cursor)
                formInputs = this.onChangeFormInput(connectionId, attachmentConnectionIdFieldName, null, null, formInputs)

                // add documents attached to template if any
                const handleDocsResult = await this.handleDocsAttachedToGeneratedTemplates(packageDSDocuments, index, formInputs, selectedTemplateRecord, dynamicFieldIdCursor)
                packageDSDocuments = handleDocsResult.packageDSDocuments
                formInputs = handleDocsResult.formInputs
                dynamicFieldIdCursor = handleDocsResult.dynamicFieldIdCursor
            }
        }

        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)
        formInputs = formInputsValidation(formInputs)
        let isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)

        // ++++++++++++ start handle enabled signers list ++++++++++++++
        let addSignersButtonFlags = getSignerAdderButtonsFlags(packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates)
        let isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder
        let isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder
        let isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder
        // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
        // those properties, so don't do that
        //---------------- end handle enabled signers list


        // finally update all of process result in state
        this.setState({
            isItExistFirstSignerPlaceholder,
            isItExistSecondSignerPlaceholder,
            isItExistBrokerSignerPlaceholder,
            isValidTheForm,
            formInputs,
            packageDSDocuments,
            dynamicFieldIdCursor,
            initiatorEmailAddressesFromTemplates: initiatorEmailAddressesFromTemplatesCopy
        })


        return {
            formInputs,
            packageDSDocuments,
            isValidTheForm
        }
    }

    /**
     * This method will fill or clean the form inputs for signers depends on added documents to the list.
     * @param {object} formInputs
     * @param {array} packageDSDocuments
     * @param {string} clientId
     * @param {string} packageId
     * @param {array} stakeholders
     * @returns
     */
    reconstructAndFillSignerFormInputs(formInputs, packageDSDocuments, clientId, packageId, stakeholders) {
        const { DSDocumentOriginTypes, isOffice } = this.props

        //const firstSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerNumber === '0')
        const secondSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerNumber === '1')
        const brokerSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerType === "BROKER")

        let packageHaveSignableDocument = requireSigning(packageDSDocuments, DSDocumentOriginTypes)

        //check if one document requires signing and if so, handle form inputs for signing
        if (packageHaveSignableDocument) {
            let brokerNumberFromForm = nesProp.get(formInputs, "brokerNumber.value")
            const formInitialValues = this.getFormInitialValues(
                packageDSDocuments,
                brokerNumberFromForm,
                stakeholders,
                clientId,
                packageId,
                this.props.clientOptionsDict,
                this.props.contractId
            )

            // extend form inputs for first signer
            formInputs = setSigningInputFields(
                formInputs,
                formInitialValues,
                requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes)
            )

            let resultSS = this.toggleShowSecondSigner(
                formInputs,
                packageDSDocuments,
                (!!secondSigningStakeholder) // force toggle
            )

            this.setState({ showSecondSigner: resultSS.showSecondSigner })
            formInputs = resultSS.formInputs

            let resultBS = this.toggleShowBrokerSigner(
                formInputs,
                packageDSDocuments,
                brokerSigningStakeholder,
                (!!brokerSigningStakeholder)
            )

            this.setState({ showBrokerSigner: resultBS.showBrokerSigner })
            formInputs = resultBS.formInputs

        }

        // if no document require signing reset fields that are are set in case previously there was select a
        // contract that require signing and now is removed
        if (!packageHaveSignableDocument) {
            formInputs = removeSigningInputFieldsValues(formInputs)

            let resultSS = this.toggleShowSecondSigner(formInputs, packageDSDocuments, false)

            this.setState({ showSecondSigner: resultSS.showSecondSigner })
            formInputs = resultSS.formInputs

            let resultBS = this.toggleShowBrokerSigner(formInputs, packageDSDocuments, brokerSigningStakeholder, false)

            this.setState({ showBrokerSigner: resultBS.showBrokerSigner })
            formInputs = resultBS.formInputs
        }

        return formInputs
    }

    /**
     * Onchange event handler for the language selector
     * @param {*} value
     * @param {*} docTemplateFieldName
     * @param {*} packageDSDocuments
     * @param {*} formInputs
     * @param {*} documentCursor
     */
    async onChangeLanguageForDoc(value, docLangFieldName, packageDSDocuments, formInputs, documentCursor) {
        const { templates, DSDocumentOriginTypes } = this.props
        let { dynamicFieldIdCursor, moduleKey, subModuleKey, stakeholders } = this.state
        formInputs = this.onChangeFormInput(
            nesProp.get(value, "value") || "",
            docLangFieldName,
            null,
            null,
            formInputs
        )
        if (packageDSDocuments) {
            for (let index = 0; index < packageDSDocuments.length; index++) {
                const oneDocument = packageDSDocuments[index]

                if (oneDocument.cursor == documentCursor) {
                    // put it in the document affected
                    nesProp.set(packageDSDocuments, index + ".language", nesProp.get(value, "value"))
                    nesProp.set(packageDSDocuments, index + ".brokerFilledValues", null)
                    nesProp.set(packageDSDocuments, index + ".isPrinted", false)

                    // find the affected template record
                    let selectedTemplateRecord = templates
                        .filter((item) => (String(item._id) === String(oneDocument.documentTemplateId)))

                    selectedTemplateRecord = nesProp.get(selectedTemplateRecord, "0") || null
                    //check if there attached documents from template
                    const attachedDocumentsToRemove = packageDSDocuments.filter(oneDsDoc =>
                        oneDsDoc.attachmentConnectionId === oneDocument.attachmentConnectionId && oneDsDoc.cursor !== oneDocument.cursor)
                    for (const oneDocToRemove of attachedDocumentsToRemove) {

                        const responseFromRemoveDoc = await this.removeAttachmentDocument(oneDocToRemove.cursor, formInputs, packageDSDocuments)
                        packageDSDocuments = responseFromRemoveDoc.packageDSDocuments
                        formInputs = responseFromRemoveDoc.formInputs
                    }

                    // add documents attached to template if any
                    const handleDocsResult = await this.handleDocsAttachedToGeneratedTemplates(packageDSDocuments, index, formInputs, selectedTemplateRecord, dynamicFieldIdCursor)
                    packageDSDocuments = handleDocsResult.packageDSDocuments
                    formInputs = handleDocsResult.formInputs
                    dynamicFieldIdCursor = handleDocsResult.dynamicFieldIdCursor
                }
            }
        }

        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)
        formInputs = formInputsValidation(formInputs)
        let isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)

        this.setState({ packageDSDocuments, formInputs, dynamicFieldIdCursor, isValidTheForm })

        return { packageDSDocuments, formInputs }
    }

    /**
     *
     * @param {*} value
     * @param {*} docTeamFieldName
     * @param {*} documentCursor
     */
    onChangeTeamForDoc(value, docTeamFieldName, documentCursor) {
        let { packageDSDocuments } = this.state

        this.onChangeFormInput(
            nesProp.get(value, "value") || "",
            docTeamFieldName,
            null,
            () => {
                if (packageDSDocuments) {
                    packageDSDocuments.forEach((oneDocument, index) => {
                        if (oneDocument.cursor == documentCursor) {
                            nesProp.set(packageDSDocuments, index + ".team", nesProp.get(value, "value"))
                        }
                    })
                }
                this.setState({ packageDSDocuments: packageDSDocuments })
            }
        )
    }


    /**
     *
     * @param {*} value
     * @param {*} docTeamNameFieldName
     * @param {*} documentCursor
     */
    onChangeTeamNameForDoc(value, docTeamNameFieldName, documentCursor) {
        let { packageDSDocuments } = this.state

        this.onChangeFormInput(
            nesProp.get(value, "label") || "",
            docTeamNameFieldName,
            null,
            () => {
                if (packageDSDocuments) {
                    packageDSDocuments.forEach((oneDocument, index) => {
                        if (oneDocument.cursor == documentCursor) {
                            nesProp.set(packageDSDocuments, index + ".teamName", nesProp.get(value, "value"))
                        }
                    })
                }
                this.setState({ packageDSDocuments: packageDSDocuments })
            }
        )
    }

    /**
     * This function not called by direc user interaction because all documents has the same subgroup, changed by an
     * outer dropdown on package.
     * @param {*} value
     * @param {*} docTeamSubgroupFieldName
     * @param {*} documentCursor
     */
    onChangeTeamSubgroupForDoc(value, docTeamSubgroupFieldName, documentCursor) {
        let { packageDSDocuments, formInputs } = this.state
        let selectedTeamSubgroupValue = nesProp.get(value, "value")

        this.onChangeFormInput(
            selectedTeamSubgroupValue || "",
            docTeamSubgroupFieldName,
            null,
            () => {
                if (packageDSDocuments) {
                    packageDSDocuments.forEach((oneDocument, index) => {
                        if (oneDocument.cursor == documentCursor) {
                            nesProp.set(packageDSDocuments, index + ".teamSubgroup", nesProp.get(value, "value"))
                        }
                    })
                }
                this.setState({ packageDSDocuments: packageDSDocuments/* , documentTemplateOptions */ })
            }
        )
    }

    /**
     * Remove attachment documents but do not update state
     * @param {*} cursor 
     * @param {*} formInputs 
     * @param {*} packageDSDocuments 
     * @returns 
     */
    async removeAttachmentDocument(cursor, formInputs, packageDSDocuments) {
        const { moduleKey, subModuleKey, stakeholders } = this.state
        const { DSDocumentOriginTypes } = this.props

        // filter document list
        packageDSDocuments = removeDSDocumentFromThePackage(cursor, packageDSDocuments)

        // filter input list
        formInputs = removeFormInputByCursor(cursor, formInputs)

        // handle the signing filed related dynamic inputs and validations
        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)
        formInputs = formInputsValidation(formInputs)

        let isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)

        return {
            packageDSDocuments,
            formInputs,
            isValidTheForm
        }
    }

    /**
     * This function remove documents from package document and form inputs as well
     */
    async onRemoveDocument(cursor, formInputs, packageDSDocuments, updateState = true) {
        let { selectedClaimRelatedOraDocuments,
            selectedContractRelatedOraDocuments,
            selectedTarificationRelatedOraDocuments,
            selectedClientRelatedOraDocuments,
            selectedTicketRelatedOraDocuments,
            moduleKey, subModuleKey, stakeholders } = this.state

        const { DSDocumentOriginTypes } = this.props
        // filter ticket doc list
        let oracleId = getOracleIdByCursorFromPackageDSDocuments(cursor, packageDSDocuments)

        selectedClaimRelatedOraDocuments = removeSelectedDocumentFromOraDocuments(
            oracleId,
            selectedClaimRelatedOraDocuments
        )

        selectedContractRelatedOraDocuments = removeSelectedDocumentFromOraDocuments(
            oracleId,
            selectedContractRelatedOraDocuments
        )

        selectedTarificationRelatedOraDocuments = removeSelectedDocumentFromOraDocuments(
            oracleId,
            selectedTarificationRelatedOraDocuments
        )

        selectedClientRelatedOraDocuments = removeSelectedDocumentFromOraDocuments(
            oracleId,
            selectedClientRelatedOraDocuments
        )

        selectedTicketRelatedOraDocuments = removeSelectedDocumentFromOraDocuments(
            oracleId,
            selectedTicketRelatedOraDocuments
        )

        // filter document list
        packageDSDocuments = removeDSDocumentFromThePackage(cursor, packageDSDocuments)

        // filter input list
        formInputs = removeFormInputByCursor(cursor, formInputs)

        // handle the signing filed related dynamic inputs and validations
        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)
        formInputs = formInputsValidation(formInputs)

        let isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)

        if (!updateState) {
            return
        }
        this.setState({
            formInputs,
            isValidTheForm,
            packageDSDocuments,
            selectedClaimRelatedOraDocuments,
            selectedContractRelatedOraDocuments,
            selectedTarificationRelatedOraDocuments,
            selectedClientRelatedOraDocuments,
            selectedTicketRelatedOraDocuments
        })
    }

    /**
     * This function render a document in the dome
     * @param {*} oneDocument
     * @param {*} isRequiredTarification
     */
    renderPackageDocument(oneDocument, isRequiredTarification) {
        const { languageOptions, documentTemplateOptions } = this.state
        let { formInputs, isPrem, packageDSDocuments } = this.state
        const { lang, DSDocumentOriginTypes, templates, claimWizardDocType } = this.props
        let cursor = oneDocument.cursor

        // find the package instance from the first document of the package
        let packageInstance = {}

        const requiredOnPrem = oneDocument.documentTemplate && oneDocument.documentTemplate.requiredOnPrem

        //if module is claimWizard than there always should be only one document template that cant't be removed
        // const requiredOnClaimWizard = oneDocument.documentTemplate && oneDocument.documentTemplate.indexType.lowValue === claimWizardDocType 
        const requiredOnClaimWizard = false

        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        let docIdFieldName = getDynamicFieldNameForDocId(cursor)
        let docOriginFieldName = getDynamicFieldNameForDocOrigin(cursor)
        let docTemplateFieldName = getDynamicFieldNameForDocTemplate(cursor)
        let docLangFieldName = getDynamicFieldNameForDocLang(cursor)
        let docTeamFieldName = getDynamicFieldNameForDocTeam(cursor)
        let docTeamNameFieldName = getDynamicFieldNameForDocTeamName(cursor)
        let docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(cursor)
        let docContractFieldName = getDynamicFieldNameForDocContractNumber(cursor)
        let docContractIdFieldName = getDynamicFieldNameForDocContractId(cursor)
        let docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(cursor)
        let docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(cursor)
        let docClaimIdFieldName = getDynamicFieldNameForDocClaimId(cursor)
        let docClaimNumberFieldName = getDynamicFieldNameForDocClaimNumber(cursor)
        // local upload
        let docTemporaryUploadIdFieldName = getDynamicFieldNameForTemporaryUploadId(cursor)
        let docUploadedFileOriginalNameFieldName = getDynamicFieldNameForDocUploadedFileOriginalName(cursor)
        let docDocumentTypeIdxFieldName = getDynamicFieldNameForDocumentTypeIdx(cursor)
        let docDocumentUploadGroupTypeIdFieldName = getDynamicFieldNameForDocumentUploadGroupTypeId(cursor)
        let docDocumentUploadCommentFieldName = getDynamicFieldNameForUploadComment(cursor)
        // oracle selected
        let docOracleIdFieldName = getDynamicFieldNameForDocOracleId(cursor)
        let docOracleName = getDynamicFieldNameForDocOracleName(cursor)
        let oracleDocumentUploadDate = getDynamicFieldNameForOracleDocumentUploadDate(cursor)
        let docOracleTypeFieldName = getDynamicFieldNameForDocOracleType(cursor)
        let documentSelectionTabFieldName = getDynamicFieldNameForDocSelectionTab(cursor)
        let attachmentConnectionIdFieldName = getDynamicFieldNameAttachmentConnectionId(cursor)
        let isAttachmentFieldName = getDynamicFieldNameIsAttachment(cursor)
        let positionInUploadDocFieldName = getDynamicFieldNamePositionInUploadDoc(cursor)
        let documentSizeFieldName = getDynamicFieldNameForSize(cursor)
        let documentEncryptedFieldName = getDynamicFieldNameForEncrypted(cursor)

        // when no data loaded no render
        if (!formInputs[docOriginFieldName]) {
            return
        }

        // decide what languages to be in the list
        let filteredLanguageOptions = getLanguageOptionsByTemplateId(formInputs[docTemplateFieldName].value, templates, languageOptions)
        let isRequiredContractNumber = (nesProp.get(oneDocument, "documentTemplate.uploadedOnModule") == c.DS_MODULE_CLIENT_CONTRACT)

        // check if team leven is selected and subteam is invalid to disable the template selection
        let disableTemplateSelect = false
        if ((formInputs.team.value === '1' && !formInputs.teamSubgroup.value) || requiredOnPrem) {
            disableTemplateSelect = true
        }

        return (
            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.packageDocumentContainer)} key={oneDocument._id + Math.random()}>
                <input
                    ref={docIdFieldName}
                    name={docIdFieldName}
                    type="hidden"
                    value={formInputs[docIdFieldName].value || ''}
                />
                <input
                    ref={docOriginFieldName}
                    name={docOriginFieldName}
                    type="hidden"
                    value={formInputs[docOriginFieldName].value || ''}
                />
                <div className={cs(stylesDocCss.packageDocumentDetailRow)}>
                    {formInputs[docOriginFieldName].value == DSDocumentOriginTypes.DS_ORIGIN_GENERATED &&
                        <div>
                            <div className={cs(stylesDocCss.row)}>
                                <div className={cs(stylesDocCss.formLabel, stylesDocCss.short1)}>{_('documentTemplate')} </div>
                                <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect, stylesDocCss.short3, stylesDocCss.flexLast)}>

                                    <CustomSelect
                                        value={requiredOnPrem ? { label: oneDocument.documentTemplate.title[lang], value: formInputs[docTemplateFieldName].value }
                                            : findItemByValueFromSelectOptions(formInputs[docTemplateFieldName].value, documentTemplateOptions) || ""}
                                        ref={docTemplateFieldName}
                                        name={docTemplateFieldName}
                                        onChange={async (value) => {
                                            if (nesProp.get(oneDocument, "brokerFilledValues")) {
                                                return this.setState({
                                                    isOpenAreYouSure: {
                                                        title: _('areYouSureModalTitle'),
                                                        message: _('areYouSureToChangeDocumentTemplate'),
                                                        callBackCancel: () => { },
                                                        callBackOk: async () => {
                                                            // to be shown the error message on validation
                                                            formInputs["hasObligatedTarificationTemplate"].touched = true
                                                            formInputs["hasObligatedMandateTemplate"].touched = true

                                                            let resultOfChange = await this.onChangeTemplateForDoc(
                                                                value,
                                                                docTemplateFieldName,
                                                                packageDSDocuments,
                                                                formInputs,
                                                                oneDocument.cursor
                                                            )

                                                            return resultOfChange
                                                        }
                                                    }
                                                })
                                            } else {
                                                // to be shown the error message on validation
                                                formInputs["hasObligatedTarificationTemplate"].touched = true
                                                formInputs["hasObligatedMandateTemplate"].touched = true

                                                let resultOfChange = await this.onChangeTemplateForDoc(
                                                    value,
                                                    docTemplateFieldName,
                                                    packageDSDocuments,
                                                    formInputs,
                                                    oneDocument.cursor
                                                )

                                                return resultOfChange
                                            }
                                        }}
                                        handleOnBlur={(e) => { }}
                                        options={documentTemplateOptions}
                                        isSearchable
                                        isClearable
                                        isMulti={false}
                                        isCreatableSelect={false}
                                        isDisabled={disableTemplateSelect}
                                    />
                                </div>
                            </div>
                            <div className={cs(stylesDocCss.errorMessageContainer,
                                (formInputs[docTemplateFieldName].touched && formInputs[docTemplateFieldName].error) ? "" : stylesDocCss.none
                            )}>
                                <div className={stylesDocCss.errorMessage}>
                                    {formInputs[docTemplateFieldName].error && formInputs[docTemplateFieldName].touched &&
                                        formInputs[docTemplateFieldName].error}
                                </div>
                            </div>

                            <div className={stylesDocCss.row}>
                                <label className={stylesDocCss.formLabel}>{_('documentLanguage')} </label>
                                <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                    <CustomSelect
                                        value={findItemByValueFromSelectOptions(formInputs[docLangFieldName].value, languageOptions) || ""}
                                        ref={docLangFieldName}
                                        name={docLangFieldName}
                                        onChange={(value) => {
                                            if (nesProp.get(oneDocument, "brokerFilledValues")) {
                                                return this.setState({
                                                    isOpenAreYouSure: {
                                                        title: _('areYouSureModalTitle'),
                                                        message: _('areYouSureToChangeDocumentLanguage'),
                                                        callBackCancel: () => { },
                                                        callBackOk: () => {
                                                            this.onChangeLanguageForDoc(value, docLangFieldName, packageDSDocuments, formInputs, oneDocument.cursor)
                                                        }
                                                    }
                                                })
                                            } else {
                                                return this.onChangeLanguageForDoc(value, docLangFieldName, packageDSDocuments, formInputs, oneDocument.cursor)
                                            }
                                        }}
                                        handleOnBlur={(e) => { }}
                                        options={filteredLanguageOptions}
                                        isSearchable
                                        isClearable
                                        isMulti={false}
                                        isCreatableSelect={false}
                                        isDisabled={false}
                                    />
                                </div>

                            </div>
                            <div className={cs(stylesDocCss.errorMessageContainer,
                                (formInputs[docLangFieldName].touched && formInputs[docLangFieldName].error) ? "" : stylesDocCss.none
                            )}>
                                <div className={stylesDocCss.errorMessage}>
                                    {formInputs[docLangFieldName].error && formInputs[docLangFieldName].touched &&
                                        formInputs[docLangFieldName].error}
                                </div>
                            </div>
                        </div>}

                    {formInputs[docOriginFieldName].value == DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD &&
                        <div className={stylesDocCss.row}>
                            <label className={stylesDocCss.formLabel}>{_('documentPdfName')} </label>

                            <div className={cs(stylesDocCss.formInput, stylesDocCss.short3)}>
                                <input
                                    ref={docLangFieldName}
                                    name={docLangFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[docLangFieldName].value || ""}
                                />
                                <input
                                    ref={docTemporaryUploadIdFieldName}
                                    name={docTemporaryUploadIdFieldName}
                                    type="hidden"
                                    value={formInputs[docTemporaryUploadIdFieldName].value || ""}
                                />
                                <input
                                    ref={docDocumentTypeIdxFieldName}
                                    name={docDocumentTypeIdxFieldName}
                                    type="hidden"
                                    value={formInputs[docDocumentTypeIdxFieldName].value || ""}
                                />
                                <input
                                    ref={docDocumentUploadGroupTypeIdFieldName}
                                    name={docDocumentUploadGroupTypeIdFieldName}
                                    type="hidden"
                                    value={formInputs[docDocumentUploadGroupTypeIdFieldName].value || ""}
                                />
                                <input
                                    ref={docDocumentUploadCommentFieldName}
                                    name={docDocumentUploadCommentFieldName}
                                    type="hidden"
                                    value={formInputs[docDocumentUploadCommentFieldName].value || ""}
                                />
                                <input
                                    ref={docUploadedFileOriginalNameFieldName}
                                    name={docUploadedFileOriginalNameFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[docUploadedFileOriginalNameFieldName].value || ""}
                                />
                                {formInputs[docUploadedFileOriginalNameFieldName].value || ""}
                            </div>
                        </div>}

                    {formInputs[docOriginFieldName].value == DSDocumentOriginTypes.DS_ORIGIN_ORACLE &&
                        <div className={stylesDocCss.row}>
                            <label className={stylesDocCss.formLabel}>{_('documentOracle')} </label>
                            <div className={cs(stylesDocCss.formInput, stylesDocCss.short3)}>
                                <input
                                    ref={docLangFieldName}
                                    name={docLangFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[docLangFieldName].value || ""}
                                />
                                <input
                                    ref={docOracleIdFieldName}
                                    name={docOracleIdFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[docOracleIdFieldName].value || ""}
                                />
                                <input
                                    ref={docOracleTypeFieldName}
                                    name={docOracleTypeFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[docOracleTypeFieldName].value}
                                />
                                <input
                                    ref={documentSelectionTabFieldName}
                                    name={documentSelectionTabFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[documentSelectionTabFieldName].value}
                                />
                                <input
                                    ref={attachmentConnectionIdFieldName}
                                    name={attachmentConnectionIdFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[attachmentConnectionIdFieldName].value}
                                />
                                <input
                                    ref={isAttachmentFieldName}
                                    name={isAttachmentFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[isAttachmentFieldName].value}
                                />
                                <input
                                    ref={positionInUploadDocFieldName}
                                    name={positionInUploadDocFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[positionInUploadDocFieldName].value}
                                />
                                <input
                                    ref={docOracleName}
                                    name={docOracleName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[docOracleName].value}
                                />
                                <input
                                    ref={documentEncryptedFieldName}
                                    name={documentEncryptedFieldName}
                                    type="hidden"
                                    disabled
                                    value={formInputs[documentEncryptedFieldName].value}
                                />
                                <input
                                    ref={oracleDocumentUploadDate}
                                    name={oracleDocumentUploadDate}
                                    type="hidden"
                                    disabled
                                    value={formInputs[oracleDocumentUploadDate].value}
                                />
                                <span>
                                    {formInputs[docOracleName].value || ""}
                                </span>
                            </div>
                        </div>
                    }
                    <input
                        ref={docClaimIdFieldName}
                        name={docClaimIdFieldName}
                        type="hidden"
                        value={formInputs[docClaimIdFieldName].value}
                    />
                    <input
                        ref={docClaimNumberFieldName}
                        name={docClaimNumberFieldName}
                        type="hidden"
                        value={formInputs[docClaimNumberFieldName].value}
                    />
                    <input
                        ref={documentSizeFieldName}
                        name={documentSizeFieldName}
                        type="hidden"
                        disabled
                        value={formInputs[documentSizeFieldName].value}
                    />
                    <div className={stylesDocCss.row}>
                        <span>
                            {_('documentSize')} {(Math.ceil(Number((oneDocument.fileSize / 1024) / 1024) * 100) / 100).toFixed(2)} {_('megabytes')}
                        </span>
                    </div>
                    <div className={cs(stylesDocCss.errorMessageContainer,
                        (formInputs[documentSizeFieldName].error) ? "" : stylesDocCss.none
                    )}>
                        <div className={stylesDocCss.errorMessage}>
                            {formInputs[documentSizeFieldName].error &&
                                formInputs[documentSizeFieldName].error}
                        </div>
                    </div>

                    <div className={cs(stylesDocCss.errorMessageContainer,
                        (formInputs[documentEncryptedFieldName].error) ? "" : stylesDocCss.none
                    )}>
                        <div className={stylesDocCss.errorMessage}>
                            {formInputs[documentEncryptedFieldName].error &&
                                formInputs[documentEncryptedFieldName].error}
                        </div>
                    </div>
                    {/*<div className={cs(stylesDocCss.errorMessageContainer,
                        (formInputs[docTemporaryUploadIdFieldName].touched && formInputs[docTemporaryUploadIdFieldName].error) ? "" : stylesDocCss.none
                    )}>
                        <div className={stylesDocCss.errorMessage}>
                            {formInputs[docTemporaryUploadIdFieldName].error && formInputs[docTemporaryUploadIdFieldName].touched &&
                                formInputs[docTemporaryUploadIdFieldName].error}
                        </div>
                    </div>*/}

                    {(isRequiredContractNumber || isPrem) &&
                        <div className={cs(stylesDocCss.row)}>
                            <label className={stylesDocCss.formLabel}>
                                {!isPrem ? _('contractNumber') : _('premContractNumber')}:
                            </label>
                            {!isPrem ?
                                (formInputs[docContractFieldName].value ? formInputs[docContractFieldName].value : _("selectContractNumberLater"))
                                :
                                (packageInstance && packageInstance.contractNumber ? packageInstance.contractNumber : _("selectContractNumberLater"))
                            }
                        </div>
                    }

                    {isRequiredTarification &&
                        <input
                            ref={docTeamFieldName}
                            name={docTeamFieldName}
                            type="hidden"
                            value={formInputs[docTeamFieldName].value}
                        />
                    }
                    {isRequiredTarification &&
                        <input
                            ref={docTeamNameFieldName}
                            name={docTeamNameFieldName}
                            type="hidden"
                            value={formInputs[docTeamNameFieldName].value}
                        />
                    }

                    <input
                        ref={docContractFieldName}
                        name={docContractFieldName}
                        type="hidden"
                        value={formInputs[docContractFieldName].value}
                    />
                    <input
                        ref={docContractIdFieldName}
                        name={docContractIdFieldName}
                        type="hidden"
                        value={formInputs[docContractIdFieldName].value}
                    />
                    <input
                        ref={docTarificationIdFieldName}
                        name={docTarificationIdFieldName}
                        type="hidden"
                        value={formInputs[docTarificationIdFieldName].value}
                    />
                    <input
                        ref={docTarificationNumberFieldName}
                        name={docTarificationNumberFieldName}
                        type="hidden"
                        value={formInputs[docTarificationNumberFieldName].value}
                    />
                </div>


                <div className={cs(stylesDocCss.operationsRow)}>
                    {!packageDSDocuments || packageDSDocuments.length === 1 || requiredOnPrem || requiredOnClaimWizard ?
                        <div className={cs(stylesDocCss.onlyInfo)}>
                            {_("canNotRemoveThisDocument")}
                        </div>
                        :
                        <div className={cs(stylesDocCss.cancel, stylesDocCss.removeDocumentBtn)}
                            onClick={(e) => {
                                this.setState({
                                    isOpenAreYouSure: {
                                        title: _('areYouSureModalTitle'),
                                        message: _('areYouSureToRemoveDocument'),
                                        callBackCancel: () => { },
                                        callBackOk: async () => {

                                            //check if the document is generated and has documents attached and remove those to, 
                                            //also create a empty generated doc if there are no docs left in package 

                                            if (oneDocument && !oneDocument.isAttachment) {
                                                const attachedDocumentsToRemove = packageDSDocuments.filter(oneDsDoc =>
                                                    oneDsDoc.attachmentConnectionId === oneDocument.attachmentConnectionId && oneDsDoc.cursor !== oneDocument.cursor)
                                                for (const oneDocToRemove of attachedDocumentsToRemove) {
                                                    await this.onRemoveDocument(oneDocToRemove.cursor, formInputs, packageDSDocuments, false)
                                                }
                                                await this.onRemoveDocument(oneDocument.cursor, formInputs, packageDSDocuments, true)

                                                if (packageDSDocuments.length === 0) {
                                                    await this.onClickAddGeneratedDocument()
                                                }

                                            } else {

                                                this.onRemoveDocument(oneDocument.cursor, formInputs, packageDSDocuments)
                                            }
                                        }
                                    }
                                })
                            }}>
                            {_("removeDocument")}
                        </div>}
                </div>
            </div>
        )
    }

    /**
     * This function will handle the on contract change in MIFID wizard step #1.
     * This will update the broker information also in the state.
     * Update form data in state also related with contractNumber.
     * @param {*} newContractId
     * @param {*} newContractNumber
     * @param {*} formInputs
     */
    async handleChangeContractNumber(newContractId, newContractNumber, formInputs) {
        const { dispatch, brokers } = this.props

        // get detailed contract data to know to predefine the broker data
        let resultContract = await dispatch(fetchClientContract(newContractId))

        let brokerNumber = nesProp.get(resultContract, "response.contractDetails.brokerNumber")
        let brokerInfo = getBrokerFullInfoByNumber(brokerNumber, brokers)
        let brokerEmailAddress = nesProp.get(brokerInfo, "main.emails.0")
        let brokerName = nesProp.get(brokerInfo, "main.name")

        nesProp.set(formInputs, "brokerName.value", brokerName)
        nesProp.set(formInputs, "brokerEmailAddress.value", brokerEmailAddress)
        nesProp.set(formInputs, "brokerNumber.value", brokerNumber)
        nesProp.set(formInputs, "contractNumber.value", newContractNumber || "")

        return formInputs
    }

    /**
    * On change event handler for Remainder Interval
    * @param {*} value
    * @returns
    */
    onChangeRemainderInterval(value) {
        const { formInputs } = this.state
        let rawValue = nesProp.get(value, "value")

        // check if the remainders interval is set to 0, need to be set to 0 the repeats and disable the repeat field
        if (parseInt(rawValue) === 0) {
            formInputs['remainderRepeats'].value = '0'
        } else {
            if (formInputs['remainderRepeats'].value == '0') {
                formInputs['remainderRepeats'].value = '1'
            }
        }

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                rawValue || "",
                "remainderInterval"
            )
        })
    }

    /**
    * On change event handler for Remainder Ticket Interval
    * @param {*} value
    * @returns
    */
    onChangeRemainderTicketInterval(value) {
        const { formInputs } = this.state
        let rawValue = nesProp.get(value, "value")

        // check if the remainders interval is set to 0, need to be set to 0 the repeats and disable the repeat field
        if (parseInt(rawValue) === 0) {
            formInputs['remainderTicketRepeats'].value = '0'
        } else {
            if (formInputs['remainderTicketRepeats'].value == '0') {
                formInputs['remainderTicketRepeats'].value = '1'
            }
        }

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                rawValue || "",
                "remainderTicketInterval"
            )
        })
    }

    /**
    * On change event handler for first signer phone number
    * @param {*} value
    * @param {*} forceTouch
    * @returns
    */
    onChangeFirstSignerPhoneNumber(value, forceTouch = null) {
        const { formInputs, clientGSMPhoneNumbers, brokerGSMPhoneNumbers } = this.state
        const { isOffice } = this.props
        let rawValue = nesProp.get(value, "value")

        // handle phone number change to display any country codes associated with selected phone number
        const phoneNumbers = isOffice ? brokerGSMPhoneNumbers : clientGSMPhoneNumbers
        const selectedGSMPhoneNumber = phoneNumbers.find(elem => (elem.value === rawValue))
        formInputs['firstSignerCountryPhoneCode'].value =
            selectedGSMPhoneNumber ? selectedGSMPhoneNumber.countryCode : formInputs['firstSignerCountryPhoneCode'].value

        if (formInputs['firstSignerCountryPhoneCode'].value != '+32') {
            formInputs['firstSignerPhoneNumber'].isValid = () => true
        } else {
            formInputs['firstSignerPhoneNumber'].isValid = (value) => (value[0] == '0' ? value.length === 10 : value.length === 9)
        }

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                rawValue || "",
                "firstSignerPhoneNumber",
                forceTouch
            )
        })
    }

    /**
   * On change event handler for first signer phone number country code
   * @param {*} value
   * @param {*} forceTouch
   * @returns
   */
    onChangeFirstSignerCountryCode(val, forceTouch = null) {
        const { formInputs, countryPhoneCodes } = this.state

        let value = ''

        const countryCodeIndex = countryPhoneCodes.findIndex(oneCode => oneCode.value === val)
        if (countryCodeIndex > -1) {
            value = countryPhoneCodes[countryCodeIndex].value
        }

        if (value === '+32') {
            formInputs['firstSignerPhoneNumber'].isValid = (value) => (value[0] == '0' ? value.length === 10 : value.length === 9)
        } else {
            formInputs['firstSignerPhoneNumber'].isValid = () => true
        }
        const firstSignerPhoneNumberValidation = fieldValidation(formInputs['firstSignerPhoneNumber'])
        nesProp.set(formInputs, 'firstSignerPhoneNumber', firstSignerPhoneNumberValidation)

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                value || "",
                "firstSignerCountryPhoneCode",
                forceTouch
            )
        })
    }

    /**
   * On change event handler for second signer phone number
   * @param {*} value
   * @param {*} forceTouch
   * @returns
   */
    onChangeSecondSignerPhoneNumber(value, forceTouch = false) {
        const { formInputs } = this.state

        if (formInputs['secondSignerCountryPhoneCode'].value != '+32') {
            formInputs['secondSignerPhoneNumber'].isValid = () => true
        } else {
            formInputs['secondSignerPhoneNumber'].isValid = (value) => (value[0] == '0' ? value.length === 10 : value.length === 9)
        }

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                value || "",
                "secondSignerPhoneNumber",
                forceTouch
            )
        })
    }

    /**
   * On change event handler for second signer phone number country code
   * @param {*} value
   * @param {*} forceTouch
   * @returns
   */
    onChangeSecondSignerCountryCode(val, forceTouch = false) {
        const { formInputs, countryPhoneCodes } = this.state

        let value = ''

        const countryCodeIndex = countryPhoneCodes.findIndex(oneCode => oneCode.value === val)
        if (countryCodeIndex > -1) {
            value = countryPhoneCodes[countryCodeIndex].value
        }

        if (value === '+32') {
            formInputs['secondSignerPhoneNumber'].isValid = (value) => (value[0] == '0' ? value.length === 10 : value.length === 9)
        } else {
            formInputs['secondSignerPhoneNumber'].isValid = () => true
        }
        const secondSignerPhoneNumberValidation = fieldValidation(formInputs['secondSignerPhoneNumber'])
        nesProp.set(formInputs, 'secondSignerPhoneNumber', secondSignerPhoneNumberValidation)

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                value || "",
                "secondSignerCountryPhoneCode",
                forceTouch
            )
        })
    }

    /**
    * On change event handler for broker signer phone number
    * @param {*} value
    * @param {*} forceTouch
    * @returns
    */
    onChangeBrokerSignerPhoneNumber(value, forceTouch = null) {
        const { formInputs, brokerGSMPhoneNumbers } = this.state
        let rawValue = nesProp.get(value, "value")

        // handle phone number change to display any country codes associated with selected phone number
        const selectedGSMPhoneNumber = brokerGSMPhoneNumbers.find(elem => (elem.value === rawValue))
        formInputs['brokerSignerCountryPhoneCode'].value =
            selectedGSMPhoneNumber ? selectedGSMPhoneNumber.countryCode : formInputs['brokerSignerCountryPhoneCode'].value

        if (formInputs['brokerSignerCountryPhoneCode'].value != '+32') {
            formInputs['brokerSignerPhoneNumber'].isValid = () => true
        } else {
            formInputs['brokerSignerPhoneNumber'].isValid = (value) => (value[0] == '0' ? value.length === 10 : value.length === 9)
        }
        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                rawValue || "",
                "brokerSignerPhoneNumber",
                forceTouch
            )
        })
    }

    /**
   * On change event handler for broker broker phone number country code
   * @param {*} value
   * @param {*} forceTouch
   * @returns
   */
    onChangeBrokerSignerCountryCode(value, forceTouch = false) {
        const { formInputs } = this.state

        if (value === '+32') {
            formInputs['brokerSignerPhoneNumber'].isValid = (value) => (value[0] == '0' ? value.length === 10 : value.length === 9)
        } else {
            formInputs['brokerSignerPhoneNumber'].isValid = () => true
        }
        const brokerSignerPhoneNumberValidation = fieldValidation(formInputs['brokerSignerPhoneNumber'])
        nesProp.set(formInputs, 'brokerSignerPhoneNumber', brokerSignerPhoneNumberValidation)

        return this.setState({ formInputs: formInputs }, () => {
            return this.onChangeFormInput(
                value || "",
                "brokerSignerCountryPhoneCode",
                forceTouch
            )
        })
    }

    /**
     * This function will reset the tarification and team values for the
     * dsDocument list what are depending on selected broker. Reset form values also
     * @returns
     */
    resetTeamsAndTarificationForAllDocuments(packageDSDocuments, formInputs) {
        // reset package team/tarification information
        formInputs = this.onChangeFormInput("", "team", null, null, formInputs)
        formInputs = this.onChangeFormInput("", "teamName", null, null, formInputs)
        formInputs = this.onChangeTeamSubGroupHandler("", formInputs)
        formInputs = this.onChangeFormInput("", "tarificationId", null, null, formInputs)
        formInputs = this.onChangeFormInput("", "tarificationNumber", null, null, formInputs)

        // reset documents level team and tarification information
        if (!packageDSDocuments) {
            return { packageDSDocuments, formInputs }
        }

        packageDSDocuments.forEach((oneDocument, index) => {
            nesProp.set(packageDSDocuments, index + ".documentTemplateId", "")
            nesProp.set(packageDSDocuments, index + ".documentTemplate", "")
            nesProp.set(packageDSDocuments, index + ".team", "")
            nesProp.set(packageDSDocuments, index + ".teamName", "")
            nesProp.set(packageDSDocuments, index + ".teamSubgroup", "")
            nesProp.set(packageDSDocuments, index + ".tarificationId", "")
            nesProp.set(packageDSDocuments, index + ".tarificationNumber", "")

            let docTemplateFieldName = getDynamicFieldNameForDocTemplate(oneDocument.cursor)
            let docTeamFieldName = getDynamicFieldNameForDocTeam(oneDocument.cursor)
            let docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(oneDocument.cursor)
            let docTeamNameFieldName = getDynamicFieldNameForDocTeamName(oneDocument.cursor)
            let docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(oneDocument.cursor)
            let docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(oneDocument.cursor)

            formInputs = this.onChangeFormInput("", docTemplateFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput("", docTeamFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput("", docTeamNameFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput("", docTeamSubgroupFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput("", docTarificationIdFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput("", docTarificationNumberFieldName, null, null, formInputs)
        })

        return { packageDSDocuments, formInputs }
    }

    /**
     *
     * @param {*} packageDSDocuments
     * @param {*} formInputs
     * @param {*} valueLabelPair
     * @param {*} subGroupValueLabelPair
     * @returns
     */
    setTeamsForAllDocuments(packageDSDocuments, formInputs, valueLabelPair, subGroupValueLabelPair) {
        if (!packageDSDocuments) {
            console.error("No documents added to the package")
            return Promise.reject(new Error("No documents added to the package"))
        }

        let team = nesProp.get(valueLabelPair, "value")
        let teamName = nesProp.get(valueLabelPair, "label")
        let teamSubgroupId = nesProp.get(subGroupValueLabelPair, "value")

        packageDSDocuments.forEach((oneDocument, index) => {
            // set values in state document
            nesProp.set(packageDSDocuments, index + ".team", team)
            nesProp.set(packageDSDocuments, index + ".teamName", teamName)
            nesProp.set(packageDSDocuments, index + ".teamSubgroup", teamSubgroupId)

            // set values in form documents also
            let docTeamFieldName = getDynamicFieldNameForDocTeam(oneDocument.cursor)
            let docTeamNameFieldName = getDynamicFieldNameForDocTeamName(oneDocument.cursor)
            let docTeamSubgroupFieldName = getDynamicFieldNameForDocTeamSubgroup(oneDocument.cursor)
            //let docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(oneDocument.cursor)
            //let docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(oneDocument.cursor)

            // change values for form in sync with state documents
            formInputs = this.onChangeFormInput(team, docTeamFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput(teamName, docTeamNameFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput(teamSubgroupId, docTeamSubgroupFieldName, null, null, formInputs)
        })

        return { packageDSDocuments, formInputs }
    }

    /**
     *
     * @param {*} packageDSDocuments
     * @param {*} valueLabelPair
     * @returns
     */
    async clearTemplateForAllDocuments(packageDSDocuments, formInputs) {
        if (!packageDSDocuments) {
            throw new Error("No documents added to the package")
        }

        for (let i = 0; i < packageDSDocuments.length; i++) {
            let oneDocument = packageDSDocuments[i]

            let docTemplateFieldName = getDynamicFieldNameForDocTemplate(oneDocument.cursor)

            let updatedValuePack = await this.onChangeTemplateForDoc(
                null,
                docTemplateFieldName,
                packageDSDocuments,
                formInputs,
                oneDocument.cursor
            )

            packageDSDocuments = updatedValuePack.packageDSDocuments,
                formInputs = updatedValuePack.formInputs
        }

        return {
            packageDSDocuments,
            formInputs
        }
    }

    /**
     * Set tarification information for all the documents in the state and in the form inputs also.
     * Return a promise when the job is done.
     * @param {*} packageDSDocuments
     * @param {*} valueLabelPair
     * @returns Promise
     */
    async setTarificationInfoForAllDocuments(packageDSDocuments, formInputs, tarificationId, tarificationNumber) {
        const { DSDocumentOriginTypes } = this.props

        if (!packageDSDocuments) {
            return packageDSDocuments
        }

        packageDSDocuments.forEach((oneDocument, index) => {
            let isRequiredTarification = false

            if (oneDocument.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED &&
                oneDocument.subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION) {
                // UPLOADED ORACLE DOCUMENTS CASE
                isRequiredTarification = true

            } else {
                // GENERATED DOCUMENTS CASE
                isRequiredTarification = (
                    nesProp.get(oneDocument, "documentTemplate.uploadedOnModule") == c.DS_MODULE_CLIENT_TARIFICATION &&
                    nesProp.get(oneDocument, "subModuleKey") !== c.DS_MODULE_CLIENT_TARIFICATION
                )
            }

            // in case when the document don't require tarification number the skip it
            if (!isRequiredTarification) {
                return // skip this step of loop
            }

            // update state documents
            nesProp.set(packageDSDocuments, index + ".tarificationId", tarificationId)
            nesProp.set(packageDSDocuments, index + ".tarificationNumber", tarificationNumber)

            // update form values for the documents
            let docTarificationIdFieldName = getDynamicFieldNameForDocTarificationId(oneDocument.cursor)
            let docTarificationNumberFieldName = getDynamicFieldNameForDocTarificationNumber(oneDocument.cursor)
            formInputs = this.onChangeFormInput(tarificationId, docTarificationIdFieldName, null, null, formInputs)
            formInputs = this.onChangeFormInput(tarificationNumber, docTarificationNumberFieldName, null, null, formInputs)
        })


        // return a promise when everything is updated
        return { packageDSDocuments, formInputs }
    }

    /**
     *
     * @param {*} value - the event of the input on onchange
     * @returns
     */
    onChangeBrokerNumberHandler(value) {
        let { templates, lang, clientOptionsDict, brokersTeamWhiteList, moduleKeyFromProps, subModuleKey, brokers, userId,
            DSDocumentOriginTypes, userFirstName, userLastName, userPhoneNumber, claimWizardDocType } = this.props
        let { packageDSDocuments, formInputs, showBrokerSigner, countryPhoneCodes, stakeholders } = this.state

        // fetch selected brokerNumber from input event
        let selectedValue = nesProp.get(value, "value") || ""

        // update broker email list in state
        let brokerEmailOptions = getBrokerEmailsInOptionList(selectedValue, brokers, userId)

        // reset the broker fields
        // select the first available broker email address, to be selected
        let firstBrokerEmailAddress = nesProp.get(brokerEmailOptions, "0.value")
        // change the form input of the broker email address
        this.onChangeFormInput(firstBrokerEmailAddress, "brokerEmailAddress")

        // reset team options
        let teamsOptions = getTeamsOptionList(clientOptionsDict, lang)
        teamsOptions = filterTeamsForBroker(teamsOptions, brokersTeamWhiteList, selectedValue)

        // recalculate the template options by broker white lists and template white list match
        const moduleKeyFromState = nesProp.get(this, "state.moduleKey")
        const subModuleKeyFromState = nesProp.get(this, "state.subModuleKey")
        let moduleKey = moduleKeyFromState || moduleKeyFromProps
        let subModuleKeyCalculated = subModuleKeyFromState || subModuleKey

        // reset the template list
        let documentTemplateOptions = getDocumentTemplateOptionList(templates, lang, moduleKey, subModuleKeyCalculated, false, claimWizardDocType)
        if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKeyCalculated == c.DS_MODULE_CLIENT_TARIFICATION) {
            documentTemplateOptions = filterTemplatesForBroker(
                documentTemplateOptions, brokersTeamWhiteList, selectedValue, false, false
            )
        }

        // fetch the full info about the broker using the brokerNumber
        let brokerInfo = getBrokerFullInfoByNumber(selectedValue, brokers)
        // fetch the broker name to set it in the form values
        let brokerName = nesProp.get(brokerInfo, "main.name")

        // update brokerName form input
        formInputs = this.onChangeFormInput(brokerName, "brokerName", null, null, formInputs)

        let requireSmsOtpSigningResult = requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes)

        const brokerSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerType === "BROKER")

        formInputs = resetBrokerSignerRelatedFields(brokerSigningStakeholder, formInputs, brokerInfo, lang, countryPhoneCodes,
            showBrokerSigner, requireSmsOtpSigningResult, userFirstName, userLastName, userPhoneNumber)

        // reset the state stored documents tarification and team values
        let resultOfReset = this.resetTeamsAndTarificationForAllDocuments(packageDSDocuments, formInputs)
        packageDSDocuments = resultOfReset.packageDSDocuments
        formInputs = resultOfReset.formInputs


        // generate dynamic list of the fields for documents
        let freshDocumentsInputList = getFlatValueListOfDsDocumentsForForm(packageDSDocuments, documentTemplateOptions)
        formInputs = patchFormInputValuesByValueList(formInputs, freshDocumentsInputList)

        // finally change the form input value for the broker number also
        formInputs = this.onChangeFormInput(selectedValue, "brokerNumber", null, null, formInputs)

        // update the state with the processed values after brokerNumber input change
        this.setState({
            formInputs,
            brokerEmailOptions,
            teamsOptions,
            documentTemplateOptions,
            packageDSDocuments
        })

        return formInputs
    }
    /**
     * Handle OnChange event for teamSubgroups on package level
     * @param {*} valueToSetForSubGroup
     * @param {*} formInputs
     * @returns
     */
    onChangeTeamSubGroupHandler(valueToSetForSubGroup, formInputs) {
        let formFieldName = "teamSubgroup"
        //get the object from state to be able to set the validity value in it.
        let formField = nesProp.get(formInputs, formFieldName)

        // set the value
        formField.value = valueToSetForSubGroup

        //check if team is leven and set the subTeam as required
        const teamField = nesProp.get(formInputs, 'team')
        if (teamField.value && parseInt(teamField.value) === 1) {
            formField.isRequired = true
        } else {
            formField.isRequired = false
        }

        nesProp.set(formInputs, formFieldName, formField)

        formInputs = this.onChangeFormInput(valueToSetForSubGroup, formFieldName, null, null, formInputs)

        return formInputs
    }

    /**
     * This is a handler for onChange the team of package
     * @param {*} value
     * @returns
     */
    async onChangeTeamHandler(teamValue, teamSubgroupValue, packageDSDocuments, formInputs) {
        let { teamsOptions, teamSubgroupsOptions, moduleKey, subModuleKey } = this.state
        let { templates, lang, brokersTeamWhiteList, claimWizardDocType } = this.props

        let selectedTeamValue = nesProp.get(teamValue, "value") || ""
        let selectedTeamSubgroupValue = nesProp.get(teamSubgroupValue, "value") || ""
        let brokerNumber = nesProp.get(formInputs, "brokerNumber.value")
        let teamOptionItem = findItemByValueFromSelectOptions(selectedTeamValue, teamsOptions)
        let teamSubgroupOptionItem = findItemByValueFromSelectOptions(selectedTeamSubgroupValue, teamSubgroupsOptions)
        let documentTemplateOptions = getDocumentTemplateOptionList(templates, lang, moduleKey, subModuleKey, false, claimWizardDocType)

        // if the main tarification module (overview) is opened, then filter the templates
        if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION) {
            documentTemplateOptions = filterTemplatesForBroker(
                documentTemplateOptions, brokersTeamWhiteList, brokerNumber, selectedTeamValue, selectedTeamSubgroupValue
            )
        }

        // first of all we must refilter the template list after the new selected team
        // reset the state stored documents tarification and team values, in the form also
        let result = this.setTeamsForAllDocuments(packageDSDocuments, formInputs, teamOptionItem, teamSubgroupOptionItem)

        formInputs = result.formInputs
        packageDSDocuments = result.packageDSDocuments

        formInputs = this.onChangeFormInput(teamOptionItem.label, "teamName", null, null, formInputs)
        formInputs = this.onChangeFormInput(selectedTeamValue, "team", null, null, formInputs)

        // when the team is not LEVEN the clear the subgroups
        let valueToSetForSubGroup = selectedTeamSubgroupValue
        if (parseInt(selectedTeamValue) !== 1) {
            valueToSetForSubGroup = ""
        }

        formInputs = this.onChangeTeamSubGroupHandler(valueToSetForSubGroup, formInputs)

        let resultClear = await this.clearTemplateForAllDocuments(packageDSDocuments, formInputs)

        formInputs = resultClear.formInputs
        packageDSDocuments = resultClear.packageDSDocuments

        // generate dynamic list of the fields for documents
        let freshDocumentsInputList = getFlatValueListOfDsDocumentsForForm(packageDSDocuments, documentTemplateOptions)
        formInputs = patchFormInputValuesByValueList(formInputs, freshDocumentsInputList)

        this.setState({
            formInputs,
            packageDSDocuments,
            documentTemplateOptions
        })

        return {
            formInputs,
            packageDSDocuments,
            documentTemplateOptions
        }
    }

    /**
     * This function will toggle show the second signer fields and set or reset values
     *
     * @param {*} formInputs
     * @param {*} packageDSDocuments
     * @param {*} forceShow
     * @returns
     */
    toggleShowSecondSigner(formInputs, packageDSDocuments, forceShow = null) {
        const { DSDocumentOriginTypes } = this.props
        const { showSecondSigner } = this.state
        const requireSmsOtpSigningResult = requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes)

        // toggle
        let show = !showSecondSigner

        if (forceShow !== null) {
            show = forceShow
        }

        formInputs = showSecondSignerFields(formInputs, show, requireSmsOtpSigningResult)

        return { showSecondSigner: show, formInputs }
    }

    /**
     * This function will toggle show the second signer fields and set or reset values
     *
     * @param {object} formInputs {name1: {input props ...}, name2: {input props ...},...}
     * @param {array} packageDSDocuments array[ <dsdocument record>, ... ]
     * @param {object} brokerSigningStakeholder stakeholder mongo record
     * @param {boolean} forceShow
     * @returns
     */
    toggleShowBrokerSigner(formInputs, packageDSDocuments, brokerSigningStakeholder, forceShow = null) {
        const { DSDocumentOriginTypes, lang, brokers, userFirstName, userLastName, userPhoneNumber } = this.props
        const { showBrokerSigner, countryPhoneCodes } = this.state
        const requireSmsOtpSigningResult = requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes)

        let selectedBroker = formInputs["brokerNumber"].value

        // fetch the full info about the broker using the brokerNumber
        let brokerInfo = getBrokerFullInfoByNumber(selectedBroker, brokers)

        let toggledShowBrokerSigner = !showBrokerSigner

        if (forceShow !== null) {
            toggledShowBrokerSigner = forceShow
        }

        formInputs = resetBrokerSignerRelatedFields(brokerSigningStakeholder, formInputs, brokerInfo, lang, countryPhoneCodes,
            toggledShowBrokerSigner, requireSmsOtpSigningResult, userFirstName, userLastName, userPhoneNumber)

        return { showBrokerSigner: toggledShowBrokerSigner, formInputs }
    }


    // function to handle the attached documents
    async handleDocsAttachedToGeneratedTemplates(packageDSDocuments, index, formInputs, selectedTemplateRecord, dynamicFieldIdCursor) {
        const { dispatch } = this.props
        const { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem, languageOptions,
            documentTemplateOptions, stakeholders } = this.state
        const generatedDocument = packageDSDocuments[index]
        const language = generatedDocument.language
        const documentsFromAttachment = []
        const team = nesProp.get(formInputs, "team.value")
        const teamName = nesProp.get(formInputs, "teamName.value")
        const teamSubgroup = nesProp.get(formInputs, "teamSubgroup.value")

        //extract attached documents to the selected template
        if (selectedTemplateRecord && selectedTemplateRecord.additionalAttachments && selectedTemplateRecord.additionalAttachments.length > 0) {
            for (const oneAttachment of selectedTemplateRecord.additionalAttachments) {
                const documents = oneAttachment.documents.filter(oneDocument => oneDocument.language === language)
                if (documents) {

                    for (let i = 0; i < documents.length; i++) {
                        documents[i].document.sourceTemplateId = generatedDocument.documentTemplateId
                        documents[i].document.uploadType = 'attachment'
                        documents[i].document.positionInUploadDoc = oneAttachment.positionInUploadDoc
                        documentsFromAttachment.push(documents[i].document)
                    }
                }
            }
        }

        //create local files from attached files on the server
        if (documentsFromAttachment && documentsFromAttachment.length > 0) {
            const documentsFromAttachmentResult = await dispatch(createLocalUploadFilesFromAttachments(documentsFromAttachment))
            const docsWithError = []
            const docsToAdd = []

            //separate the success from fails
            if (documentsFromAttachmentResult && documentsFromAttachmentResult.length > 0) {
                for (const oneDocumentRes of documentsFromAttachmentResult) {
                    if (oneDocumentRes.isError) {
                        docsWithError.push(oneDocumentRes)
                    } else {
                        docsToAdd.push(oneDocumentRes)
                        // await this.onSelectLocalDocument(oneDocumentRes.temporaryFileRecord)

                        // okayRes.push(oneDocumentRes)/
                    }
                }
            }

            //add okay documents to dswizard
            if (docsToAdd) {

                for (const oneDocToAdd of docsToAdd) {
                    const docRecord = oneDocToAdd.temporaryFileRecord
                    docRecord.attachmentConnectionId = generatedDocument.attachmentConnectionId
                    docRecord.isAttachment = true
                    docRecord.positionInUploadDoc = oneDocToAdd.positionInUploadDoc

                    const createDocResult = await this.createDSDocumentForPackage(
                        packageDSDocuments,
                        language,
                        { team, teamName, teamSubgroup },
                        dynamicFieldIdCursor,
                        languageOptions,
                        documentTemplateOptions,
                        { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem },
                        docRecord
                    )
                    formInputs = {
                        ...formInputs,
                        ...createDocResult.documentFormInputs
                    }

                    packageDSDocuments = createDocResult.packageDSDocuments
                    formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)
                    dynamicFieldIdCursor = createDocResult.dynamicFieldIdCursor
                }
            }

            if (docsWithError && docsWithError.length > 0) {
                this.setState({ templateAttachmentDocumentsError: docsWithError })
            }
        }

        return { packageDSDocuments, formInputs, dynamicFieldIdCursor }
    }

    /**
     * Function is used when user uploads local documents from his computer or when user selects a generated template with attached pdf's that will be
     *  treated from this pont as local uploads except automatic removal when the liked generated document is removed 
     * @param {*} document - must contains a document that was uploaded by user or added automatically by the createLocalUploadFilesFromAttachments
     * and exists physically on server
     */
    async onSelectLocalDocument(document) {
        let { DSDocumentOriginTypes, claimWizardDocType } = this.props
        let { formInputs, packageDSDocuments, isValidTheForm, dynamicFieldIdCursor, moduleKey, subModuleKey, stakeholders,
            languageOptions, documentTemplateOptions, contractId, tarificationId, tarificationNumber, isPrem,
            signerAvailabilityOfTemplates, claimId, claimNumber } = this.state

        if (!document || document.length == 0) {
            console.warn("No local documents provided for wizard by selector popup.")
            return
        }

        // if this claimWizard module force a document type from claimWizardDocType
        if (claimWizardDocType && moduleKey === 'DS_MODULE_CLAIM_WIZARD') {
            document.lowValue = claimWizardDocType
        }

        let clientLanguage = nesProp.get(formInputs, "clientLanguage.value")
        let team = nesProp.get(formInputs, "team.value")
        let teamName = nesProp.get(formInputs, "teamName.value")
        let teamSubgroup = nesProp.get(formInputs, "teamSubgroup.value")

        let result = await this.createDSDocumentForPackage(
            packageDSDocuments,
            clientLanguage,
            { team, teamName, teamSubgroup },
            dynamicFieldIdCursor,
            languageOptions,
            documentTemplateOptions,
            { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem },
            document
        )

        formInputs = {
            ...formInputs,
            ...result.documentFormInputs
        }

        packageDSDocuments = result.packageDSDocuments
        dynamicFieldIdCursor = result.dynamicFieldIdCursor

        // update conditional fields, what are based on another fields vallues
        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)

        // validate individual form inputs
        formInputs = formInputsValidation(formInputs)

        // validate the form global conditions, the values what are related
        isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)


        // ++++++++++++ start handle enabled signers list ++++++++++++++
        let addSignersButtonFlags = getSignerAdderButtonsFlags(packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates)
        let isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder
        let isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder
        let isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder
        // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
        // those properties, so don't do that
        //---------------- end handle enabled signers list

        this.setState({
            packageDSDocuments, formInputs, isValidTheForm, dynamicFieldIdCursor,
            isItExistFirstSignerPlaceholder,
            isItExistSecondSignerPlaceholder,
            isItExistBrokerSignerPlaceholder
        })

        return {
            packageDSDocuments, formInputs, isValidTheForm
        }
    }

    /**
     * This is an onclick handler for the add document.
     * Create instances, process data and set state of documents and inputs.
     */
    async onClickAddGeneratedDocument() {
        let { DSDocumentOriginTypes } = this.props
        let { formInputs, packageDSDocuments, isValidTheForm, dynamicFieldIdCursor, moduleKey, subModuleKey, stakeholders,
            languageOptions, documentTemplateOptions, contractId, tarificationId, tarificationNumber, isPrem,
            signerAvailabilityOfTemplates, claimId, claimNumber } = this.state

        // add document
        let clientLanguage = nesProp.get(formInputs, "clientLanguage.value")
        let team = nesProp.get(formInputs, "team.value")
        let teamName = nesProp.get(formInputs, "teamName.value")
        let teamSubgroup = nesProp.get(formInputs, "teamSubgroup.value")

        let result = await this.createDSDocumentForPackage(
            packageDSDocuments,
            clientLanguage,
            { team, teamName, teamSubgroup },
            dynamicFieldIdCursor,
            languageOptions,
            documentTemplateOptions,
            { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem }
        )

        formInputs = {
            ...formInputs,
            ...result.documentFormInputs
        }

        packageDSDocuments = result.packageDSDocuments
        dynamicFieldIdCursor = result.dynamicFieldIdCursor

        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)

        formInputs = formInputsValidation(formInputs)
        isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)


        // ++++++++++++ start handle enabled signers list ++++++++++++++
        let addSignersButtonFlags = getSignerAdderButtonsFlags(packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates)
        let isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder
        let isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder
        let isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder
        // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
        // those properties, so don't do that
        //---------------- end handle enabled signers list


        // set state
        this.setState({
            packageDSDocuments, formInputs, isValidTheForm, dynamicFieldIdCursor,
            isItExistFirstSignerPlaceholder, isItExistSecondSignerPlaceholder, isItExistBrokerSignerPlaceholder
        })
    }

    /**
     * Must called after each modification of formInputs
     */
    onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey, forcePackageId = null) {
        let { packageId, clientId } = this.state
        let packageIdFieldName = getPackageIdFieldName()
        let finalPackageId = forcePackageId || packageId || this.props.packageId

        formInputs[packageIdFieldName].value = finalPackageId

        // Minimum one tarification template required with the mark of special template template.
        // literally it is a boolean value in list of properties of a template, can be set in back-office.
        // This is only in case when we are on tarification module
        // Set the flag, what let the form to continue on tarification module.
        // set the flag, what let the form to continue on tarification module.
        formInputs["hasObligatedTarificationTemplate"].value = isATarificationAndHasAMarkedTemplate(moduleKey, packageDSDocuments, subModuleKey)
        formInputs["hasObligatedMandateTemplate"].value = isMandateAndHasAMarkedTemplate(moduleKey, packageDSDocuments, subModuleKey)

        // add OR remove signer related form inputs, depends on what kind of documents are added to de dynamic document list
        formInputs = this.reconstructAndFillSignerFormInputs(formInputs, packageDSDocuments, clientId, finalPackageId, stakeholders) // sync call

        return formInputs
    }

    handleScroll(e) {
        const { forceCloseDatepicker } = this.state
        if (!forceCloseDatepicker) {
            this.setState({ forceCloseDatepicker: true })
        }
    }

    /**
     * This will render the modal content of status explainer in case of error.
     */
    renderDSWizardPopup() {
        let { lang, brokersTeamWhiteList, clientOptionsDict, customModalTitle1, customModalDescriptionStep1, DSDocumentOriginTypes, isOffice, claimWizardDocType } = this.props
        let { moduleKey, subModuleKey, isPrem, showSecondSigner, showBrokerSigner, languageOptions, clientId, contractId, tarificationId,
            claimId } = this.state
        let { isValidTheForm, formInputs, firstSignerEmailAddressOptions, /* contractNumbersOptions ,*/ brokerOptions, brokerEmailOptions,
            remainderIntervalOptions, remainderRepeatsOptions, packageDSDocuments, teamsOptions, teamSubgroupsOptions,
            countryPhoneCodes, clientGSMPhoneNumbers, brokerGSMPhoneNumbers, isItExistFirstSignerPlaceholder,
            isItExistSecondSignerPlaceholder, isItExistBrokerSignerPlaceholder, stakeholders, haveAvailableClaimTemplate, initiatorEmailAddressesFromTemplates } = this.state

        if (!formInputs || Object.keys(formInputs).length === 0 || !packageDSDocuments) {
            return <div>...</div>
        }


        let isRequiredTarification = (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION)
        let isThereABrokerFill = checkDocumentAfterFillIns(packageDSDocuments)
        const { emailServerConfigModalIsOpen, dispatch } = this.props

        const firstSignerGSMPhoneNumber = isOffice ? brokerGSMPhoneNumbers : clientGSMPhoneNumbers

        const requireSmsOtpSigningResult = requireSmsOtpSigning(packageDSDocuments, DSDocumentOriginTypes)

        let formErrorNoGeneratedDoc = false
        if (!isValidTheForm.isValid && isValidTheForm.errors) {
            let error = isValidTheForm.errors.filter(item => item.code === DS_WIZARD_ERROR_CODE_NO_GENERATED_DOC && item.touched)
            if (error && error.length > 0) {
                formErrorNoGeneratedDoc = error[0]
            }
        }

        // ++++++ prepare values for rendering uploader
        let moduleType = getModuleTypeByModuleKey(moduleKey)
        let entityId = getEntityIdByModule(
            getModuleTypeByModuleKey(moduleKey), clientId, contractId, claimId, tarificationId
        )

        // BEWB-511 -> (moduleType !== "tarification")
        // in case when the user is on tarification overview, must show different upload categories than general: BEWB-511
        // In any case when we don't have entityId, lic a contract id oor tarification id, from overview we show a
        // default category list as of the client profile
        if (!entityId && (moduleType !== "tarification")) {
            entityId = clientId
            moduleType = getModuleTypeByModuleKey(c.DS_MODULE_CLIENT_PROFILE)
        }
        // ------ Preparation for uploader END

        const brokerSigningStakeholder = stakeholders && stakeholders.find(stakeholder => stakeholder.signerType === "BROKER")

        // pacakgeInstance if exist we need that
        // find the package instance from the first document of the package
        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        let isClaimsModule = (moduleKey === c.DS_MODULE_CLIENT_CLAIMS)
        const isClaimWizardModule = (moduleKey === c.DS_MODULE_CLAIM_WIZARD)

        return (
            <div className={stylesDocCss.documentsModalContent} key={"mifidStep1"} onWheel={e => this.handleScroll(e)} >
                <span className={stylesDocCss.title} key={"titleSpanKey"}>
                    {isPrem ? _('DSWizardModalTitleMandate') : customModalTitle1 ? customModalTitle1 : _('DSWizardModalTitle')}
                </span>
                <form method="post" onSubmit={(ev) => ev.preventDefault()} className={stylesDocCss.modalFormContent} key={"masterFormKey"}>
                    <span className={stylesDocCss.message}>
                        <div className={stylesDocCss.resendModalContainer}>

                            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)} key={"DSWizardModalDescriptionKey"}>
                                {isPrem ? _('DSWizardModalDescriptionMandate') : customModalDescriptionStep1 ? customModalDescriptionStep1 : _('DSWizardModalDescription')}
                            </div>

                            {!isOffice &&
                                <div className={stylesDocCss.formInputContainer}>
                                    {(formInputs.clientTypeCode === c.CLIENT_TYPE_PERSON) ?
                                        <label className={stylesDocCss.formLabel}>{_('clientName')} </label>
                                        :
                                        <label className={stylesDocCss.formLabel}>{_('clientCompanyName')} </label>
                                    }
                                    <input
                                        className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                        type="text"
                                        value={formInputs.clientName.value}
                                        onChange={(e) => {
                                            return this.onChangeFormInput(e.target.value, "clientName")
                                        }}
                                        onBlur={(e) => {
                                            let forceTouch = true
                                            return this.onChangeFormInput(e.target.value, "clientName", forceTouch)
                                        }}
                                        ref="clientName"
                                        name="clientName"
                                        disabled
                                    />

                                </div>
                            }
                            <div className={cs(stylesDocCss.errorMessageContainer,
                                (formInputs.clientName.touched && formInputs.clientName.error) ? "" : stylesDocCss.none
                            )}>
                                <div className={stylesDocCss.errorMessage}>
                                    {formInputs.clientName.error && formInputs.clientName.touched &&
                                        formInputs.clientName.error}
                                </div>
                            </div>
                            <div className={stylesDocCss.formInputContainer}>
                                <label className={stylesDocCss.formLabel}>{_('brokerNumber')} </label>
                                <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                    <CustomSelect
                                        value={findItemByValueFromSelectOptions(formInputs.brokerNumber.value, brokerOptions) || ""}
                                        ref="brokerNumber"
                                        name="brokerNumber"
                                        isDisabled={isPrem}
                                        onChange={(value) => {
                                            if (isThereABrokerFill) {
                                                return this.setState({
                                                    isOpenAreYouSure: {
                                                        title: _('areYouSureModalTitle'),
                                                        message: _('areYouSureToChangeBrokerNumber'),
                                                        callBackCancel: () => { },
                                                        callBackOk: () => {
                                                            return this.onChangeBrokerNumberHandler(value)
                                                        }
                                                    }
                                                })
                                            } else {
                                                return this.onChangeBrokerNumberHandler(value)
                                            }
                                        }}
                                        handleOnBlur={(e) => { }}
                                        options={brokerOptions}
                                        isSearchable
                                        isClearable
                                        isMulti={false}
                                        isCreatableSelect={false}
                                    />
                                </div>
                            </div>
                            <div className={cs(stylesDocCss.errorMessageContainer,
                                (formInputs.brokerNumber.touched && formInputs.brokerNumber.error) ? "" : stylesDocCss.none
                            )}>
                                <div className={stylesDocCss.errorMessage}>
                                    {formInputs.brokerNumber.error && formInputs.brokerNumber.touched &&
                                        formInputs.brokerNumber.error}
                                    {formInputs.brokerName.error && formInputs.brokerName.error}
                                </div>
                            </div>

                            {isRequiredTarification &&
                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={stylesDocCss.formLabel}>{_('team')} </label>
                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                        <CustomSelect
                                            value={findItemByValueFromSelectOptions(formInputs.team.value, teamsOptions) || ""}
                                            ref="team"
                                            name="team"
                                            onChange={(value) => {

                                                if (isThereABrokerFill) {
                                                    return this.setState({
                                                        isOpenAreYouSure: {
                                                            title: _('areYouSureModalTitle'),
                                                            message: _('areYouSureToChangeTeam'),
                                                            callBackCancel: () => { },
                                                            callBackOk: () => {
                                                                return this.onChangeTeamHandler(
                                                                    value,
                                                                    { value: formInputs.teamSubgroup.value },
                                                                    packageDSDocuments,
                                                                    formInputs
                                                                )
                                                            }
                                                        }
                                                    })
                                                } else {
                                                    return this.onChangeTeamHandler(
                                                        value,
                                                        { value: formInputs.teamSubgroup.value },
                                                        packageDSDocuments,
                                                        formInputs
                                                    )
                                                }

                                            }}
                                            handleOnBlur={(e) => { }}
                                            options={teamsOptions}
                                            isSearchable
                                            isClearable
                                            isMulti={false}
                                            isCreatableSelect={false}
                                        />
                                    </div>
                                </div>}

                            {isRequiredTarification &&
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.team.touched && formInputs.team.error) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.team.error && formInputs.team.touched &&
                                            formInputs.team.error}
                                    </div>
                                </div>}

                            {isRequiredTarification && (formInputs.team.value == 1) &&
                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={stylesDocCss.formLabel}>{_('teamSubgroup')} </label>
                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                        <CustomSelect
                                            value={findItemByValueFromSelectOptions(formInputs.teamSubgroup.value, teamSubgroupsOptions) || ""}
                                            ref="teamSubgroup"
                                            name="teamSubgroup"
                                            onChange={(value) => {
                                                if (isThereABrokerFill) {
                                                    return this.setState({
                                                        isOpenAreYouSure: {
                                                            title: _('areYouSureModalTitle'),
                                                            message: _('areYouSureToChangeTeamSubgroup'),
                                                            callBackCancel: () => { },
                                                            callBackOk: () => {
                                                                return this.onChangeTeamHandler(
                                                                    { value: formInputs.team.value },
                                                                    value,
                                                                    packageDSDocuments,
                                                                    formInputs
                                                                )
                                                            }
                                                        }
                                                    })
                                                } else {
                                                    return this.onChangeTeamHandler(
                                                        { value: formInputs.team.value },
                                                        value,
                                                        packageDSDocuments,
                                                        formInputs
                                                    )
                                                }
                                            }}
                                            handleOnBlur={(e) => { }}
                                            options={teamSubgroupsOptions}
                                            isSearchable
                                            isClearable
                                            isMulti={false}
                                            isCreatableSelect={false}
                                        />
                                    </div>
                                </div>}

                            {isRequiredTarification && (formInputs.team.value == 1) &&
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.teamSubgroup.touched && formInputs.teamSubgroup.error) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.teamSubgroup.error && formInputs.teamSubgroup.touched &&
                                            formInputs.teamSubgroup.error}
                                    </div>
                                </div>}

                            {(packageDSDocuments && packageDSDocuments.length > 0) ?
                                packageDSDocuments.map((oneDocument) => {
                                    return (
                                        this.renderPackageDocument(oneDocument, isRequiredTarification)
                                    )
                                })
                                :
                                <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.row, stylesDocCss.noHeight, stylesDocCss.marginBottomS)}>
                                    <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.row)}>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.short1, stylesDocCss.alignRight)}>
                                            {_("noPackageDocumentAddedYetPleaseAdd")}
                                        </div>
                                    </div>
                                </div>
                            }

                            {(packageDSDocuments && packageDSDocuments.length > 0) &&
                                <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.row, stylesDocCss.noHeight, stylesDocCss.marginBottomS)}>
                                    <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.row)}>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.short1, stylesDocCss.alignRight)}>
                                            {_('totalSizeOfFiles')} {(Math.ceil(
                                                Number(((packageDSDocuments.reduce((accumulator, currentValue) => {
                                                    return Number(accumulator) + Number(currentValue.fileSize)
                                                }, 0)) / 1024) / 1024) * 100
                                            ) / 100).toFixed(2)
                                            } {_('megabytes')}
                                        </div>
                                    </div>
                                </div>
                            }
                            {isPrem &&
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.hasObligatedMandateTemplate.touched && formInputs.hasObligatedMandateTemplate.error) ? "" : stylesDocCss.none
                                )}>
                                    <div className={cs(stylesDocCss.errorMessage, stylesDocCss.textAlignLeft)}>
                                        {formInputs.hasObligatedMandateTemplate.error && formInputs.hasObligatedMandateTemplate.touched &&
                                            formInputs.hasObligatedMandateTemplate.error}
                                    </div>
                                </div>
                            }

                            {isRequiredTarification &&
                                <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.noHeight, stylesDocCss.marginBottomS)}>
                                    <label className={stylesDocCss.formLabel}>{_('tarificationNumber')}: </label>
                                    <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.row)}>
                                        {formInputs.tarificationNumber.value ? formInputs.tarificationNumber.value : _("newTarificationWillBeCreated")}
                                    </div>

                                </div>
                            }

                            <div className={cs(stylesDocCss.errorMessageContainer,
                                (formInputs.hasObligatedTarificationTemplate.touched && formInputs.hasObligatedTarificationTemplate.error) ? "" : stylesDocCss.none
                            )}>
                                <div className={cs(stylesDocCss.errorMessage, stylesDocCss.textAlignLeft)}>
                                    {formInputs.hasObligatedTarificationTemplate.error && formInputs.hasObligatedTarificationTemplate.touched &&
                                        formInputs.hasObligatedTarificationTemplate.error}
                                </div>
                            </div>

                            <div className={cs(stylesDocCss.errorMessageContainer,
                                (formErrorNoGeneratedDoc) ? "" : stylesDocCss.none
                            )}>
                                <div className={cs(stylesDocCss.errorMessage, stylesDocCss.textAlignLeft)}>
                                    {formErrorNoGeneratedDoc.message}
                                </div>
                            </div>

                        </div>
                    </span>

                    <div className={stylesDocCss.addDocumentButtonContainer}>
                        {!isOffice &&
                            <UploadLocalDocumentButton
                                onSelectDocuments={this.onSelectLocalDocument.bind(this)}
                                clientId={clientId}
                                entityId={entityId}
                                moduleType={moduleType}
                                classNameExtra={stylesDocCss.uploadButton}
                                claimWizardDocType={claimWizardDocType}
                            />
                        }
                        {!isOffice &&
                            <OracleDocumentButton
                                onSelectDocuments={this.openOracleDocumentsModal.bind(this)}
                            />
                        }
                        {(isClaimsModule && haveAvailableClaimTemplate) || !isClaimsModule ?
                            <div className={stylesDocCss.documentsModalButtons}>
                                <button
                                    type="button"
                                    className={stylesDocCss.greenButton + " enabled"}
                                    onClick={(e) => {
                                        this.onClickAddGeneratedDocument()
                                    }}
                                >
                                    <div className={stylesDocCss.iconContainer}>
                                        <img src={require("resources/icn-plus.svg")} />
                                    </div>
                                    {_("addDocument")}
                                </button>
                            </div>
                            :
                            ''
                        }
                    </div>

                    {requireSigning(packageDSDocuments, DSDocumentOriginTypes) ?
                        <span className={stylesDocCss.message}>
                            <div className={stylesDocCss.resendModalContainer}>
                                <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.noHeight)}>
                                    <label className={cs(stylesDocCss.formLabel, stylesDocCss.signersAreaLabel)} >{isPrem ? _('signersAreaTitlelMandate') : _('signersAreaTitle')}</label>
                                </div>
                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={stylesDocCss.formLabel}>{_('firstSignerLastName')} </label>
                                    <input
                                        className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                        type="text"
                                        value={formInputs.firstSignerLastName.value}
                                        onChange={(e) => {
                                            return this.onChangeFormInput(e.target.value, "firstSignerLastName")
                                        }}
                                        onBlur={(e) => {
                                            let forceTouch = true
                                            return this.onChangeFormInput(e.target.value, "firstSignerLastName", forceTouch)
                                        }}
                                        ref="firstSignerLastName"
                                        name="firstSignerLastName"
                                    />

                                </div>
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.firstSignerLastName.touched && formInputs.firstSignerLastName.error) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.firstSignerLastName.error && formInputs.firstSignerLastName.touched &&
                                            formInputs.firstSignerLastName.error}
                                    </div>
                                </div>

                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={stylesDocCss.formLabel}>{_('firstSignerFirstName')} </label>
                                    <input
                                        className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                        type="text"
                                        value={formInputs.firstSignerFirstName.value}
                                        onChange={(e) => {
                                            return this.onChangeFormInput(e.target.value, "firstSignerFirstName")
                                        }}
                                        onBlur={(e) => {
                                            let forceTouch = true
                                            return this.onChangeFormInput(e.target.value, "firstSignerFirstName", forceTouch)
                                        }}
                                        ref="firstSignerFirstName"
                                        name="firstSignerFirstName"
                                    />

                                </div>
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.firstSignerFirstName.touched && formInputs.firstSignerFirstName.error) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.firstSignerFirstName.error && formInputs.firstSignerFirstName.touched &&
                                            formInputs.firstSignerFirstName.error}
                                    </div>
                                </div>

                                <div className={stylesDocCss.formInputContainer} key={"formInputContainerKey1"}>
                                    <label className={stylesDocCss.formLabel}>{_('emailAddress')} </label>
                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                        <CustomSelect
                                            value={findItemByValueFromSelectOptions(formInputs.clientEmailAddress.value, firstSignerEmailAddressOptions) || firstSignerEmailAddressOptions[0] || ''}
                                            ref="clientEmailAddress"
                                            name="clientEmailAddress"
                                            onChange={(value) => {
                                                return this.onChangeFormInput(
                                                    nesProp.get(value, "value") || "", "clientEmailAddress"
                                                )
                                            }}
                                            handleOnBlur={(e) => {
                                                let forceTouch = true
                                                let typedValue = nesProp.get(e, "target.value")

                                                if (typedValue) {
                                                    return this.onChangeFormInput(
                                                        nesProp.get(e, "target.value") || "", "clientEmailAddress", forceTouch
                                                    )
                                                }
                                            }}
                                            options={firstSignerEmailAddressOptions}
                                            isSearchable
                                            isClearable
                                            isMulti={false}
                                            formatCreateLabel={_('newClientEmail')}
                                            isCreatableSelect={true}
                                            noOptionsLabel={_('emailAddressNoOption')}
                                        />
                                    </div>
                                </div>

                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.clientEmailAddress.touched && formInputs.clientEmailAddress.error) ? "" : stylesDocCss.none
                                )} key={"errorMessageContainerKey1"}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.clientEmailAddress.error && formInputs.clientEmailAddress.touched &&
                                            formInputs.clientEmailAddress.error}
                                    </div>
                                </div>

                                {requireSmsOtpSigningResult &&
                                    <div className={stylesDocCss.formInputContainer} key={"formInputPhoneNumberContainerKey"}>
                                        <label className={stylesDocCss.formLabel}>{_('firstSignerPhoneNumber')} </label>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.inputsForceRow)}>

                                            <div className={cs(stylesDocCss.formInput, stylesDocCss.phoneCode)}>
                                                <CustomSelect
                                                    value={findItemByValueFromSelectOptions(formInputs.firstSignerCountryPhoneCode.value, countryPhoneCodes) || ""}
                                                    options={countryPhoneCodes}
                                                    ref="firstSignerCountryPhoneCode"
                                                    name="firstSignerCountryPhoneCode"
                                                    onChange={(value) => {
                                                        return this.onChangeFirstSignerCountryCode(nesProp.get(value, "value") || "")
                                                    }}
                                                    handleOnBlur={(e) => {
                                                        let forceTouch = true
                                                        let typedValue = nesProp.get(e, "target.value")

                                                        if (typedValue) {
                                                            return this.onChangeFirstSignerCountryCode(
                                                                nesProp.get(e, "target.value") || "", forceTouch
                                                            )
                                                        }
                                                    }}
                                                    isSearchable
                                                    isClearable
                                                    isMulti={false}
                                                    // formatCreateLabel={_('newClientPhoneNumber')}
                                                    isCreatableSelect={false}
                                                />
                                            </div>
                                            <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect, stylesDocCss.sizeXS)}>
                                                <CustomSelect
                                                    value={findItemByValueFromSelectOptions(formInputs.firstSignerPhoneNumber.value, firstSignerGSMPhoneNumber) || ""}
                                                    ref="firstSignerPhoneNumber"
                                                    name="firstSignerPhoneNumber"
                                                    onChange={(value) => {
                                                        return this.onChangeFirstSignerPhoneNumber(value)
                                                    }}
                                                    handleOnBlur={(e) => {
                                                        let forceTouch = true
                                                        let typedValue = nesProp.get(e, "target.value")
                                                        let inputValueObject = {
                                                            value: typedValue || ""
                                                        }

                                                        if (!typedValue) {
                                                            return
                                                        }

                                                        return this.onChangeFirstSignerPhoneNumber(inputValueObject, forceTouch)
                                                    }}
                                                    options={firstSignerGSMPhoneNumber}
                                                    isSearchable
                                                    isClearable
                                                    isMulti={false}
                                                    formatCreateLabel={_('newClientPhoneNumber')}
                                                    isCreatableSelect={true}
                                                    noOptionsLabel={_('phoneNumberNoOptions')}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                }

                                {requireSmsOtpSigningResult &&
                                    <div className={cs(stylesDocCss.errorMessageContainer,
                                        (formInputs.firstSignerPhoneNumber.touched && formInputs.firstSignerPhoneNumber.error) ? "" : stylesDocCss.none
                                    )} key={"errorMessageContainerKey2"}>
                                        <div className={stylesDocCss.errorMessage}>
                                            {formInputs.firstSignerPhoneNumber.error && formInputs.firstSignerPhoneNumber.touched &&
                                                formInputs.firstSignerPhoneNumber.error}
                                        </div>
                                    </div>
                                }

                                {(isPrem || isItExistSecondSignerPlaceholder || isOffice) &&
                                    <div className={stylesDocCss.secondSigner}>
                                        {showSecondSigner &&
                                            <div className={stylesDocCss.resendModalContainer}>
                                                <div className={stylesDocCss.formInputContainer}>
                                                    <label className={stylesDocCss.formLabel}>{_('secondSignerLastName')} </label>
                                                    <input
                                                        className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                                        type="text"
                                                        value={formInputs.secondSignerLastName.value}
                                                        // value={formInputs.secondSignerLastName.value}
                                                        onChange={(e) => {
                                                            return this.onChangeFormInput(e.target.value, "secondSignerLastName")
                                                        }}
                                                        onBlur={(e) => {
                                                            let forceTouch = true
                                                            return this.onChangeFormInput(e.target.value, "secondSignerLastName", forceTouch)
                                                        }}
                                                        ref="secondSignerLastName"
                                                        name="secondSignerLastName"
                                                    />

                                                </div>
                                                <div className={cs(stylesDocCss.errorMessageContainer,
                                                    (formInputs.secondSignerLastName.touched && formInputs.secondSignerLastName.error) ? "" : stylesDocCss.none
                                                )}>
                                                    <div className={stylesDocCss.errorMessage}>
                                                        {formInputs.secondSignerLastName.error && formInputs.secondSignerLastName.touched &&
                                                            formInputs.secondSignerLastName.error}
                                                    </div>
                                                </div>

                                                <div className={stylesDocCss.formInputContainer}>
                                                    <label className={stylesDocCss.formLabel}>{_('secondSignerFirstName')} </label>
                                                    <input
                                                        className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                                        type="text"
                                                        value={formInputs.secondSignerFirstName.value}
                                                        onChange={(e) => {
                                                            return this.onChangeFormInput(e.target.value, "secondSignerFirstName")
                                                        }}
                                                        onBlur={(e) => {
                                                            let forceTouch = true
                                                            return this.onChangeFormInput(e.target.value, "secondSignerFirstName", forceTouch)
                                                        }}
                                                        ref="secondSignerFirstName"
                                                        name="secondSignerFirstName"
                                                    />
                                                </div>
                                                <div className={cs(stylesDocCss.errorMessageContainer,
                                                    (formInputs.secondSignerFirstName.touched && formInputs.secondSignerFirstName.error) ? "" : stylesDocCss.none
                                                )}>
                                                    <div className={stylesDocCss.errorMessage}>
                                                        {formInputs.secondSignerFirstName.error && formInputs.secondSignerFirstName.touched &&
                                                            formInputs.secondSignerFirstName.error}
                                                    </div>
                                                </div>

                                                <div className={stylesDocCss.formInputContainer}>
                                                    <label className={stylesDocCss.formLabel}>{_('secondSignerLanguage')} </label>
                                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                                        <CustomSelect
                                                            value={findItemByValueFromSelectOptions(formInputs.secondSignerLanguage.value, languageOptions) || ""}
                                                            ref={'secondSignerLanguage'}
                                                            name={'secondSignerLanguage'}
                                                            onChange={(value) => {
                                                                return this.onChangeFormInput(
                                                                    nesProp.get(value, "value") || "", "secondSignerLanguage"
                                                                )
                                                            }}
                                                            handleOnBlur={(e) => { }}
                                                            options={languageOptions}
                                                            isSearchable
                                                            isClearable
                                                            isMulti={false}
                                                            isCreatableSelect={false}
                                                        />
                                                    </div>

                                                </div>
                                                <div className={cs(stylesDocCss.errorMessageContainer,
                                                    (formInputs.secondSignerLanguage.touched && formInputs.secondSignerLanguage.error) ? "" : stylesDocCss.none
                                                )}>
                                                    <div className={stylesDocCss.errorMessage}>
                                                        {formInputs.secondSignerLanguage.error && formInputs.secondSignerLanguage.touched &&
                                                            formInputs.secondSignerLanguage.error}
                                                    </div>
                                                </div>

                                                <div className={stylesDocCss.formInputContainer}>
                                                    <label className={stylesDocCss.formLabel}>{_('secondSignerEmailAddress')} </label>
                                                    <input
                                                        className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                                        type="text"
                                                        value={formInputs.secondSignerEmailAddress.value}
                                                        onChange={(e) => {
                                                            return this.onChangeFormInput(e.target.value, "secondSignerEmailAddress")
                                                        }}
                                                        onBlur={(e) => {
                                                            let forceTouch = true
                                                            return this.onChangeFormInput(e.target.value, "secondSignerEmailAddress", forceTouch)
                                                        }}
                                                        ref="secondSignerEmailAddress"
                                                        name="secondSignerEmailAddress"
                                                    />
                                                </div>
                                                <div className={cs(stylesDocCss.errorMessageContainer,
                                                    (formInputs.secondSignerEmailAddress.touched && formInputs.secondSignerEmailAddress.error) ? "" : stylesDocCss.none
                                                )} key={"errorMessageContainerKey12"}>
                                                    <div className={stylesDocCss.errorMessage}>
                                                        {formInputs.secondSignerEmailAddress.error && formInputs.secondSignerEmailAddress.touched &&
                                                            formInputs.secondSignerEmailAddress.error}
                                                    </div>
                                                </div>
                                                {requireSmsOtpSigningResult &&
                                                    <div className={stylesDocCss.formInputContainer}>
                                                        <label className={stylesDocCss.formLabel}>{_('secondSignerPhoneNumber')} </label>
                                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.inputsForceRow)}>

                                                            <div className={cs(stylesDocCss.formInput, stylesDocCss.phoneCode)}>
                                                                <CustomSelect
                                                                    value={findItemByValueFromSelectOptions(formInputs.secondSignerCountryPhoneCode.value || '', countryPhoneCodes) || ""}
                                                                    options={countryPhoneCodes}
                                                                    ref="secondSignerCountryPhoneCode"
                                                                    name="secondSignerCountryPhoneCode"
                                                                    onChange={(value) => {
                                                                        return this.onChangeSecondSignerCountryCode(nesProp.get(value, "value") || "")
                                                                    }}
                                                                    handleOnBlur={(e) => {
                                                                        let forceTouch = true
                                                                        let typedValue = nesProp.get(e, "target.value")

                                                                        if (typedValue) {
                                                                            return this.onChangeSecondSignerCountryCode(
                                                                                nesProp.get(e, "target.value") || "", forceTouch
                                                                            )
                                                                        }
                                                                    }}
                                                                    isSearchable
                                                                    isClearable
                                                                    isMulti={false}
                                                                    // formatCreateLabel={_('newClientPhoneNumber')}
                                                                    isCreatableSelect={false}
                                                                />
                                                            </div>
                                                            <input
                                                                className={cs(stylesDocCss.formInput, stylesDocCss.formInputText, stylesDocCss.sizeXS)}
                                                                type="text"
                                                                value={formInputs.secondSignerPhoneNumber.value}
                                                                onChange={(e) => {
                                                                    return this.onChangeSecondSignerPhoneNumber(e.target.value)
                                                                }}
                                                                onBlur={(e) => {
                                                                    let forceTouch = true
                                                                    return this.onChangeSecondSignerPhoneNumber(e.target.value, forceTouch)
                                                                }}
                                                                ref="secondSignerPhoneNumber"
                                                                name="secondSignerPhoneNumber"
                                                            />
                                                        </div>
                                                    </div>
                                                }
                                                {requireSmsOtpSigningResult &&
                                                    <div className={cs(stylesDocCss.errorMessageContainer,
                                                        (formInputs.secondSignerPhoneNumber.touched && formInputs.secondSignerPhoneNumber.error) ? "" : stylesDocCss.none
                                                    )} key={"errorMessageContainerKey2"}>
                                                        <div className={stylesDocCss.errorMessage}>
                                                            {formInputs.secondSignerPhoneNumber.error && formInputs.secondSignerPhoneNumber.touched &&
                                                                formInputs.secondSignerPhoneNumber.error}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        <div className={stylesDocCss.documentsModalButtons + ' secondSigner'}>
                                            <button
                                                type="button"
                                                className={stylesDocCss.greenButton + " enabled"}
                                                onClick={(e) => {
                                                    let result = this.toggleShowSecondSigner(formInputs, packageDSDocuments)
                                                    result.formInputs = formInputsValidation(result.formInputs)
                                                    let isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)
                                                    this.setState({ showSecondSigner: result.showSecondSigner, formInputs: result.formInputs, isValidTheForm })
                                                }}
                                            >
                                                {showSecondSigner ? _('removeSecondSigner') : _("addSecondSigner")}
                                            </button>
                                        </div>
                                    </div>
                                }

                                <div className={stylesDocCss.secondSigner}>
                                    {showBrokerSigner &&
                                        <div className={stylesDocCss.resendModalContainer}>
                                            <input
                                                ref={'brokerSignerExists'}
                                                name={'brokerSignerExists'}
                                                type="hidden"
                                                value={formInputs['brokerSignerExists'].value || false}
                                            />
                                            <div className={stylesDocCss.formInputContainer}>
                                                <label className={stylesDocCss.formLabel}>{_('brokerSignerLastName')} </label>
                                                <input
                                                    className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                                    type="text"
                                                    value={formInputs.brokerSignerLastName.value}
                                                    // value={formInputs.brokerSignerLastName.value}
                                                    onChange={(e) => {
                                                        return this.onChangeFormInput(e.target.value, "brokerSignerLastName")
                                                    }}
                                                    onBlur={(e) => {
                                                        let forceTouch = true
                                                        return this.onChangeFormInput(e.target.value, "brokerSignerLastName", forceTouch)
                                                    }}
                                                    ref="brokerSignerLastName"
                                                    name="brokerSignerLastName"
                                                />

                                            </div>
                                            <div className={cs(stylesDocCss.errorMessageContainer,
                                                (formInputs.brokerSignerLastName.touched && formInputs.brokerSignerLastName.error) ? "" : stylesDocCss.none
                                            )}>
                                                <div className={stylesDocCss.errorMessage}>
                                                    {formInputs.brokerSignerLastName.error && formInputs.brokerSignerLastName.touched &&
                                                        formInputs.brokerSignerLastName.error}
                                                </div>
                                            </div>

                                            <div className={stylesDocCss.formInputContainer}>
                                                <label className={stylesDocCss.formLabel}>{_('brokerSignerFirstName')} </label>
                                                <input
                                                    className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                                    type="text"
                                                    value={formInputs.brokerSignerFirstName.value}
                                                    onChange={(e) => {
                                                        return this.onChangeFormInput(e.target.value, "brokerSignerFirstName")
                                                    }}
                                                    onBlur={(e) => {
                                                        let forceTouch = true
                                                        return this.onChangeFormInput(e.target.value, "brokerSignerFirstName", forceTouch)
                                                    }}
                                                    ref="brokerSignerFirstName"
                                                    name="brokerSignerFirstName"
                                                />
                                            </div>
                                            <div className={cs(stylesDocCss.errorMessageContainer,
                                                (formInputs.brokerSignerFirstName.touched && formInputs.brokerSignerFirstName.error) ? "" : stylesDocCss.none
                                            )}>
                                                <div className={stylesDocCss.errorMessage}>
                                                    {formInputs.brokerSignerFirstName.error && formInputs.brokerSignerFirstName.touched &&
                                                        formInputs.brokerSignerFirstName.error}
                                                </div>
                                            </div>

                                            {/*<div className={stylesDocCss.formInputContainer}>
                                                <label className={stylesDocCss.formLabel}>{_('brokerSignerBirthDate')} </label>
                                                <DatePicker
                                                    className={cs(stylesDocCss.formInput, stylesDocCss.formInputText)}
                                                    type="text"
                                                    value={formInputs.brokerSignerBirthDate.value}

                                                    // value={formInputs.brokerSignerBirthDate.value}
                                                    onChange={(value) => {
                                                        this.onChangeFormInput(value, "brokerSignerBirthDate")
                                                        return this.setState({forceCloseDatepicker: false})
                                                    }}

                                                    // onBlur={(e) => {
                                                    //     let forceTouch = true
                                                    //     this.onChangeFormInput(e.target.value, "brokerSignerBirthDate", forceTouch)
                                                    //     return this.setState({forceCloseDatepicker: false})
                                                    // }}

                                                    ref="brokerSignerBirthDate"
                                                    name="brokerSignerBirthDate"
                                                    maxDate={moment().toString()}
                                                    forceCloseDatepicker={{
                                                        froceClose: this.state.forceCloseDatepicker,
                                                        cb: () => this.setState({forceCloseDatepicker:false})
                                                    }}
                                                />
                                            </div>
                                            <div className={cs(stylesDocCss.errorMessageContainer,
                                                (formInputs.brokerSignerBirthDate.touched && formInputs.brokerSignerBirthDate.error) ? "" : stylesDocCss.none
                                            )}>
                                                <div className={stylesDocCss.errorMessage}>
                                                    {formInputs.brokerSignerBirthDate.error && formInputs.brokerSignerBirthDate.touched &&
                                                        formInputs.brokerSignerBirthDate.error}
                                                </div>
                                            </div>*/}


                                            <input
                                                ref={'brokerSignerLanguage'}
                                                name={'brokerSignerLanguage'}
                                                type="hidden"
                                                value={formInputs['brokerSignerLanguage'].value || ''}
                                            />

                                            {requireSmsOtpSigningResult &&
                                                <div className={stylesDocCss.formInputContainer} key={"formInputPhoneNumberContainerKey"}>
                                                    <label className={stylesDocCss.formLabel}>{_('brokerSignerPhoneNumber')} </label>
                                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.inputsForceRow)}>

                                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.phoneCode)}>
                                                            <CustomSelect
                                                                value={findItemByValueFromSelectOptions(formInputs.brokerSignerCountryPhoneCode.value, countryPhoneCodes) || ""}
                                                                options={countryPhoneCodes}
                                                                ref="brokerSignerCountryPhoneCode"
                                                                name="brokerSignerCountryPhoneCode"
                                                                onChange={(value) => {
                                                                    return this.onChangeBrokerSignerCountryCode(nesProp.get(value, "value") || "")
                                                                }}
                                                                handleOnBlur={(e) => {
                                                                    let forceTouch = true
                                                                    let typedValue = nesProp.get(e, "target.value")

                                                                    if (typedValue) {
                                                                        return this.onChangeBrokerSignerCountryCode(
                                                                            nesProp.get(e, "target.value") || "", forceTouch
                                                                        )
                                                                    }
                                                                }}
                                                                isSearchable
                                                                isClearable
                                                                isMulti={false}
                                                                // formatCreateLabel={_('newClientPhoneNumber')}
                                                                isCreatableSelect={false}
                                                            />
                                                        </div>

                                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect, stylesDocCss.sizeXS)}>
                                                            <CustomSelect
                                                                value={findItemByValueFromSelectOptions(formInputs.brokerSignerPhoneNumber.value, brokerGSMPhoneNumbers) || ""}
                                                                ref="brokerSignerPhoneNumber"
                                                                name="brokerSignerPhoneNumber"
                                                                onChange={(value) => {
                                                                    return this.onChangeBrokerSignerPhoneNumber(value)
                                                                }}
                                                                handleOnBlur={(e) => {
                                                                    let forceTouch = true
                                                                    let typedValue = nesProp.get(e, "target.value")
                                                                    let inputValueObject = {
                                                                        value: typedValue || ""
                                                                    }

                                                                    if (!typedValue) {
                                                                        return
                                                                    }

                                                                    return this.onChangeBrokerSignerPhoneNumber(inputValueObject, forceTouch)
                                                                }}
                                                                options={brokerGSMPhoneNumbers}
                                                                isSearchable
                                                                isClearable
                                                                isMulti={false}
                                                                formatCreateLabel={_('newClientPhoneNumber')}
                                                                isCreatableSelect={true}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {requireSmsOtpSigningResult &&
                                                <div className={cs(stylesDocCss.errorMessageContainer,
                                                    (formInputs.brokerSignerPhoneNumber.touched && formInputs.brokerSignerPhoneNumber.error) ? "" : stylesDocCss.none
                                                )} key={"errorMessageContainerKey2"}>
                                                    <div className={stylesDocCss.errorMessage}>
                                                        {formInputs.brokerSignerPhoneNumber.error && formInputs.brokerSignerPhoneNumber.touched &&
                                                            formInputs.brokerSignerPhoneNumber.error}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    {isItExistBrokerSignerPlaceholder &&
                                        <div className={stylesDocCss.documentsModalButtons + ' secondSigner'}>
                                            <button
                                                type="button"
                                                className={stylesDocCss.greenButton + " enabled"}
                                                onClick={(e) => {
                                                    let result = this.toggleShowBrokerSigner(formInputs, packageDSDocuments, brokerSigningStakeholder)
                                                    this.setState({ showBrokerSigner: result.showBrokerSigner, formInputs: result.formInputs })
                                                }}
                                            >
                                                {showBrokerSigner ? _('removeBrokerAsSigner') : _("addBrokerAsSigner")}
                                            </button>
                                        </div>
                                    }
                                </div>

                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={stylesDocCss.formLabel}>
                                        {_(isOffice ? 'willemotEmailAddress' : 'brokerEmailAddress')}
                                    </label>
                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect)}>
                                        <CustomSelect
                                            value={findItemByValueFromSelectOptions(formInputs.brokerEmailAddress.value, isOffice ? initiatorEmailAddressesFromTemplates : brokerEmailOptions) || ""}
                                            ref="brokerEmailAddress"
                                            name="brokerEmailAddress"
                                            onChange={(value) => {
                                                return this.onChangeFormInput(
                                                    nesProp.get(value, "value") || "", "brokerEmailAddress"
                                                )
                                            }}

                                            handleOnBlur={(e) => { }}
                                            options={isOffice ? initiatorEmailAddressesFromTemplates : brokerEmailOptions}
                                            isSearchable
                                            isClearable
                                            isMulti={false}
                                            isCreatableSelect={false}
                                        />
                                    </div>

                                </div>
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    (formInputs.brokerEmailAddress.touched && formInputs.brokerEmailAddress.error) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.brokerEmailAddress.error && formInputs.brokerEmailAddress.touched &&
                                            formInputs.brokerEmailAddress.error}

                                    </div>
                                </div>

                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={cs(stylesDocCss.formLabel)}>
                                        {_(isOffice ? 'brokerReminderInterval' : 'remainderInterval')}
                                        <img
                                            onClick={(e) => { this.setState({ isOpenIntervalInfo: true }) }}
                                            className={cs(stylesDocCss.infoIcon)}
                                            src={this.getIcon('icn-info')}
                                        />
                                    </label>

                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.inputsForceRow)}>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect, stylesDocCss.sizeXS, stylesDocCss.first)}>
                                            <CustomSelect
                                                value={findItemByValueFromSelectOptions(formInputs.remainderInterval.value, remainderIntervalOptions) || ""}
                                                ref="remainderInterval"
                                                name="remainderInterval"
                                                onChange={(value) => {
                                                    return this.onChangeRemainderInterval(value.value)
                                                }}
                                                handleOnBlur={(e) => { }}
                                                options={remainderIntervalOptions}
                                                isSearchable
                                                isClearable
                                                isMulti={false}
                                                isCreatableSelect={false}
                                            />
                                        </div>
                                        <div className={cs(stylesDocCss.formLabel, stylesDocCss.marginLeftS, stylesDocCss.short1)}>{_('remainderRepeats')} </div>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect,
                                            stylesDocCss.sizeXS, stylesDocCss.shortMargin, stylesDocCss.last)}>
                                            <CustomSelect
                                                value={findItemByValueFromSelectOptions(formInputs.remainderRepeats.value, remainderRepeatsOptions) || ""}
                                                ref="remainderRepeats"
                                                name="remainderRepeats"
                                                onChange={(value) => {
                                                    return this.onChangeFormInput(
                                                        nesProp.get(value, "value") || "", "remainderRepeats"
                                                    )
                                                }}
                                                handleOnBlur={(e) => { }}
                                                options={remainderRepeatsOptions}
                                                isSearchable
                                                isClearable
                                                isMulti={false}
                                                isCreatableSelect={false}
                                                isDisabled={parseInt(formInputs.remainderInterval.value) === 0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    ((formInputs.remainderInterval.touched && formInputs.remainderInterval.error) || (formInputs.remainderRepeats.touched && formInputs.remainderRepeats.error)) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.remainderInterval.error && formInputs.remainderInterval.touched &&
                                            formInputs.remainderInterval.error}
                                    </div>

                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.remainderRepeats.error && formInputs.remainderRepeats.touched &&
                                            formInputs.remainderRepeats.error}
                                    </div>
                                </div>

                                <div className={stylesDocCss.formInputContainer}>
                                    <label className={cs(stylesDocCss.formLabel)}>
                                        {_(isOffice ? 'willemotReminderTicketInterval' : 'remainderTicketInterval')}
                                        <img
                                            onClick={(e) => { this.setState({ isOpenTicketIntervalInfo: true }) }}
                                            className={cs(stylesDocCss.infoIcon)}
                                            src={this.getIcon('icn-info')}
                                        />
                                    </label>

                                    <div className={cs(stylesDocCss.formInput, stylesDocCss.inputsForceRow)}>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect, stylesDocCss.sizeXS, stylesDocCss.first)}>
                                            <CustomSelect
                                                value={findItemByValueFromSelectOptions(formInputs.remainderTicketInterval.value, remainderIntervalOptions) || ""}
                                                ref="remainderTicketInterval"
                                                name="remainderTicketInterval"
                                                onChange={(value) => {
                                                    return this.onChangeRemainderTicketInterval(value.value)
                                                }}
                                                handleOnBlur={(e) => { }}
                                                options={remainderIntervalOptions}
                                                isSearchable
                                                isClearable
                                                isMulti={false}
                                                isCreatableSelect={false}
                                            />
                                        </div>
                                        <div className={cs(stylesDocCss.formLabel, stylesDocCss.marginLeftS, stylesDocCss.short1)}>{_('remainderRepeats')} </div>
                                        <div className={cs(stylesDocCss.formInput, stylesDocCss.formInputCreatableSelect,
                                            stylesDocCss.sizeXS, stylesDocCss.shortMargin, stylesDocCss.last)}>
                                            <CustomSelect
                                                value={findItemByValueFromSelectOptions(formInputs.remainderTicketRepeats.value, remainderRepeatsOptions) || ""}
                                                ref="remainderTicketRepeats"
                                                name="remainderTicketRepeats"
                                                onChange={(value) => {
                                                    return this.onChangeFormInput(
                                                        nesProp.get(value, "value") || "", "remainderTicketRepeats"
                                                    )
                                                }}
                                                handleOnBlur={(e) => { }}
                                                options={remainderRepeatsOptions}
                                                isSearchable
                                                isClearable
                                                isMulti={false}
                                                isCreatableSelect={false}
                                                isDisabled={parseInt(formInputs.remainderTicketInterval.value) === 0}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className={cs(stylesDocCss.errorMessageContainer,
                                    ((formInputs.remainderInterval.touched && formInputs.remainderInterval.error) || (formInputs.remainderRepeats.touched && formInputs.remainderRepeats.error)) ? "" : stylesDocCss.none
                                )}>
                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.remainderInterval.error && formInputs.remainderInterval.touched &&
                                            formInputs.remainderInterval.error}
                                    </div>

                                    <div className={stylesDocCss.errorMessage}>
                                        {formInputs.remainderRepeats.error && formInputs.remainderRepeats.touched &&
                                            formInputs.remainderRepeats.error}
                                    </div>
                                </div>
                            </div>
                        </span> : null
                    }

                    {!isValidTheForm.isValid && isValidTheForm.errors.map((oneErr, errIndex) => {
                        return (<div className={cs(stylesDocCss.errorMessageContainer,
                            (formInputs.hasObligatedTarificationTemplate.touched && formInputs.hasObligatedTarificationTemplate.error) ?
                                "" : stylesDocCss.none)}
                            key={oneErr.code + " " + errIndex}
                        >
                            <div className={cs(stylesDocCss.errorMessage, stylesDocCss.textAlignLeft)}>
                                {oneErr.message && oneErr.touched &&
                                    oneErr.message}
                            </div>
                        </div>)
                    })}

                    <div className={stylesDocCss.documentsModalButtons}>
                        <div
                            onClick={async () => {
                                if (packageInstance && packageInstance._id) {
                                    let skipValidationJustUpdate = true
                                    await this.initStep2(formInputs, skipValidationJustUpdate)
                                } else {
                                    if (packageDSDocuments && packageDSDocuments.length > 0) {
                                        let listOfTmpId = packageDSDocuments
                                            .filter((oneDoc) => {
                                                return oneDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD
                                            })
                                            .map((oneDoc) => {
                                                return oneDoc.temporaryUploadId
                                            })

                                        await dispatch(removeTemporaryUpload(listOfTmpId))
                                    }

                                }

                                // just reset triggers and states and close modal
                                this.closeModal()
                            }}
                            className={stylesDocCss.cancel}
                        >
                            {_("cancel")}
                        </div>
                        <button
                            type="button"
                            className={stylesDocCss.greenButton + " enabled"}
                            disabled={!isValidTheForm.isValid}
                            onClick={(e) => {
                                e.preventDefault()

                                const { formInputs } = this.state
                                const brokerEmailAddress = formInputs.brokerEmailAddress.value

                                if (brokerEmailAddress) {
                                    dispatch(loadEmailServer(brokerEmailAddress))
                                        .then(res => {
                                            if (res && res.senderName && res.senderName.length > 0) {
                                                this.initStep2(formInputs)
                                                    .then(() => {
                                                        // step forward to disable rendering of form
                                                        this.setState({ step: c.DSWIZARD_STEP_2_FILL_DOCUMENTS }, () => { })
                                                    })

                                                    .catch((err) => {
                                                        console.error("init step 2: ", err)
                                                        // step forward to disable rendering of form
                                                        this.setState({ step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE })
                                                    })

                                            } else {
                                                dispatch(showEmailServerConfigModal(brokerEmailAddress))
                                            }
                                        }).catch(err => {
                                            dispatch(showEmailServerConfigModal(brokerEmailAddress))
                                        })
                                } else {
                                    this.initStep2(formInputs)
                                        .then(() => {

                                            // step forward to disable rendering of form
                                            this.setState({ step: c.DSWIZARD_STEP_2_FILL_DOCUMENTS }, () => { })
                                        })

                                        .catch((err) => {
                                            console.error("init step 2: ", err)

                                            // step forward to disable rendering of form
                                            this.setState({ step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE })
                                        })
                                }
                            }}
                        >
                            {_("Next")}
                        </button>
                    </div>
                </form>
                <EmailServerConfigDialog
                    modalIsOpen={emailServerConfigModalIsOpen}
                    onCancel={() => {
                        const { dispatch } = this.props
                        dispatch(hideEmailServerConfigModal(false))
                    }}
                    onConfirmation={(config) => {
                        dispatch(saveEmailServer(config))
                            .then(res => {
                                dispatch(hideEmailServerConfigModal(true))

                                if (res) {
                                    this.initStep2(formInputs)
                                        .then(() => {
                                            // step forward to disable rendering of form
                                            this.setState({ step: c.DSWIZARD_STEP_2_FILL_DOCUMENTS })
                                        })
                                }
                            })
                            .catch((err) => {
                                // step forward to disable rendering of form
                                this.setState({ step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE })
                            })
                    }}
                />
            </div>
        )
    }


    /**
     * This function render a row for fill a document
     * @param {object} oneDocument Instance fo dsdocument
     */
    renderDocumentFillAndPrintBlock(oneDocument) {
        const { DSDocumentOriginTypes } = this.props
        const { stakeholders } = this.state

        // totalNumberOfSigners is require to validate PDF documents about the signature placeholder count.
        let totalNumberOfSigners = stakeholders.length
        const packageReseted = oneDocument.package.packageReseted
        const documentRequiredOnOffers = oneDocument.documentTemplate ? oneDocument.documentTemplate.requiredOnOffers : false

        let isValid = isValidDocument(oneDocument, totalNumberOfSigners, DSDocumentOriginTypes)
        return (
            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.packageDocumentContainer)}
                key={"formInputContainerPackageDocumentContainerKey" + oneDocument.cursor + oneDocument._id}
            >
                <div className={cs(stylesDocCss.packageDocumentDetailRow)}>
                    <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.documentsModalButtons, stylesDocCss.fillButtonContainer)}>

                        <label className={cs(stylesDocCss.formLabel, stylesDocCss.short5)}>
                            {oneDocument.fileName}
                        </label>

                        <div className={cs(
                            stylesDocCss.short1,
                            stylesDocCss.alignRight
                        )}
                            key={"documentsModalButtonsAlignRightKey"}
                        >
                            {oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_GENERATED &&
                                <button
                                    key="OpenDocumentForSignaturePlaceholdersEditDocumentButtonKey"
                                    type="button"
                                    disabled={packageReseted && documentRequiredOnOffers}
                                    className={cs(stylesDocCss.formInput,
                                        stylesDocCss.short8,
                                        stylesDocCss.autoWidth,
                                        stylesDocCss.editDocumentButton,
                                        stylesDocCss.greenButton + " enabled"
                                    )}
                                    onClick={(e) => {
                                        this.openFillADocument(oneDocument)
                                    }}
                                >
                                    <div className={cs(stylesDocCss.btnText)}>
                                        {oneDocument.brokerFilledValues ? _("editDocument") : _("fillDocument")}

                                    </div>
                                    {isValid &&
                                        <img
                                            className={cs(stylesDocCss.checkIcon)}
                                            src={this.getIcon('ic_done_white_32px')}
                                        />
                                    }
                                </button>
                            }
                            {!oneDocument.isAttachment && (oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_LOCAL_UPLOAD ||
                                oneDocument.origin == DSDocumentOriginTypes.DS_ORIGIN_ORACLE) &&
                                <button
                                    key="OpenDocumentForSignaturePlaceholdersButtonKey"
                                    type="button"
                                    className={cs(stylesDocCss.formInput,
                                        stylesDocCss.short8,
                                        stylesDocCss.autoWidth,
                                        stylesDocCss.greenButton + " enabled",
                                        stylesDocCss.editDocumentButton
                                    )}
                                    onClick={(e) => {
                                        this.openPopupToAddSignaturePlaceholders(oneDocument)
                                    }}
                                >
                                    <div className={cs(stylesDocCss.btnText)}>

                                        {oneDocument.brokerFilledValues ? _("editSignaturePlaceholders") : _("addSignaturePlaceholders")}
                                    </div>
                                    {isValid &&
                                        <img
                                            className={stylesDocCss.checkIcon}
                                            src={this.getIcon('ic_done_white_32px')}
                                        />
                                    }
                                </button>
                            }
                            {(!oneDocument.origin || oneDocument.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED) ?
                                <div
                                    type="button"
                                    className={cs(
                                        stylesDocCss.short1
                                    )}
                                    onClick={(e) => {
                                        // can not print the document until is not filled correctly
                                        if (!isValid) {
                                            return this.setState({ printNotValidModalOpen: [_("theDocumentIsNotFilledCorrectlyYet")] })
                                        }

                                        // open printing modal
                                        return this.printPDFManually(oneDocument)
                                    }}
                                >
                                    <img
                                        className={cs(stylesDocCss.checkIcon)}
                                        src={this.getIcon('print-black-18dp')}
                                    />
                                    {oneDocument.isPrinted &&
                                        <img
                                            className={cs(stylesDocCss.checkIcon)}
                                            src={this.getIcon('ic_done_green_32px')}
                                        />}
                                </div>
                                :
                                <div className={stylesDocCss.emptyPrintSpace}></div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * This function will popup a modal with fillable html by a document record.
     * @param {*} oneDocument
     */
    async openFillADocument(oneDocument) {
        const { dispatch } = this.props
        const { packageDSDocuments, claimId } = this.state

        // find the package instance from the first document of the package
        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        let brokerNumber = nesProp.get(packageInstance, "brokerNumber")
        let clientId = nesProp.get(packageInstance, "clientId")
        let contractId = nesProp.get(packageInstance, "contractId")
        let datasetId = nesProp.get(oneDocument, "documentTemplate.dataSetId.datasetId")
        let datasetName = nesProp.get(oneDocument, "documentTemplate.dataSetId.datasetName")
        let language = nesProp.get(oneDocument, "language")
        let optionsLists
        try {
            await dispatch(getDSDataSets())
            const dataSetsForDoc = await dispatch(getDSDataSet(
                datasetName,
                (datasetId === 'clientId') ? clientId : null,
                brokerNumber,
                language,
                (datasetId === 'contractId') ? contractId : null,
                (datasetId === 'claimId') ? claimId : null
            ))

            await dispatch(disableBackgroundProcesses(true))

            if (dataSetsForDoc && dataSetsForDoc.placeholders) {
                const listsToGet = []
                for (let placeholder of dataSetsForDoc.placeholders) {
                    if (placeholder.placeholderList) {
                        listsToGet.push({ placeholderName: placeholder.placeholderName, placeholderList: placeholder.placeholderList })
                    }
                }

                if (listsToGet && listsToGet.length > 0) {
                    const getListRequest = await dispatch(getLists(listsToGet, language))
                    if (getListRequest) {
                        optionsLists = getListRequest
                    }
                }
            }

            this.setState({ isOpenDocumentToFill: { oneDocument, dataSet: dataSetsForDoc, optionsLists } })
        } catch (error) {
            dispatch(setNotification(_('wizardError') + " " + JSON.stringify(error), 'error'))
        }
    }

    /**
     * This function will popup a modal with images from PDF to add placeholders
     * @param {*} oneDocument - Instance of a document record
     */
    async openPopupToAddSignaturePlaceholders(oneDocument) {
        const { dispatch } = this.props
        const { packageDSDocuments } = this.state

        // find the package instance from the first document of the package
        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        await dispatch(disableBackgroundProcesses(true))

        let pdfInfo = await dispatch(getImageListAboutPDF(oneDocument._id))

        this.setState({
            isOpenDocumentForPlaceholders: {
                dsDocument: oneDocument,
                maxPageNumber: (pdfInfo.Pages * 1),
                pageSizeList: pdfInfo.pageSizeList
            }
        })

    }

    /**
     * This will generate the PDF and forward to the ling toward it to print.
     * @param {Object} oneDocument
     */
    async printPDFManually(oneDocument) {
        const { dispatch, templates, lang, brokersTeamWhiteList, DSDocumentOriginTypes, claimWizardDocType } = this.props
        let { moduleKey, subModuleKey, dynamicFieldIdCursor, formInputs } = this.state
        let brokerNumber = nesProp.get(oneDocument, "package.brokerNumber")
        let teamIndex = nesProp.get(oneDocument, "package.team")
        let teamSubgroupId = nesProp.get(oneDocument, "teamSubgroup")

        let linkForPdfDownload = HALF_FILLED_PDF_API_URL + "/" + oneDocument._id
        let w = window.open(linkForPdfDownload, '_blank', 'noopener,noreferrer')

        let onLoadWindowPromise = new Promise((resolve) => {
            w.addEventListener('load', () => {
                resolve()
            }, true)
        })

        await onLoadWindowPromise
        await dispatch(getDsDocsAndPackages(false, false, null, null, true))

        let documentTemplateOptions = getDocumentTemplateOptionList(this.props.templates, lang, moduleKey, subModuleKey, false, claimWizardDocType)

        // tarification case, needs extra filtering for template options
        if (moduleKey === c.DS_MODULE_CLIENT_TARIFICATION && subModuleKey !== c.DS_MODULE_CLIENT_TARIFICATION) {
            documentTemplateOptions = filterTemplatesForBroker(
                documentTemplateOptions, this.props.brokersTeamWhiteList, brokerNumber, teamIndex, teamSubgroupId
            )
        }

        let packageDSDocuments = filterDocumentsByPackageId(this.props.documents, oneDocument.packageId)
        let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor)
        packageDSDocuments = attachIdResult.packageDSDocuments
        dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor

        formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)

        moduleKey = moduleKey || getModuleKeyOfPackage(nesProp.get(this, "state.packageDSDocuments"))
        subModuleKey = subModuleKey || getSubModuleKeyOfPackage(nesProp.get(this, "state.packageDSDocuments"))

        this.setState({ packageDSDocuments, moduleKey, documentTemplateOptions, formInputs, dynamicFieldIdCursor })
    }

    /**
     * Goto the next step. Execute an API call what start a process on the server to create the package on connective.
     * @param {object} ev
     */
    async initStep3(ev) {
        const { dispatch, UsersProcessFlag, DSDocumentOriginTypes } = this.props
        const packageId = nesProp.get(this, "state.packageId") || nesProp.get(this, "props.packageId")
        let { dynamicFieldIdCursor, formInputs, moduleKey, subModuleKey, stakeholders, signerAvailabilityOfTemplates } = this.state
        let error = false

        ev.preventDefault()

        // args: {string}flagName, {string}referenceId, {numeric}checkpointCount
        await dispatch(startUsersProcessFlagWatch(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS, packageId, 4))
        await dispatch(doUsersProcessFlagWatch(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS, packageId))

        this.setState({ step: c.DSWIZARD_STEP_WAITING })

        let noLoader = true // hide spinner
        let resultOfApiCall
        let updatedStakeholders = [...stakeholders]
        try {
            resultOfApiCall = await dispatch(executeFullDSDocumentWizardOnServer(packageId, c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS, noLoader))
            if (resultOfApiCall) {
                const stakeholderIdsToFetch = []
                for (const oneStakeholder of stakeholders) {
                    stakeholderIdsToFetch.push({ stakeholder: oneStakeholder._id })
                }
                updatedStakeholders = await dispatch(getDSStakeholders(stakeholderIdsToFetch))
            }
        } catch (err) {
            console.error(err)
            error = err
        }

        // stop watching the process
        // stop to check the progress
        dispatch(stopUsersProcessFlagWatch(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS, packageId))

        // reloaded package reset cursor
        dynamicFieldIdCursor = 1

        // get documents from props to state
        let packageDSDocuments = filterDocumentsByPackageId(this.props.documents, packageId)
        let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)
        packageDSDocuments = attachIdResult.packageDSDocuments
        dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor

        formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)

        // if there was a warning else just resolve the promise
        if ((resultOfApiCall && resultOfApiCall.warnings && resultOfApiCall.warnings.length > 0) || error) {
            let err = error || resultOfApiCall.warnings

            await new Promise((resolvePopup) => {
                this.setState({
                    isOpenAreYouSure: {
                        title: _('thereWasAnAError'),
                        message: _('thereWasAnErrorWhenCreatePackage'),
                        message1: (nesProp.get(err, "error") ?
                            (JSON.stringify(nesProp.get(err, "error")) + JSON.stringify(nesProp.get(err, "message"))) :
                            <pre>
                                {err && err.errorCodes && this.renderErrorCodes(err.errorCodes)}
                                {jsonBeautify(err, null, 2, 80)}
                            </pre>),
                        message2: nesProp.get(err, "message") + (err.errorTranslationKey ? _(err.errorTranslationKey) : ""),
                        isErrorMessage: true,
                        callBackCancel: () => { resolvePopup() },
                        callBackOk: () => { resolvePopup() }
                    }
                })
            })

            this.closeModal()

            throw err
        }

        // display the waiting STEP
        this.setState({ stakeholders: updatedStakeholders, dynamicFieldIdCursor, formInputs, packageDSDocuments })

        return resultOfApiCall
    }

    /**
     * This function will render the error codes from the server response of the API call what create the package on connective.
     * @param {Array} codes
     */
    renderErrorCodes(codes) {
        if (!codes || codes.length === 0) {
            return ""
        }

        return <div>
            {codes.map((oneCode, index) => {
                return <div key={index}>{_(oneCode)}</div>
            })}
        </div>
    }

    /**
     * Render second page of wizard
     **/
    renderDSWizardPopup2() {
        const { isValidTheForm, packageDSDocuments, customModalTitle2, customModalDescriptionStep2,
            stakeholders, formInputs, signerAvailabilityOfTemplates } = this.state
        const { DSDocumentOriginTypes } = this.props

        // totalNumberOfSigners is require to validate PDF documents about the signature placeholder count.
        let totalNumberOfSigners = stakeholders.length

        return (
            <div className={stylesDocCss.documentsModalContent}
                key={"mifidStep2"}
            >
                <span className={stylesDocCss.title} key={"mifidStepTitle2"}>
                    {customModalTitle2 ? customModalTitle2 : _('DSWizardModalTitle2')}
                </span>
                <form method="post" onSubmit={(ev) => ev.preventDefault()} className={stylesDocCss.modalFormContent}
                    key={"mifidStep2Form"}>
                    <div className={stylesDocCss.message} key={"mifidStep2messageDescription"}>
                        <div className={stylesDocCss.resendModalContainer} key={"mifidStep2messageDescriptionResendModalContainer"}>

                            <div className={stylesDocCss.columnContainer} key={"DSWizardModalDescription2columnContainerKey"}>
                                <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel, stylesDocCss.autoHeight)}
                                    key={"DSWizardModalDescription2FormInputContainerKey"}
                                >
                                    <div className={stylesDocCss.whitespacePre} key={"DSWizardModalDescription2WhitespacePreKey"}
                                        dangerouslySetInnerHTML={{ __html: customModalDescriptionStep2 ? customModalDescriptionStep2 : _('DSWizardModalDescription2') }} />
                                </div>

                                <div className={stylesDocCss.oneRowItem}
                                    key={"DSWizardModalDescription2oneRowItemKey"}
                                >
                                    {packageDSDocuments && packageDSDocuments.map((oneDocument) => {
                                        return (
                                            this.renderDocumentFillAndPrintBlock(oneDocument)
                                        )
                                    })}
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={stylesDocCss.documentsModalButtons} key={"mifidStep2documentsModalButtons"}>
                        <div
                            onClick={() => {
                                // just reset triggers and states and close modal
                                this.closeModal()
                            }}
                            className={stylesDocCss.cancel}
                            key={"mifidStep2ButtonsCloseModal"}
                        >
                            {_("cancel")}
                        </div>
                        <button
                            type="button"
                            className={stylesDocCss.greenButton + " enabled"}
                            onClick={async (e) => {
                                this.startLoading()
                                try {
                                    let newFormInputs = await this.initStep1(formInputs)

                                    this.setState({
                                        step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE,
                                        formInputs: newFormInputs
                                    })
                                } catch (err) {
                                    console.error(err)
                                }

                                this.stopLoading()

                            }}
                            key={"mifidStep2ButtonsBackToStep1"}
                        >
                            {_("back")}
                        </button>
                        <button
                            key={"mifidStep2ButtonsNextToStep2"}
                            type="button"
                            className={stylesDocCss.greenButton + ((!isValidTheForm.isValid) ? " disabled" : " enabled")}
                            disabled={!isValidTheForm.isValid}
                            onClick={(e) => {
                                let documentsAreNotValidModalOpen = getTheListOfInvalidDocuments(
                                    packageDSDocuments,
                                    totalNumberOfSigners,
                                    DSDocumentOriginTypes
                                )

                                let resultOfUsage = isUsedAllOfStakeholders(
                                    packageDSDocuments,
                                    stakeholders,
                                    DSDocumentOriginTypes,
                                    signerAvailabilityOfTemplates
                                )

                                let isThisASignablePackage = areThereSignableDocuments(
                                    packageDSDocuments,
                                    DSDocumentOriginTypes
                                )

                                let { stakeholderUsageMap, areNonUsedStakeholders } = resultOfUsage

                                // check if there is an invalid document
                                if (areNonUsedStakeholders && isThisASignablePackage) {
                                    return this.setState({
                                        documentsAreNotValidModalOpen: [],
                                        areNonUsedStakeholders,
                                        stakeholderUsageMap
                                    })
                                } else {
                                    this.setState({
                                        documentsAreNotValidModalOpen: false,
                                        areNonUsedStakeholders: false,
                                        stakeholderUsageMap: {}
                                    })
                                }

                                // check if there is an invalid document
                                if (documentsAreNotValidModalOpen && documentsAreNotValidModalOpen.length > 0) {
                                    return this.setState({ documentsAreNotValidModalOpen })
                                }

                                return this.initStep3(e)
                                    .then(() => {
                                        // forward the wizard
                                        // let the user to see the fourth dot before leaving the waiting modal
                                        //setTimeout(() => {
                                        this.setState({ step: c.DSWIZARD_STEP_3_BROKER_FILLING })
                                        //}, 500)
                                    })
                                    .catch(err => {
                                        console.warn('error init step 3 ', err);
                                    })
                            }}
                        >
                            {_("Next")}
                        </button>
                    </div>
                </form>
            </div>
        )
    }

    /**
     * This function will navigate to package.
     * @param {string} packageId
     */
    onClickDSDocInSamePackage(packageId) {
        const { dispatch } = this.props

        // refresh the packages and documents before navigate to details.
        dispatch(getDsDocsAndPackages(false, false, null, null, true))
            .then(() => {
                this.closeModal()

                dispatch(setAppModule(c.DSDOCUMENTS))
                dispatch(setDSDocumentsOpenedPackage(packageId))
                dispatch(setDSDocumentsSubModule('detailedPackage'))

                return
            })
    }

    /**
     * The finisher dialog
     */
    renderDSWizardPopup3() {
        const { customModalTitle3, customModalDescriptionStep3, DSDocumentOriginTypes, createmail, dispatch, isOffice } = this.props
        const { packageDSDocuments, packageId, moduleKey, moduleOptions, selectedTicketRelatedOraDocuments,
            invitationEmailSent, /* moduleKeyToSetForEmailer, */ stakeholders } = this.state

        const formFiller = stakeholders.find(oneStakeholder => {
            return oneStakeholder.roles.find(oneRole => oneRole.type === 'formFiller' && oneRole.status === 'Available')
        })

        let URLForSign = nesProp.get(packageDSDocuments, "0.package.F2FSigningUrl")
        let URLForPreview = nesProp.get(packageDSDocuments, "0.package.previewUrl")
        let areConnectiveDocuments = areThereDocumentSentToConnective(packageDSDocuments, DSDocumentOriginTypes)

        let packageInstance = {}
        if (packageDSDocuments) {
            packageInstance = nesProp.get(packageDSDocuments, "0.package")
        }

        return (
            <div className={stylesDocCss.documentsModalContent} key={"mifidStep3"}>
                <span className={stylesDocCss.title}>
                    {customModalTitle3 ? customModalTitle3 : _('DSWizardModalTitle3')}
                </span>
                <form method="post" onSubmit={(ev) => ev.preventDefault()} className={stylesDocCss.modalFormContent}>
                    <span className={stylesDocCss.message}>
                        <div className={stylesDocCss.resendModalContainer}>
                            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)} key="step3ModalDescription2">
                                {!areConnectiveDocuments ?
                                    <div className={stylesDocCss.whitespacePre}>
                                        {customModalDescriptionStep3 ? customModalDescriptionStep3 : _('DSWizardModalDescription3NoDocsForSign')}
                                    </div>
                                    :
                                    <div className={stylesDocCss.whitespacePre}>
                                        {customModalDescriptionStep3 ? customModalDescriptionStep3 : _('DSWizardModalDescription3')}
                                    </div>
                                }
                            </div>
                        </div>
                    </span>
                    <div className={stylesDocCss.documentsModalButtons}>
                        {/* <button
                            type="button"
                            className={stylesDocCss.greenButton + " enabled"}
                            onClick={(e)=>{
                                let firstDocId = nesProp.get(packageDSDocuments, "0._id")
                                this.onClickDSDocInSamePackage(packageId)
                            }}
                            key={"goToDocumentsButtonKey"}
                        >
                            {_("goToDocuments")}
                        </button> */}
                        {areConnectiveDocuments && createmail && !invitationEmailSent &&
                            <EmailButton
                                onInit={() => {
                                    let attachments = this.state.emailAttachmentsTicketRelatedOraDocuments
                                    if (attachments && attachments.length) {
                                        let files = attachments.map((oneDoc) => {
                                            return {
                                                name: oneDoc.oracleDocumentType,
                                                date: "-",
                                                id: oneDoc.oracleDocumentId,
                                                typeDocument: oneDoc.oracleDocumentType
                                            }
                                        })

                                        dispatch(setEmailSenderExternalAttachments(files))
                                    }

                                    return
                                }}
                                onSentLate={async (responses) => {
                                    try {
                                        if (!responses || responses.length === 0) {
                                            return
                                        }

                                        for (let i = 0; i < responses.length; i++) {
                                            let emailId = nesProp.get(responses, i + ".emailRecord._id")
                                            let toEmailAddress = nesProp.get(responses, i + ".emailRecord.toEmailAddress")

                                            // skip the step, no email sent
                                            if (!emailId) { continue }

                                            // update all stakeholder as invited
                                            for (let j = 0; j < stakeholders.length; j++) {
                                                if (toEmailAddress && toEmailAddress.length > 0 &&
                                                    toEmailAddress.some((email) =>
                                                        (String(email).toLowerCase() === String(stakeholders[j].email).toLowerCase())
                                                    )
                                                ) {
                                                    await dispatch(upsertDSPackageEmailStatus(
                                                        packageId, emailId, { isInvitation: true, stakeholderId: stakeholders[j]._id } /* --> ?? mailOptions*/
                                                    ))
                                                    await dispatch(updateDSStakeholder(
                                                        { stakeholderId: stakeholders[j]._id, isInvited: true }
                                                    ))
                                                }
                                            }

                                            packageInstance = await dispatch(getOneDsPackageById(packageId))
                                        }
                                    } catch (e) {
                                        console.error(e)
                                        throw e
                                    }

                                    this.setState({ invitationEmailSent: true }, () => {
                                        this.closeModal()
                                    })
                                }}
                                moduleKeyToSet={getEmailerModuleKeyByWizardModuleKey(moduleKey) /* moduleKeyToSetForEmailer */}
                                moduleOptions={
                                    {
                                        ...moduleOptions,
                                        dsPackage: packageInstance,
                                        brokerNumber: nesProp.get(packageInstance, "brokerNumber"),
                                        brokerEmailAddress: nesProp.get(packageInstance, "brokerEmailAddress"),
                                        stakeholders: stakeholders.filter((oneStake) => (oneStake.signerType !== "BROKER")),
                                        autoSelectTemplate: true,
                                        usePlaceholdersForClientVariables: true,
                                        // overwrite client email addresses, for signer emailaddress-es
                                        clientEmails: stakeholders
                                            .filter((oneStake) => (oneStake.signerType !== "BROKER"))
                                            .map((oneHolder) => ({
                                                referenceId: oneHolder._id,
                                                value: oneHolder.email,
                                                lang: oneHolder.language,
                                                isPermanentSelected: true,
                                                isCC: false,
                                                label: oneHolder.firstName + " " + oneHolder.lastName
                                            })
                                            )
                                    }
                                }
                                getDSStakeholders={async (stakeholderIdArray) => (await dispatch(getDSStakeholders(stakeholderIdArray)))}
                                customButtonLabel={_('customizeInvitationEmail')}
                                customClassName={stylesDocCss.greenButton + " enabled"}
                                key={"customizeInvitationRenderEmailSenderButtonKey"}
                                isWhiteIcon={true}
                                modalId={c.EMAILER_MODAL_ID_DSWIZARD_STEP_3}
                                hideCC={isOffice ? false : true}
                                isCreatable={isOffice ? true : false}
                                multiLanguage={true}
                                serialSending={true}
                                forceIsMulti={true}
                            />
                        }
                        {areConnectiveDocuments &&
                            <button
                                type="button"
                                className={stylesDocCss.greenButton + " enabled"}
                                onClick={(e) => {
                                    // open direct signing and close the modal
                                    if (formFiller) {
                                        window.open(formFiller.privateLink, '_blank', 'noopener,noreferrer')
                                    } else {

                                        window.open(URLForSign, '_blank', 'noopener,noreferrer')
                                    }

                                    this.closeModal()

                                    dispatch(removeUsersProcessFlagWatch(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS, packageId))

                                    //if the cancel command comes from PREM -- after creating a mandate contract, should remove it from state
                                    if (this.state.isPrem) {
                                        dispatch(setClientSubModule(
                                            'contracts',
                                            { contractId: this.state.contractId },
                                            null
                                        ))
                                    }

                                }}
                                key={"signNowButtonKey"}
                            >
                                {_('signNow')}
                            </button>
                        }
                        {!areConnectiveDocuments && <button
                            type="button"
                            className={stylesDocCss.greenButton + " enabled"}
                            onClick={(e) => {
                                this.closeModal()

                                dispatch(removeUsersProcessFlagWatch(c.DSWIZARD_PDF_CONNECTIVE_EMAIL_PROCESS, packageId))

                                //if the cancel command comes from PREM -- after creating a mandate contract, should remove it from state
                                if (this.state.isPrem) {
                                    dispatch(setClientSubModule(
                                        'contracts',
                                        { contractId: this.state.contractId },
                                        null
                                    ))
                                }
                            }}
                            key={"finishWizardButtonKey"}
                        >
                            {_("ok")}
                        </button>}
                    </div>
                </form>
            </div>
        )
    }

    /**
     * This step can be used in any case, when there is a waiting.
     * @returns
     */
    renderDSWizardPopupWait() {
        const { UsersProcessFlag } = this.props
        const { packageId } = this.state

        let textKey = nesProp.get(UsersProcessFlag, `${packageId}.record.customData`) || "usersProcessStatus_initialize"
        let status = nesProp.get(UsersProcessFlag, `${packageId}.record.status`) * 1
        let checkpointCount = nesProp.get(UsersProcessFlag, `${packageId}.checkpointCount`) * 1

        let dotClassesList = []

        // iterate steps to setup the class list for step indicator dots
        for (let i = 0; i < checkpointCount; i++) {
            dotClassesList[i] = [stylesDocCss.progressDot]

            // step in progress must be gray
            if (status == i) {
                dotClassesList[i].push(stylesDocCss.progressDotInProgress)
            }

            // step completed must be green
            if (status > i) {
                dotClassesList[i].push(stylesDocCss.progressDotFilled)
            }
        }

        //init dots array To Render Dots And Lines also
        let dotAndLinesArray = [...Array(checkpointCount * 2 - 1).keys()]

        return (
            <div className={stylesDocCss.documentsModalContent}
                key={"mifidStepWait"}>
                <span className={stylesDocCss.title} >
                    {_('DSWizardModalTitleWait')}
                </span>
                <form method="post" onSubmit={(ev) => ev.preventDefault()} className={stylesDocCss.modalFormContent}>
                    <span className={stylesDocCss.message} key="step3ModalSpanMessage">
                        <div className={stylesDocCss.resendModalContainer} key="step3ModalresendModalContainer">
                            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)} key="step3ModalDescription1">
                                <div className={stylesDocCss.progress}>
                                    <div className={stylesDocCss.progressDotsContainer} key={"progressDotsContainerKey"}>
                                        {dotAndLinesArray.map((elementNumber) => {
                                            if (!(elementNumber * 1 % 2)) {
                                                return <div className={cs(dotClassesList[elementNumber * 1 / 2])}>{elementNumber * 1 / 2}</div>
                                            }
                                            return <div className={stylesDocCss.progressLine}></div>
                                        })}
                                    </div>
                                    <div className={stylesDocCss.progressText} key={"progressDotsProgressTextKey"}>
                                        {_(textKey)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>
                </form>
            </div>
        )
    }

    /**
     * Any case of modal close must call this function to reset states and call the callback function
     */
    closeModal() {
        const { dispatch, moduleKey } = this.props
        const { callBackOnClose, callBackOnCloseFromClaimWizard } = this.props
        const { clientId, tarificationId, packageId } = this.state
        this.setState({ step: c.DSWIZARD_STEP_1_COMPOSE_PACKAGE })
        this.setState({ isValidTheForm: { isValid: true } })

        dispatch(setDSWizard(false))

        if (this.state.isPrem) {
            this.setState({ isPrem: false })
        }

        dispatch(setClientCreateContractState(''))

        if (moduleKey === c.DS_MODULE_CLAIM_WIZARD) {
            callBackOnCloseFromClaimWizard(packageId)
        }

        //anyway must called to reset external trigger also for modal opening
        callBackOnClose(clientId, tarificationId)
    }

    /**
     * Content of filling the document template error
     * @param {*} fillTemplateErrorsModalOpen
     * @returns
     */
    fillTemplateErrorsRender(fillTemplateErrorsModalOpen) {
        return (
            <div className={stylesDocCss.documentsModalContent} key={"fillTemplateErrorsModalContentDivKey"}>
                <span className={stylesDocCss.title}>{_('fillTemplateErrorsModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}>{_('fillTemplateErrorsModalDescription')}</div>

                        {fillTemplateErrorsModalOpen && <div>
                            {fillTemplateErrorsModalOpen.map((item, index) => {
                                return (<div key={"index" + index}>{item}</div>)
                            })}
                        </div>}

                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            this.setState({ fillTemplateErrorsModalOpen: false })
                        }}
                        className={stylesDocCss.greenButton + " enabled"}
                    >
                        {_("ok")}
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Content of filling the document template error
     * @param {*} printNotValidModalOpen
     * @returns
     */
    printingAbortErrorsRender(printNotValidModalOpen) {
        return (
            <div className={stylesDocCss.documentsModalContent} key={"printingAbortErrorsModalRenderKey"}>
                <span className={stylesDocCss.title}>{_('printNotValidModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}>{_('printNotValidModalDescription')}</div>

                        {printNotValidModalOpen && <div>
                            {printNotValidModalOpen.map((item, index) => {
                                return (<div key={"index" + index}>{item}</div>)
                            })}
                        </div>}

                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            this.setState({ printNotValidModalOpen: false })
                        }}
                        className={stylesDocCss.greenButton + " enabled"}
                    >
                        {_("ok")}
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Used to display errors when copying files from template attachments to local uploads 
     * @param {*} templateAttachmentDocumentsError 
     * @returns 
     */
    templateAttachmentDocumentsErrorRender(templateAttachmentDocumentsError) {
        return (
            <div className={stylesDocCss.documentsModalContent} key={"printingAbortErrorsModalRenderKey"}>
                <span className={stylesDocCss.title}>{_('templateAttachmentDocumentsErrorModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}>{_('templateAttachmentDocumentsErrorDescription')}</div>

                        {templateAttachmentDocumentsError && templateAttachmentDocumentsError.length > 0 && <div>
                            {templateAttachmentDocumentsError.map((item, index) => {
                                return (
                                    <div key={"index" + index}>
                                        <div className={stylesDocCss.message}>
                                            <span>{_('errorFileName')} : {item.originalname}</span>
                                            <span>{_('errorMessage')} : {item.error}</span>
                                        </div>

                                    </div>
                                )
                            })}
                        </div>}

                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            this.setState({ templateAttachmentDocumentsError: false })
                        }}
                        className={stylesDocCss.greenButton + " enabled"}
                    >
                        {_("ok")}
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Content of invalid documents fills error modal
     * @param {*} documentsAreNotValidModalOpen - list of documents with invalid fillings
     * @returns React node
     */
    warningModalDocumentsAreNotValidRender(documentsAreNotValidModalOpen) {
        const { DSDocumentOriginTypes } = this.props
        const { areNonUsedStakeholders, stakeholderUsageMap } = this.state
        return (
            <div className={stylesDocCss.documentsModalContent} key={"warningDocumentsAreNotValidRenderContentKey"}>
                <span className={stylesDocCss.title}>{_('documentsAreNotValidModalTitle')}</span>
                <span className={stylesDocCss.message}>
                    <div className={stylesDocCss.resendModalContainer}>
                        <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}>{_('documentsAreNotValidModalDescription')}</div>

                        {documentsAreNotValidModalOpen && documentsAreNotValidModalOpen.length > 0 && <div>
                            {documentsAreNotValidModalOpen.map((dsDoc, index) => {
                                return (<div key={"index" + index}>
                                    {(dsDoc.origin === DSDocumentOriginTypes.DS_ORIGIN_GENERATED) && (dsDoc.fileName + ": " + _("documentTemplateNotFilledCorrectly"))}
                                    {(dsDoc.origin !== DSDocumentOriginTypes.DS_ORIGIN_GENERATED) && (dsDoc.fileName + ": " + _("documentMustHavePlacedSignerPlaceholders"))}
                                    {dsDoc.errorMessages && <div className={stylesDocCss.marginLeft1em}>
                                        {dsDoc.errorMessages.map((message, index) => {
                                            return (<div>{message}</div>)
                                        })}
                                    </div>}
                                </div>)
                            })}
                        </div>}

                        {documentsAreNotValidModalOpen && areNonUsedStakeholders && <div>
                            {_("notAllStakeholdersAreNotUsed")}
                            <div className={stylesDocCss.marginLeft1em}>
                                {Object.keys(stakeholderUsageMap).map((oneKey, index) => {
                                    let holder = stakeholderUsageMap[oneKey]
                                    return (holder ?
                                        <div key={"index" + index}>
                                            <div>{holder.firstName + " " + holder.lastName + " [" + holder.email + "] "}</div>
                                        </div> : null)
                                })}
                            </div>
                        </div>}

                    </div>
                </span>
                <div className={stylesDocCss.documentsModalButtons}>
                    <div
                        onClick={() => {
                            this.setState({ documentsAreNotValidModalOpen: false })
                        }}
                        className={stylesDocCss.greenButton + " enabled"}
                    >
                        {_("ok")}
                    </div>
                </div>
            </div>
        )
    }

    /**
     * This function will effect the attaching of document to the attachment list.
     * @param {array} selected0 - list of claim documents
     * @param {array} selected - list of contract documents
     * @param {array} selected2 - list of client documents
     * @param {array} selected3 - list of tarification documents
     */
    async handleConfirmSelectedAttachments(selected0 = [], selected1 = [], selected2 = [], selected3 = [], selected4 = [], selected5 = []) {
        let { DSDocumentOriginTypes, stakeholders, claimWizardDocType } = this.props
        let { packageDSDocuments, formInputs, isValidTheForm, dynamicFieldIdCursor, moduleKey, subModuleKey,
            languageOptions, documentTemplateOptions, claimId, claimNumber,
            contractId, tarificationId, tarificationNumber, isPrem, signerAvailabilityOfTemplates } = this.state

        // add attachments from default document list of current module
        let selectedClaimRelatedOraDocuments = prepareOracleDocumentsFromUploaderSelectionDocList(selected0, c.CLAIM_DOCUMENTS_TAB, claimWizardDocType)

        // add attachments from default document list of current module
        let selectedContractRelatedOraDocuments = prepareOracleDocumentsFromUploaderSelectionDocList(selected1, c.CONTRACT_DOCUMENTS_TAB, claimWizardDocType)

        // add attachments from default document list of current module
        let selectedTarificationRelatedOraDocuments = prepareOracleDocumentsFromUploaderSelectionDocList(selected3, c.TARIFICATION_DOCUMENTS_TAB, claimWizardDocType)

        // add attachments from optional document list of current module
        let selectedClientRelatedOraDocuments = prepareOracleDocumentsFromUploaderSelectionDocList(selected2, c.PROFILE_DOCUMENTS_TAB, claimWizardDocType)

        // add attachments from optional document list of current module
        let selectedTicketRelatedOraDocuments = prepareOracleDocumentsFromUploaderSelectionDocList(selected4, c.TICKET_DOCUMENTS_TAB, claimWizardDocType)

        // merge all selected lists together for show
        let selectedOracleDocuments = selectedClaimRelatedOraDocuments.concat(
            selectedContractRelatedOraDocuments,
            selectedTarificationRelatedOraDocuments,
            selectedClientRelatedOraDocuments,
            selectedTicketRelatedOraDocuments
        )

        let cursorsListToRemove = []
        // remove oracle documents that have been unselected
        for (const onePackageDocument of packageDSDocuments) {
            // if the origin is ORACLE
            if (onePackageDocument.oracleDocumentId) {

                // document is it on the list of selected documents from uploader table?
                const keepDocument = selectedOracleDocuments.some(selectedDocument => {
                    return selectedDocument.id === onePackageDocument.oracleDocumentId
                })

                // not in the selection list but have oracle id clear it
                if (!keepDocument) {
                    cursorsListToRemove.push(onePackageDocument.cursor)
                }
            }
        }

        // remove the collected ID-s by unselected documents
        // do like this because not healthy to modify the array what is iterated in a loop
        if (cursorsListToRemove && cursorsListToRemove.length > 0) {
            for (const oneCursor of cursorsListToRemove) {
                // filter document list
                packageDSDocuments = removeDSDocumentFromThePackage(oneCursor, packageDSDocuments)

                // filter input list
                formInputs = removeFormInputByCursor(oneCursor, formInputs)
            }
        }

        let clientLanguage = nesProp.get(formInputs, "clientLanguage.value")
        let team = nesProp.get(formInputs, "team.value")
        let teamName = nesProp.get(formInputs, "teamName.value")
        let teamSubgroup = nesProp.get(formInputs, "teamSubgroup.value")

        // add the missing documents to the form
        for (const oneOraDocument of selectedOracleDocuments) {
            if (!oraDocumentAlreadyInList(oneOraDocument, packageDSDocuments)) {

                let result = await this.createDSDocumentForPackage(
                    packageDSDocuments,
                    clientLanguage,
                    { team, teamName, teamSubgroup },
                    dynamicFieldIdCursor,
                    languageOptions,
                    documentTemplateOptions,
                    { contractId, tarificationId, tarificationNumber, claimId, claimNumber, moduleKey, subModuleKey, isPrem },
                    null,
                    oneOraDocument
                )

                formInputs = {
                    ...formInputs,
                    ...result.documentFormInputs
                }

                packageDSDocuments = result.packageDSDocuments
                dynamicFieldIdCursor = result.dynamicFieldIdCursor
            }

        }

        formInputs = this.onUpdateFormInputs(formInputs, packageDSDocuments, stakeholders, moduleKey, subModuleKey)
        formInputs = formInputsValidation(formInputs)
        isValidTheForm = validateTheForm(formInputs, packageDSDocuments, DSDocumentOriginTypes, true)

        // ++++++++++++ start handle enabled signers list ++++++++++++++
        let addSignersButtonFlags = getSignerAdderButtonsFlags(packageDSDocuments, DSDocumentOriginTypes, isPrem, signerAvailabilityOfTemplates)
        let isItExistFirstSignerPlaceholder = addSignersButtonFlags.isItExistFirstSignerPlaceholder
        let isItExistSecondSignerPlaceholder = addSignersButtonFlags.isItExistSecondSignerPlaceholder
        let isItExistBrokerSignerPlaceholder = addSignersButtonFlags.isItExistBrokerSignerPlaceholder
        // yes it can be destructured directly in state but then I cant find it in the code where is modified the state for
        // those properties, so don't do that
        //---------------- end handle enabled signers list

        this.setState({
            packageDSDocuments,
            formInputs,
            isValidTheForm,
            dynamicFieldIdCursor,
            selectedClaimRelatedOraDocuments,
            selectedContractRelatedOraDocuments,
            selectedTarificationRelatedOraDocuments,
            selectedClientRelatedOraDocuments,
            selectedTicketRelatedOraDocuments,

            isItExistFirstSignerPlaceholder,
            isItExistSecondSignerPlaceholder,
            isItExistBrokerSignerPlaceholder
        })
    }

    /**
     * Takes the selected documents from the attachment modal and decides if there are changes that might affect a previous selection
     * @param {*} selectedClaimDocuments
     * @param {*} selectedContractDocuments
     * @param {*} selectedClientDocuments
     * @param {*} selectedTarificationDocuments
     * @returns boolean
     */
    checkForOracleDocumentsChanges(selectedClaimDocuments = [], selectedContractDocuments = [], selectedClientDocuments = [], selectedTarificationDocuments = [], selectedTicketDocuments = []) {
        const { selectedClaimRelatedOraDocuments, selectedContractRelatedOraDocuments, selectedTarificationRelatedOraDocuments,
            selectedClientRelatedOraDocuments, selectedTicketRelatedOraDocuments } = this.state
        let hasChanges = true

        if (
            ((!selectedClaimRelatedOraDocuments || selectedClaimRelatedOraDocuments.length === 0) ||
                (selectedClaimRelatedOraDocuments.length === selectedClaimDocuments.length &&
                    selectedClaimRelatedOraDocuments.every(oneDoc => selectedClaimDocuments.some(oneSelectedDoc => oneSelectedDoc.id === oneDoc.id))))

            && ((!selectedContractRelatedOraDocuments || selectedContractRelatedOraDocuments.length === 0) ||
                (selectedContractRelatedOraDocuments.length === selectedContractDocuments.length &&
                    selectedContractRelatedOraDocuments.every(oneDoc => selectedContractDocuments.some(oneSelectedDoc => oneSelectedDoc.id === oneDoc.id))))

            && ((!selectedTarificationRelatedOraDocuments || selectedTarificationRelatedOraDocuments.length === 0) ||
                (selectedTarificationRelatedOraDocuments.length === selectedTarificationDocuments.length &&
                    selectedTarificationRelatedOraDocuments.every(oneDoc => selectedTarificationDocuments.some(oneSelectedDoc => oneSelectedDoc.id === oneDoc.id))))

            && ((!selectedClientRelatedOraDocuments || selectedClientRelatedOraDocuments.length === 0) ||
                (selectedClientRelatedOraDocuments.length === selectedClientDocuments.length &&
                    selectedClientRelatedOraDocuments.every(oneDoc => selectedClientDocuments.some(oneSelectedDoc => oneSelectedDoc.id === oneDoc.id))))

            && ((!selectedTicketRelatedOraDocuments || selectedTicketRelatedOraDocuments.length === 0) ||
                (selectedTicketRelatedOraDocuments.length === selectedTicketDocuments.length &&
                    selectedTicketRelatedOraDocuments.every(oneDoc => selectedTicketDocuments.some(oneSelectedDoc => oneSelectedDoc.oracleDocumentId === oneDoc.oracleDocumentId))))) {

            hasChanges = false
        }
        return hasChanges
    }

    /**
    * this will open the emailAttachments modal which will serve in this case to select existing documents to send to oracle for signing
    */
    openOracleDocumentsModal() {
        const { dispatch } = this.props
        dispatch(showEmailSenderAttachmentModal(
            "dsDocumentsSelectionModal",
            _("selectDocuments"),
            _("pleaseSelect"),
            "select",
            null
        ))
    }

    /**
     * Open warning modal
     * @param {*} isThereXSSFiltered
     * @param {*} suspectValues
     */
    async openWarningModalForXssIssue(isThereXSSFiltered, suspectValues) {
        return this.setState({ warningModalOpen: isThereXSSFiltered ? suspectValues : false })
    }

    /**
     * Get Actual Documents From Store from DSDocuments.items path
     */
    getActualDocumentsFromStore() {
        return this.props ? this.props.documents : null
    }

    /**
     * Set the actual package documents in state
     * @param {*} packageDSDocuments
     */
    async setPackageDocuments(packageDSDocuments) {
        let { formInputs, moduleKey, subModuleKey } = this.state
        let { DSDocumentOriginTypes } = this.props

        formInputs = synchronizePackageDSDocumentsInputsFromForm(formInputs, packageDSDocuments, moduleKey, subModuleKey, DSDocumentOriginTypes)

        return this.setState({ packageDSDocuments, formInputs })
    }

    render() {
        const { DSWizardOpened, dispatch, DSDocumentOriginTypes, moduleOptions, moduleKey, ticketDocuments, subModuleKey, isOffice } = this.props
        const { isOpenIntervalInfo, isOpenTicketIntervalInfo, step, isLoaded, isOpenDocumentToFill, isOpenDocumentForPlaceholders, warningModalOpen, isOpenAreYouSure,
            fillTemplateErrorsModalOpen, documentsAreNotValidModalOpen, printNotValidModalOpen, stakeholders, templateAttachmentDocumentsError } = this.state

        let { dynamicFieldIdCursor } = this.state
        let intervalInfoTitle = ''
        let intervalInfoDescription = ''
        let openIntervalInfoModal = false
        if (isOpenIntervalInfo) {
            intervalInfoTitle = _('IntervalInfoModalTitle')
            intervalInfoDescription = _('IntervalInfoModalDescription')
            openIntervalInfoModal = Boolean(isOpenIntervalInfo)
        } else if (isOpenTicketIntervalInfo) {
            intervalInfoTitle = _('IntervalTicketInfoModalTitle')
            intervalInfoDescription = _('IntervalTicketInfoModalDescription')
            openIntervalInfoModal = Boolean(isOpenTicketIntervalInfo)
        }

        return (<div key="rootComponentOfDsWizardRender">
            <Modal
                isOpen={Boolean(DSWizardOpened)}
                style={customModalStyles}
                contentLabel={""}
                key={"DSWizardModal"}
            >
                {(!step || step === c.DSWIZARD_STEP_1_COMPOSE_PACKAGE) && this.renderDSWizardPopup()}
                {(step === c.DSWIZARD_STEP_2_FILL_DOCUMENTS) && this.renderDSWizardPopup2()}
                {(step === c.DSWIZARD_STEP_3_BROKER_FILLING) && this.renderDSWizardPopup3()}

                {(step === c.DSWIZARD_STEP_WAITING) && this.renderDSWizardPopupWait()}
            </Modal>

            <IntervalInfoPopup
                isOpen={openIntervalInfoModal}
                style={customModalStyles}
                contentLabel={""}
                didClose={() => {
                    this.setState({ isOpenIntervalInfo: false, isOpenTicketIntervalInfo: false })
                }}
                key={"IntervalInfoPopup"}
                modalTitle={intervalInfoTitle}
                modalDescription={intervalInfoDescription}
            >
            </IntervalInfoPopup>

            <OpenDocumentToFillModal
                isOpen={Boolean(isOpenDocumentToFill)}
                style={customModalStylesForFillForm}
                contentLabel={""}
                dataForEditDocument={isOpenDocumentToFill}
                stakeholders={stakeholders}
                packageDSDocuments={this.state.packageDSDocuments}
                lang={this.props.lang}
                packageId={nesProp.get(this, "state.packageId") || nesProp.get(this, "props.packageId")}
                showWarningXss={(isThereXSSFiltered, suspectValues) => {
                    return this.openWarningModalForXssIssue(isThereXSSFiltered, suspectValues)
                }
                }
                didClose={() => {
                    this.setState({ isOpenDocumentToFill: false })
                    //this.setState({isLoaded: true})
                    this.stopLoading()
                    dispatch(disableBackgroundProcesses(false))
                }}
                onCancel={() => {
                }}
                onSave={async (oneDocumentUpdatableProps) => {
                    const updatedDocument = await dispatch(upsertDSDocumentAndFetchAllData(oneDocumentUpdatableProps))

                    dynamicFieldIdCursor = 1
                    let packageId = nesProp.get(this, "state.packageId") || nesProp.get(this, "props.packageId")

                    // refresh state packageDSDocuments from props "documents" by packageId, because after
                    // the API call of upsertDSDocumentAndFetchAllData the documents are reloaded in store
                    let docsFromProps = this.getActualDocumentsFromStore()
                    let packageDSDocuments = filterDocumentsByPackageId(docsFromProps, packageId)
                    let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)
                    packageDSDocuments = attachIdResult.packageDSDocuments
                    dynamicFieldIdCursor = attachIdResult.dynamicFieldIdCursor

                    this.setState({ dynamicFieldIdCursor: dynamicFieldIdCursor })

                    // immediately update the document in state to show the actualised data on render
                    packageDSDocuments = packageDocumentsListUpdateByDocument(packageDSDocuments, updatedDocument) //sync

                    await this.setPackageDocuments(packageDSDocuments)

                    // invalid fill of template
                    if (oneDocumentUpdatableProps.errorMessages.length > 0) {
                        let errorInstance = new Error()
                        errorInstance.error = oneDocumentUpdatableProps.errorMessages
                        throw errorInstance
                    }
                }}
                key={"OpenDocumentToFillModal"}
            ></OpenDocumentToFillModal>

            <PopupOfSignaturePlaceholder
                isOpen={Boolean(isOpenDocumentForPlaceholders)}
                style={customModalStylesForFillForm}
                contentLabel={""}
                dataForEditDocument={isOpenDocumentForPlaceholders}
                stakeholders={stakeholders}
                packageDSDocuments={this.state.packageDSDocuments}
                lang={this.props.lang}
                DSDocumentOriginTypes={DSDocumentOriginTypes}
                dynamicFieldIdCursor={nesProp.get(this, "state.dynamicFieldIdCursor")}
                setFieldIdCursor={(dynamicFieldIdCursor) => {
                    return this.setState({ dynamicFieldIdCursor: dynamicFieldIdCursor })
                }}
                getDocumentsFromStore={() => { return this.getActualDocumentsFromStore() }}
                updatePackageDocuments={(packageDSDocuments) => { return this.setPackageDocuments(packageDSDocuments) }}
                didClose={() => {
                    this.setState({ isOpenDocumentForPlaceholders: false })
                    //this.setState({isLoaded: true})
                    this.stopLoading()
                    dispatch(disableBackgroundProcesses(false))
                }}
                onCancel={() => {
                }}
                onSave={(updatedDocument) => {
                }}
                key={"OpenDocumentToAddSignaturePlaceholder"}
            />

            <WarningModal
                isOpen={Boolean(warningModalOpen)}
                style={customModalStyles}
                contentLabel={""}
                didClose={() => {
                    this.setState({ warningModalOpen: false })
                }}
                key={"WarningModal"}
            >
            </WarningModal>

            <AreYouSureModal
                isOpen={Boolean(isOpenAreYouSure)}
                style={customModalStyles}
                contentLabel={""}
                isOpenAreYouSure={isOpenAreYouSure ? isOpenAreYouSure : {}}
                didClose={() => {
                    this.setState({ isOpenAreYouSure: false })
                }}
                key={"AreYouSureModal"}
            ></AreYouSureModal>

            <Modal
                isOpen={Boolean(fillTemplateErrorsModalOpen)}
                style={customModalStyles}
                contentLabel={""}
                key={"fillTemplateErrorsModal"}
            >
                {this.fillTemplateErrorsRender(fillTemplateErrorsModalOpen)}
            </Modal>
            <Modal
                isOpen={Boolean(documentsAreNotValidModalOpen)}
                style={customModalStyles}
                contentLabel={""}
                key={"documentsAreNotValidModal"}
            >
                {this.warningModalDocumentsAreNotValidRender(documentsAreNotValidModalOpen)}
            </Modal>
            <Modal
                isOpen={Boolean(printNotValidModalOpen)}
                style={customModalStyles}
                contentLabel={""}
                key={"printNotValidModal"}
            >
                {this.printingAbortErrorsRender(printNotValidModalOpen)}
            </Modal>

            <Modal
                isOpen={Boolean(templateAttachmentDocumentsError)}
                style={customModalStyles}
                contentLabel={""}
                key={"templateAttachmentDocumentsError"}
            >
                {this.templateAttachmentDocumentsErrorRender(templateAttachmentDocumentsError)}
            </Modal>

            {!isOffice &&
                < AttachmentDialog
                    key={"attachmentDialogForDsWizard"}
                    cancelLabel={_("cancel")}
                    confirmationLabel={_("ok")}
                    onCancel={() => {
                        const { dispatch } = this.props
                        dispatch(hideEmailSenderAttachmentModal(false))
                    }}
                    onConfirmation={async (result0 = [], result1 = [], result2 = [], result3 = [], result4 = []) => {
                        const { dispatch } = this.props
                        //check oracle document changes except for documents originate from inbox
                        if (this.checkForOracleDocumentsChanges(result0, result1, result2, result3, result4)) {
                            dispatch(hideEmailSenderAttachmentModal(true))
                            this.setState({
                                isOpenAreYouSure: {
                                    title: _('areYouSureModalTitle'),
                                    message: _('areYouSureToUpdateDocumentsLists'),
                                    callBackCancel: () => { dispatch(this.openOracleDocumentsModal.bind(this)) },
                                    callBackOk: () => {
                                        this.handleConfirmSelectedAttachments(result0, result1, result2, result3, result4)
                                    }
                                }
                            })
                        } else {
                            this.handleConfirmSelectedAttachments(result0, result1, result2, result3, result4)
                            dispatch(hideEmailSenderAttachmentModal(true))
                        }
                    }}
                    moduleOptions={moduleOptions}
                    moduleKey={moduleKey}
                    isDsWizard={true}
                    ticketDocuments={ticketDocuments}
                    selected0={this.state.selectedClaimRelatedOraDocuments}
                    selected1={this.state.selectedContractRelatedOraDocuments}
                    selected2={this.state.selectedClientRelatedOraDocuments}
                    selected3={this.state.selectedTarificationRelatedOraDocuments}
                    selected4={this.state.selectedTicketRelatedOraDocuments}
                    selected5={this.state.emailAttachmentsTicketRelatedOraDocuments}
                />
            }
        </div>)
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/DSWizard.jsx